const villages = [
  {
    _id: { $oid: '6b6000010000000000000001' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Acheli'
  },
  {
    _id: { $oid: '6b6000010000000000000002' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Aranpur'
  },
  {
    _id: { $oid: '6b6000010000000000000003' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Mendpal'
  },
  {
    _id: { $oid: '6b6000010000000000000004' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Arbe'
  },
  {
    _id: { $oid: '6b6000010000000000000005' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Burgum'
  },
  {
    _id: { $oid: '6b6000010000000000000006' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Pujaripal'
  },
  {
    _id: { $oid: '6b6000010000000000000007' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Cholnar'
  },
  {
    _id: { $oid: '6b6000010000000000000008' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Gadhmiri'
  },
  {
    _id: { $oid: '6b6000010000000000000009' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Bade Hadmamunda'
  },
  {
    _id: { $oid: '6b600001000000000000000a' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Gongpal'
  },
  {
    _id: { $oid: '6b600001000000000000000b' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Aalnar'
  },
  {
    _id: { $oid: '6b600001000000000000000c' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Bengpal'
  },
  {
    _id: { $oid: '6b600001000000000000000d' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Bodepali'
  },
  {
    _id: { $oid: '6b600001000000000000000e' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Gumiyapal'
  },
  {
    _id: { $oid: '6b600001000000000000000f' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Halbaras'
  },
  {
    _id: { $oid: '6b6000010000000000000010' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Hiroli'
  },
  {
    _id: { $oid: '6b6000010000000000000011' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Lawa'
  },
  {
    _id: { $oid: '6b6000010000000000000012' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Pirnar'
  },
  {
    _id: { $oid: '6b6000010000000000000013' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Purangel'
  },
  {
    _id: { $oid: '6b6000010000000000000014' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Hitawar'
  },
  {
    _id: { $oid: '6b6000010000000000000015' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Jabeli'
  },
  {
    _id: { $oid: '6b6000010000000000000016' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Kadampal'
  },
  {
    _id: { $oid: '6b6000010000000000000017' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Kalepal'
  },
  {
    _id: { $oid: '6b6000010000000000000018' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Khutepal'
  },
  {
    _id: { $oid: '6b6000010000000000000019' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Kodenar'
  },
  {
    _id: { $oid: '6b600001000000000000001a' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Kutrem'
  },
  {
    _id: { $oid: '6b600001000000000000001b' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Kuakonda'
  },
  {
    _id: { $oid: '6b600001000000000000001c' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Madadi'
  },
  {
    _id: { $oid: '6b600001000000000000001d' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Perpa'
  },
  {
    _id: { $oid: '6b600001000000000000001e' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Doriras'
  },
  {
    _id: { $oid: '6b600001000000000000001f' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Lendra'
  },
  {
    _id: { $oid: '6b6000010000000000000020' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Mahrahaurnar'
  },
  {
    _id: { $oid: '6b6000010000000000000021' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Penta'
  },
  {
    _id: { $oid: '6b6000010000000000000022' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Mailawada'
  },
  {
    _id: { $oid: '6b6000010000000000000023' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Kakadi'
  },
  {
    _id: { $oid: '6b6000010000000000000024' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Muler'
  },
  {
    _id: { $oid: '6b6000010000000000000025' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Nahadi'
  },
  {
    _id: { $oid: '6b6000010000000000000026' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Nakulnar'
  },
  {
    _id: { $oid: '6b6000010000000000000027' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Nilawaya'
  },
  {
    _id: { $oid: '6b6000010000000000000028' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Palnar'
  },
  {
    _id: { $oid: '6b6000010000000000000029' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Fulpad'
  },
  {
    _id: { $oid: '6b600001000000000000002a' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Potali'
  },
  {
    _id: { $oid: '6b600001000000000000002b' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Renganar'
  },
  {
    _id: { $oid: '6b600001000000000000002c' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Barrem'
  },
  {
    _id: { $oid: '6b600001000000000000002d' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Rewali'
  },
  {
    _id: { $oid: '6b600001000000000000002e' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Madkamiras'
  },
  {
    _id: { $oid: '6b600001000000000000002f' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Samalwar'
  },
  {
    _id: { $oid: '6b6000010000000000000030' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Madenda'
  },
  {
    _id: { $oid: '6b6000010000000000000031' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Sameli'
  },
  {
    _id: { $oid: '6b6000010000000000000032' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Jimer'
  },
  {
    _id: { $oid: '6b6000010000000000000033' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Samgiri'
  },
  {
    _id: { $oid: '6b6000010000000000000034' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Pedka'
  },
  {
    _id: { $oid: '6b6000010000000000000035' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Taneli'
  },
  {
    _id: { $oid: '6b6000010000000000000036' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Kuwakonda',
    village: 'Tikanpal'
  },
  {
    _id: { $oid: '6a04806c4364e0da9730cafb' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Nagarkurnool',
    village: 'Bondalapally'
  },
  {
    _id: { $oid: '6a04806c6625c564cc21ea79' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Nagarkurnool',
    village: 'Venkatapur'
  },
  {
    _id: { $oid: '6a04806cf35114b1ab3e2327' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Nagarkurnool',
    village: 'Puljala'
  },
  {
    _id: { $oid: '6a04806c3b0992c6be8cbe5c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Nagarkurnool',
    village: 'Gudipally'
  },
  {
    _id: { $oid: '6a04806cfd24aaf03324f2e0' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Nagarkurnool',
    village: 'Aourasipally'
  },
  {
    _id: { $oid: '6a04806c6f08e541f9cdd34a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Nagarkurnool',
    village: 'Vanapatla'
  },
  {
    _id: { $oid: '6a04806cf6c562bfc72c638f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Nagarkurnool',
    village: 'Nagarkurnool'
  },
  {
    _id: { $oid: '6a04806c781dba93aa66e62a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Nagarkurnool',
    village: 'Peddapur'
  },
  {
    _id: { $oid: '6a04806c7bf801523bcdb1d4' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Nagarkurnool',
    village: 'Malkapur'
  },
  {
    _id: { $oid: '6a04806c272e88ce69e698e9' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Nagarkurnool',
    village: 'Yendabetla'
  },
  {
    _id: { $oid: '6a04806ccc188504fe8a4ab5' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Nagarkurnool',
    village: 'Desi Itikyala'
  },
  {
    _id: { $oid: '6a04806cae6119393a2526d5' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Nagarkurnool',
    village: 'Chandubatla'
  },
  {
    _id: { $oid: '6a04806c7c00b3d0ecf23954' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Nagarkurnool',
    village: 'Laxmapur'
  },
  {
    _id: { $oid: '6a04806c2fea7d7e3e10b1f9' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Nagarkurnool',
    village: 'Vallabhapalle'
  },

  {
    _id: { $oid: '6a048059e2034f8f420fbf55' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Tippapur'
  },
  {
    _id: { $oid: '6a048059c3d84cc6b9e4366f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Peddapur'
  },
  {
    _id: { $oid: '6a048059ba9089808e9bbd1b' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Koratikal'
  },
  {
    _id: { $oid: '6a0480599143bb4900830e3e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Kamsanipally'
  },
  {
    _id: { $oid: '6a0480591ff7ab1c98d7e90e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Marripally'
  },
  {
    _id: { $oid: '6a048059eaea00da6094ee24' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Upparipally'
  },
  {
    _id: { $oid: '6a04805967887fdb87736d00' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Veltoor'
  },
  {
    _id: { $oid: '6a0480592d68859aa855d203' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Molgara'
  },
  {
    _id: { $oid: '6a04805916b4ad265b7777ca' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Thirumalapoor'
  },
  {
    _id: { $oid: '6a04805997aa3bb4e4ee304f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Vigneshpoor'
  },
  {
    _id: { $oid: '6a0480595efc765bc1f2cef6' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Tadoor'
  },
  {
    _id: { $oid: '6a048059682b79eda57a2c18' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Japtisadagodu'
  },
  {
    _id: { $oid: '6a048059ef336a4372ac4871' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Lateefpur'
  },
  {
    _id: { $oid: '6a048059ab672e6de602b27e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Ayyavaripally'
  },
  {
    _id: { $oid: '6a048059124a30beeea57434' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Raiched'
  },
  {
    _id: { $oid: '6a04805953a0a35e7dacf780' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Laxmapur'
  },
  {
    _id: { $oid: '6a04805997324b71c5cc905d' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Piratvanipally'
  },
  {
    _id: { $oid: '6a04805985c7a9adb0581bdf' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Dasarlapally'
  },
  {
    _id: { $oid: '6a04805983d4596cb79f3907' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Rajanagar'
  },
  {
    _id: { $oid: '6a048059de6055d35b31da65' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Uppununtala'
  },
  {
    _id: { $oid: '6a048059bc7f9871d16a326b' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Mammillapally'
  },
  {
    _id: { $oid: '6a0480594c86e44274ae0dd2' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Penimilla'
  },
  {
    _id: { $oid: '6a048059cabb3fe4826d1678' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Toodukurthy'
  },
  {
    _id: { $oid: '6a048059886a6b804be21e83' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Narsaipally'
  },
  {
    _id: { $oid: '6a048059cfe26218a5740842' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Ganyagula'
  },
  {
    _id: { $oid: '6a048059681ed00446fa6716' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Bheemaram'
  },
  {
    _id: { $oid: '6a0480593dd7a62680b1fdf6' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Chandayapally'
  },
  {
    _id: { $oid: '6a0480590911ed68747613fb' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Kummera'
  },
  {
    _id: { $oid: '6a048059259fe2b1c6cded2d' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Uyyalawada'
  },
  {
    _id: { $oid: '6a048059de4ed479f356f9d6' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Gaggalapally'
  },
  {
    _id: { $oid: '6a048059d1ff05f80f70ac5b' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Manthati'
  },
  {
    _id: { $oid: '6a0480595884950b54fd7c05' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Sripuram'
  },
  {
    _id: { $oid: '6a0480595947a7ca1b9d8ef7' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Peddamuddunur'
  },
  {
    _id: { $oid: '6a048059eb076552e429ac28' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Nallavelly'
  },
  {
    _id: { $oid: '6a0480594e209c81e5f0349f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Naganool'
  },
  {
    _id: { $oid: '6a048059234bcb119e7af4b0' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Uppununthala',
    village: 'Bandapally'
  },

  {
    _id: { $oid: '6a047f19def685bcda66304e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Achampet'
  },
  {
    _id: { $oid: '6a047f19e763afc68313d97b' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Tangapur'
  },
  {
    _id: { $oid: '6a047f19c5b817422cd032d4' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Nadimpally'
  },
  {
    _id: { $oid: '6a047f1968dd1103069c0e85' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Bramhanpally'
  },
  {
    _id: { $oid: '6a047f19885bcfcb7c8255e4' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Lingotam'
  },
  {
    _id: { $oid: '6a047f19a97fc8ba71b55748' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Palkapally'
  },
  {
    _id: { $oid: '6a047f1921ff33f28d7defb9' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Chandapur'
  },
  {
    _id: { $oid: '6a047f19ab491e0eab2f9719' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Inole'
  },
  {
    _id: { $oid: '6a047f19af74995d1f17aa36' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Siddapur'
  },
  {
    _id: { $oid: '6a047f1976a47f8d94dd03fa' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Gumpampally'
  },
  {
    _id: { $oid: '6a047f199d8e80ff3b7c5a64' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Bommanpally'
  },
  {
    _id: { $oid: '6a047f194caae9d4354aba85' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Rangapur'
  },
  {
    _id: { $oid: '6a047f19e0ef8131f765ea44' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Akkavaram'
  },
  {
    _id: { $oid: '6a047f19d9f8ab9cf46b5bb4' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Chennaram'
  },
  {
    _id: { $oid: '6a047f1947dc7cd4c29ecce1' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Singaram'
  },
  {
    _id: { $oid: '6a047f19dab32abf18cffa01' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Hajipur'
  },
  {
    _id: { $oid: '6a047f195abd2731a999d9d7' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Pulijala'
  },
  {
    _id: { $oid: '6a047f19b0b1988673703ed4' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Choutapally'
  },
  {
    _id: { $oid: '6a047f1a7f76077875ffe0f3' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Ghanapur'
  },
  {
    _id: { $oid: '6a047f1ac478759dbd2a2c18' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Mannevaripally'
  },
  {
    _id: { $oid: '6a047f1a041a56fa8ec6206f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Bolgatpally'
  },
  {
    _id: { $oid: '6a047f1a8c78740cff779dfa' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Achampet',
    village: 'Laxmapur'
  },

  {
    _id: { $oid: '6a047ede04ef731513d986b5' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Urkonda',
    village: 'Jaknalapally'
  },
  {
    _id: { $oid: '6a047edec87323bd0ff7eda8' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Urkonda',
    village: 'Jagboyanapally'
  },
  {
    _id: { $oid: '6a047ede67705d4165f0f61a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Urkonda',
    village: 'Ippapahad'
  },
  {
    _id: { $oid: '6a047ede381676744e9dea26' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Urkonda',
    village: 'Urkonda'
  },
  {
    _id: { $oid: '6a047ede827843e9bdcb80e1' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Urkonda',
    village: 'Ramreddypally'
  },
  {
    _id: { $oid: '6a047ede2242f83bfca946c5' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Urkonda',
    village: 'Bommarajupally'
  },
  {
    _id: { $oid: '6a047ede0fa381a237e8d789' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Urkonda',
    village: 'Rachalapally'
  },
  {
    _id: { $oid: '6a047ede9f13a94ec518b2db' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Urkonda',
    village: 'Madaram'
  },
  {
    _id: { $oid: '6a047ede97bf739a18d49694' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Urkonda',
    village: 'Revally'
  },
  {
    _id: { $oid: '6a047edef919a4eb9aa6a6f6' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Urkonda',
    village: 'Gudiganpally'
  },
  {
    _id: { $oid: '6a047ede9e7e3dfa8fa52516' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Urkonda',
    village: 'Narsampally'
  },
  {
    _id: { $oid: '6a047ede16410e0f7d979fc8' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Urkonda',
    village: 'Urkondapeta'
  },

  {
    _id: { $oid: '6a047ec8eb7fa917a7119590' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Mittasadagodu'
  },
  {
    _id: { $oid: '6a047ec81c448ca0b02fc216' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Vangoor'
  },
  {
    _id: { $oid: '6a047ec860f89b98c7f1582d' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Gajara'
  },
  {
    _id: { $oid: '6a047ec81d2e9174d5af921e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Ulpara'
  },
  {
    _id: { $oid: '6a047ec82521a5db6533ad2b' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Dindi chinthalapally'
  },
  {
    _id: { $oid: '6a047ec8dc8e8538505c15d3' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Uppalapahad'
  },
  {
    _id: { $oid: '6a047ec81276fd3dc1562306' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Konetipur'
  },
  {
    _id: { $oid: '6a047ec8f0cad44653aad0c4' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Thippareddypally'
  },
  {
    _id: { $oid: '6a047ec8863e9a4ae736da64' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Venkatapur'
  },
  {
    _id: { $oid: '6a047ec8790f3a2f3c322d43' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Annaram'
  },
  {
    _id: { $oid: '6a047ec88aa3019e644dcda5' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Rangapur'
  },
  {
    _id: { $oid: '6a047ec830b119bcee4f1f74' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Kondareddypally'
  },
  {
    _id: { $oid: '6a047ec8bbc42ac9f23aed4e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Thirumalagiri'
  },
  {
    _id: { $oid: '6a047ec84d711e089319bc58' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Polkampally'
  },
  {
    _id: { $oid: '6a047ec86bdf476b25b4e7ba' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Nijamabad'
  },
  {
    _id: { $oid: '6a047ec80a83ca8959a644ec' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Pothireddypally'
  },
  {
    _id: { $oid: '6a047ec8753c244bc9f2f3ca' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Sarwareddypally'
  },
  {
    _id: { $oid: '6a047ec8592265cb87cfe42d' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Jajala'
  },
  {
    _id: { $oid: '6a047ec8bd9768c62d8dba2f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Vangoor',
    village: 'Umapur'
  },

  {
    _id: { $oid: '6a047eb766140d4b5365ac76' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Charakonda',
    village: 'Charakonda'
  },
  {
    _id: { $oid: '6a047eb757193ec4ff8b97f6' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Charakonda',
    village: 'Gokaram'
  },
  {
    _id: { $oid: '6a047eb7dc865ce71a579c72' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Charakonda',
    village: 'Kamalapur'
  },
  {
    _id: { $oid: '6a047eb7d836ca3c7216d360' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Charakonda',
    village: 'Jupally'
  },
  {
    _id: { $oid: '6a047eb774b54fbcf3ddb5ea' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Charakonda',
    village: 'Sirsanagandla'
  },
  {
    _id: { $oid: '6a047eb7127a512a4e21995e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Charakonda',
    village: 'Sheriappareddypally'
  },
  {
    _id: { $oid: '6a047eb758bfe2094e9b46af' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Charakonda',
    village: 'Thimmaipally'
  },

  {
    _id: { $oid: '6a047ea650508fe1ee8d8c4d' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Veldanda',
    village: 'Karrevanipally'
  },
  {
    _id: { $oid: '6a047ea674f9839359316d86' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Veldanda',
    village: 'Kuppagandla'
  },
  {
    _id: { $oid: '6a047ea6910a1d78d57c2c39' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Veldanda',
    village: 'Lingareddipally'
  },
  {
    _id: { $oid: '6a047ea6384d18f865634710' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Veldanda',
    village: 'Konetiwada'
  },
  {
    _id: { $oid: '6a047ea631d04ed99d173792' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Veldanda',
    village: 'Cherkur'
  },
  {
    _id: { $oid: '6a047ea6465ee1d433ecc1d1' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Veldanda',
    village: 'Peddapur'
  },
  {
    _id: { $oid: '6a047ea64d104270dcbce543' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Veldanda',
    village: 'Cheduruvally'
  },
  {
    _id: { $oid: '6a047ea6289f0772a3a2c2ae' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Veldanda',
    village: 'Bhairapur'
  },
  {
    _id: { $oid: '6a047ea6efadf0c835ed96f3' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Veldanda',
    village: 'Pothepally'
  },
  {
    _id: { $oid: '6a047ea6c8250e24fcfcc001' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Veldanda',
    village: 'Kotra'
  },
  {
    _id: { $oid: '6a047ea6388b721825e0b5c3' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Veldanda',
    village: 'Gundala'
  },
  {
    _id: { $oid: '6a047ea6d0cc059a1f5e9dd4' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Veldanda',
    village: 'Yerravalli'
  },
  {
    _id: { $oid: '6a047ea61b7297a974dbfee1' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Veldanda',
    village: 'Rachur'
  },
  {
    _id: { $oid: '6a047ea6a5d4df9471ab9340' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Veldanda',
    village: 'Ajilapur'
  },
  {
    _id: { $oid: '6a047ea695cbb282bf4f1eb5' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Veldanda',
    village: 'Veldanda'
  },
  {
    _id: { $oid: '6a047ea6f0a595b3db88cd27' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Veldanda',
    village: 'Bollampally'
  },

  {
    _id: { $oid: '6a047e93cf8e1e2350e46a94' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Bekkera'
  },
  {
    _id: { $oid: '6a047e93de3bcc8118a59f2c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Kurmidda'
  },
  {
    _id: { $oid: '6a047e935008b32ce4813357' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Marchala'
  },
  {
    _id: { $oid: '6a047e93faf1069b90018d1c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Panjugula'
  },
  {
    _id: { $oid: '6a047e93f9f213259e9c4dee' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Yellikal'
  },
  {
    _id: { $oid: '6a047e93682f381e7e217710' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Gundur'
  },
  {
    _id: { $oid: '6a047e93ff0583d16da3e1d8' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Lingasanipally'
  },
  {
    _id: { $oid: '6a047e937b55d5d38bb9b53a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Raghupathipet'
  },
  {
    _id: { $oid: '6a047e932c4c75b9ad7d2614' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Mokurala'
  },
  {
    _id: { $oid: '6a047e93aeaa685e15bbee2c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Venkatapur pattimolgara'
  },
  {
    _id: { $oid: '6a047e93185d03469d529520' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Vepur'
  },
  {
    _id: { $oid: '6a047e935e1011b59b50d4af' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Yellikatta'
  },
  {
    _id: { $oid: '6a047e932df5a9d1c3db62ea' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Jeedipally'
  },
  {
    _id: { $oid: '6a047e9308835dcde79f3658' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Kalwakurthy'
  },
  {
    _id: { $oid: '6a047e937c22bf261f49b309' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Tharnikal'
  },
  {
    _id: { $oid: '6a047e937f6078372ca68898' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Thandra'
  },
  {
    _id: { $oid: '6a047e935459ac0e23c994b6' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Jillela'
  },
  {
    _id: { $oid: '6a047e933271d68b7123d2c0' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Suddakal'
  },
  {
    _id: { $oid: '6a047e938a65ad9133f41391' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kalwakurthy',
    village: 'Thotapally'
  },

  {
    _id: { $oid: '6a047e73b0c25fa503429c32' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Pentlavelli',
    village: 'Kondur'
  },
  {
    _id: { $oid: '6a047e73cbaa74ef6469a958' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Pentlavelli',
    village: 'Gopalapuram'
  },
  {
    _id: { $oid: '6a047e739ef1e0613bc3d382' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Pentlavelli',
    village: 'Jetprol'
  },
  {
    _id: { $oid: '6a047e7334378b2126667652' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Pentlavelli',
    village: 'Pentlavelly'
  },
  {
    _id: { $oid: '6a047e73fe12add74b4bf126' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Pentlavelli',
    village: 'Manchalakataa'
  },
  {
    _id: { $oid: '6a047e730232b76e1467feba' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Pentlavelli',
    village: 'Singavaram'
  },
  {
    _id: { $oid: '6a047e735a6f2e983c2aaee4' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Pentlavelli',
    village: 'Vemukal'
  },
  {
    _id: { $oid: '6a047e73c778c741aef46eaa' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Pentlavelli',
    village: 'Malleshwaram'
  },

  {
    _id: { $oid: '6a047e25e40cc4250cfc0788' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kodair',
    village: 'Janumpally'
  },
  {
    _id: { $oid: '6a047e258d80aeca55845da9' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kodair',
    village: 'Kodair'
  },
  {
    _id: { $oid: '6a047e258b8c64a657979f12' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kodair',
    village: 'Paspula'
  },
  {
    _id: { $oid: '6a047e250f1effa509ddcca2' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kodair',
    village: 'Nagulapally'
  },
  {
    _id: { $oid: '6a047e253ba67a7a2d7bd03d' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kodair',
    village: 'Rajapur'
  },
  {
    _id: { $oid: '6a047e254973e6bf818625ca' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kodair',
    village: 'Mylaram'
  },
  {
    _id: { $oid: '6a047e25bc644ee8e3160bbd' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kodair',
    village: 'Badugadinne'
  },
  {
    _id: { $oid: '6a047e25ea5b0969308aa873' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kodair',
    village: 'Narsaipally'
  },
  {
    _id: { $oid: '6a047e2503e08bb2c8fc9ff6' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kodair',
    village: 'Yetham'
  },
  {
    _id: { $oid: '6a047e25c7e67e19bc1cd765' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kodair',
    village: 'Kondraopally'
  },
  {
    _id: { $oid: '6a047e258792dbf80e98aa6a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kodair',
    village: 'Teegalapally'
  },
  {
    _id: { $oid: '6a047e250e1d510ea9cd8751' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kodair',
    village: 'Khanapur'
  },
  {
    _id: { $oid: '6a047e25fa8e8ab989249bb4' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kodair',
    village: 'Bavaipally'
  },

  {
    _id: { $oid: '6a047dd11eacb191c8b63e69' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Appajipally'
  },
  {
    _id: { $oid: '6a047dd106fc3ba184178294' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Yedirepally'
  },
  {
    _id: { $oid: '6a047dd125be2f4e8ccf4e5a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Koduparthy'
  },
  {
    _id: { $oid: '6a047dd14bf59bc4f4d4dc66' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Gummakonda'
  },
  {
    _id: { $oid: '6a047dd18dc184651fd408cd' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Bajipuram'
  },
  {
    _id: { $oid: '6a047dd160999de43408c896' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Gorita'
  },
  {
    _id: { $oid: '6a047dd1a34211ef09e3a13d' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Bawajipally'
  },
  {
    _id: { $oid: '6a047dd1feaeaca7c0aa5a6f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Avancha'
  },
  {
    _id: { $oid: '6a047dd17612ba8f84ce7c64' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Buddasamudram'
  },
  {
    _id: { $oid: '6a047dd1c3538a6225c728c4' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Marepally'
  },
  {
    _id: { $oid: '6a047dd17c364534bc7525ca' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Thimmajipet'
  },
  {
    _id: { $oid: '6a047dd1f8d0a870df0b8336' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Chegunta'
  },
  {
    _id: { $oid: '6a047dd1ee3b2b9295c5eb49' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Allampally'
  },
  {
    _id: { $oid: '6a047dd16b7d482097d4d0d2' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Nerellapally'
  },
  {
    _id: { $oid: '6a047dd1051b65f3c85b8eb4' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Pothireddypally'
  },
  {
    _id: { $oid: '6a047dd18e693885afdb77d3' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Pullagiri'
  },
  {
    _id: { $oid: '6a047dd1a00c8f02233ed859' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Marikal'
  },
  {
    _id: { $oid: '6a047dd1f92f48f349a98b27' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Ippalapally'
  },
  {
    _id: { $oid: '6a047dd1cfc762fd8db9fe17' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Thimmajipet',
    village: 'Thirumalagiri'
  },

  {
    _id: { $oid: '6a047db62618af3545844b17' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Jamisthapur'
  },
  {
    _id: { $oid: '6a047db613a6c8e0e84f5d7b' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Gouthampally'
  },
  {
    _id: { $oid: '6a047db60dc9ffec34a759a2' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Ananthasagar'
  },
  {
    _id: { $oid: '6a047db671e6329091aceda9' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Alair'
  },
  {
    _id: { $oid: '6a047db6b96ad0b184ccfd57' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Karvanga'
  },
  {
    _id: { $oid: '6a047db6a95f012921200819' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Rakonda'
  },
  {
    _id: { $oid: '6a047db638671d5fcb58bda3' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Lakhnaram'
  },
  {
    _id: { $oid: '6a047db6b093a08693fbb3cf' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Peddur'
  },
  {
    _id: { $oid: '6a047db6ef29af97fd9e6f01' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Nadigadda'
  },
  {
    _id: { $oid: '6a047db6ed34dbfe1bbb9c16' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Telkapally'
  },
  {
    _id: { $oid: '6a047db62b4517bb69b0ccb2' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Gattunellikuduru'
  },
  {
    _id: { $oid: '6a047db6b2944de0930c768f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Parvathapur'
  },
  {
    _id: { $oid: '6a047db676edaeaeb95bb4b8' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Raipakula'
  },
  {
    _id: { $oid: '6a047db685b82893bd901302' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Gaddampally'
  },
  {
    _id: { $oid: '6a047db66bae8aa619b3f79f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Boppally'
  },
  {
    _id: { $oid: '6a047db612475ec07dfbb0eb' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Chinnamuddunur'
  },
  {
    _id: { $oid: '6a047db67e2ed2223d12207d' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Peddapally'
  },
  {
    _id: { $oid: '6a047db617516ca82d9a340f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Vattipally'
  },
  {
    _id: { $oid: '6a047db6e7bea3baa1ff4ad7' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Gouraram'
  },
  {
    _id: { $oid: '6a047db67c0d647435846bd0' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Telkapally',
    village: 'Bandapally'
  },

  {
    _id: { $oid: '6a047da3dc2c66a86573b93d' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Bhalanpally'
  },
  {
    _id: { $oid: '6a047da3163c8d5ea17ebfa3' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Tadoor'
  },
  {
    _id: { $oid: '6a047da381fe1e6c88bc1d4f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Yethmathapur'
  },
  {
    _id: { $oid: '6a047da335077078dca5b8c1' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Thummalsugur'
  },
  {
    _id: { $oid: '6a047da3adaea087675c5a2c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Sirsawada'
  },
  {
    _id: { $oid: '6a047da301bc03963ae9feb7' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Ithole'
  },
  {
    _id: { $oid: '6a047da3dd5775cbe8ceb01d' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Indrakal'
  },
  {
    _id: { $oid: '6a047da3c3549dec01c2a254' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Polmoor'
  },
  {
    _id: { $oid: '6a047da399bbeeb500922931' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Medipur'
  },
  {
    _id: { $oid: '6a047da328fa13637fe8c6ae' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Parvathaipally'
  },
  {
    _id: { $oid: '6a047da30d4580b400100ae5' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Nagdevpally'
  },
  {
    _id: { $oid: '6a047da31e9f3827bc90bb43' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Yengampally'
  },
  {
    _id: { $oid: '6a047da3522725df91af46fd' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Akunellikuduru'
  },
  {
    _id: { $oid: '6a047da34d27cd1d26f151f4' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Gunthakodur'
  },
  {
    _id: { $oid: '6a047da34846fa4670231a3c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Antharam'
  },
  {
    _id: { $oid: '6a047da3eb80dfa6fbdc2ac0' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Allapur'
  },
  {
    _id: { $oid: '6a047da3511da4820161d957' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Yetdharpally'
  },
  {
    _id: { $oid: '6a047da38c824fb9ff3c4ee4' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Govindaipally'
  },
  {
    _id: { $oid: '6a047da314669acf9b14aee0' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Papgal'
  },
  {
    _id: { $oid: '6a047da32bdb6749758f578a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Yadireddipally'
  },
  {
    _id: { $oid: '6a047da310ab9a9dba826fbe' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Thirumalapoor'
  },
  {
    _id: { $oid: '6a047da3ee78be877264fe4c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Tadoor',
    village: 'Charla Itikyala'
  },

  {
    _id: { $oid: '6a047d0ddf20d0024ac3686b' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Bacharam'
  },
  {
    _id: { $oid: '6a047d0d1b15ad1de440f96a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Bhavanamapally'
  },
  {
    _id: { $oid: '6a047d0d80bb86ff35cab6a2' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Deval Thirumalapur'
  },
  {
    _id: { $oid: '6a047d0d9c84105346fbaddf' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Vennacharla'
  },
  {
    _id: { $oid: '6a047d0d86a828b9f5d8dc6a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Dedinenipally'
  },
  {
    _id: { $oid: '6a047d0d644f822e38ae3552' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Chinnakarpamula'
  },
  {
    _id: { $oid: '6a047d0d8be333ad85072e6c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Jonnalaboguda'
  },
  {
    _id: { $oid: '6a047d0d47484093979a9eab' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Gantraopally'
  },
  {
    _id: { $oid: '6a047d0d39d5f3d1d0cf84fc' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Gorremadugu'
  },
  {
    _id: { $oid: '6a047d0d2fe96d8d024991fa' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Pochapur'
  },
  {
    _id: { $oid: '6a047d0d1eb798660ad0b82c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Sathapur'
  },
  {
    _id: { $oid: '6a047d0d45a3eea35e363e22' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Narayanapally'
  },
  {
    _id: { $oid: '6a047d0d3521065dd5a6077c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Chennapuraopally'
  },
  {
    _id: { $oid: '6a047d0d25ce358ab55f3089' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Kalwakole'
  },
  {
    _id: { $oid: '6a047d0dc5510caa814f5be2' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Pedda Kothapally'
  },
  {
    _id: { $oid: '6a047d0d99b359ba21f3d671' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Pedda Karpamula'
  },
  {
    _id: { $oid: '6a047d0d529a25d5f35860ff' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Yapatla'
  },
  {
    _id: { $oid: '6a047d0d2d224719cadf3228' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Maredumandinne'
  },
  {
    _id: { $oid: '6a047d0d274d3781044405d3' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Kothapet'
  },
  {
    _id: { $oid: '6a047d0d9f405177ddf6148d' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Adirala'
  },
  {
    _id: { $oid: '6a047d0df7be7f695f7558ea' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Vedukaraopally'
  },
  {
    _id: { $oid: '6a047d0d6d0ad98b10645e44' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Mustipally'
  },
  {
    _id: { $oid: '6a047d0d851d81f073f351cc' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Thirumalampally'
  },
  {
    _id: { $oid: '6a047d0dbe6d28909b8412ab' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Chandrakal'
  },
  {
    _id: { $oid: '6a047d0dfbb35fbb9ae221f5' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Marikal'
  },
  {
    _id: { $oid: '6a047d0d3479d0aa1bee596a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Peddakothapally',
    village: 'Mahasamudram'
  },

  {
    _id: { $oid: '6a047c55bbf9e8db077781f1' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Polepally'
  },
  {
    _id: { $oid: '6a047c550ae1a76c841b3d12' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Mahadevunipeta'
  },
  {
    _id: { $oid: '6a047c551b9e3f2a86baca31' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Mammaipally'
  },
  {
    _id: { $oid: '6a047c556050adfa158b79e6' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Lingasanipally'
  },
  {
    _id: { $oid: '6a047c558f7107f4c80b44a5' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Palem'
  },
  {
    _id: { $oid: '6a047c55e6fba142b7925932' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Boyapuram'
  },
  {
    _id: { $oid: '6a047c55abd48bf444be0eb1' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Venkatapur'
  },
  {
    _id: { $oid: '6a047c55de95c2633713a75a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Manganoor'
  },
  {
    _id: { $oid: '6a047c559b5b0ee5ecbe0881' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Bijinapally'
  },
  {
    _id: { $oid: '6a047c5582e37fe9a083c39d' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Salkarpet'
  },
  {
    _id: { $oid: '6a047c558b774f5157f294f7' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Dharmapur'
  },
  {
    _id: { $oid: '6a047c552444f7f1e6eabd29' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Karukonda'
  },
  {
    _id: { $oid: '6a047c55868e7487b2daa3a4' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Gudlanarva'
  },
  {
    _id: { $oid: '6a047c5572b4d68d93620ea5' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Khanapur'
  },
  {
    _id: { $oid: '6a047c55f294d0251a0a46f7' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Shainpally'
  },
  {
    _id: { $oid: '6a047c55e35a1c1609086fe0' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Vattem'
  },
  {
    _id: { $oid: '6a047c557ae74b207ead7a1a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Lattupally'
  },
  {
    _id: { $oid: '6a047c556960f6d919a1341c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Waddeman'
  },
  {
    _id: { $oid: '6a047c551ff3c2def5bc3de6' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Velgonda'
  },
  {
    _id: { $oid: '6a047c557d09f52e85a1a619' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Gouraram'
  },
  {
    _id: { $oid: '6a047c55cf3a5e6e906a0fb5' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Anekhanpally'
  },
  {
    _id: { $oid: '6a047c559b3a89888d5b5b0b' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Vasanthapur'
  },
  {
    _id: { $oid: '6a047c5532d83849c667a0f3' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Gangaram'
  },
  {
    _id: { $oid: '6a047c55d9621e5a90e8151f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Bijinapally',
    village: 'Alipur'
  },

  {
    _id: { $oid: '6a047b28154a3559dabe1899' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Bambara'
  },
  {
    _id: { $oid: '6a047b28a7ae7ed0bad3358e' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Bendera'
  },
  {
    _id: { $oid: '6a047b289b02490ce5f75787' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Chichupally'
  },
  {
    _id: { $oid: '6a047b288d790de6264eda9d' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Chowpanguda'
  },
  {
    _id: { $oid: '6a047b283489bb3feae2a1ef' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Dabha'
  },
  {
    _id: { $oid: '6a047b28520ba1180b8e9766' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Doddiguda'
  },
  {
    _id: { $oid: '6a047b28278fb8fbc8a243c8' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Goyagaon'
  },
  {
    _id: { $oid: '6a047b28a081389e8f15fdcd' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Indhani'
  },
  {
    _id: { $oid: '6a047b28ebb3458712070ced' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Jaithpur'
  },
  {
    _id: { $oid: '6a047b286143eb310524a2ec' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Jambuldhari'
  },
  {
    _id: { $oid: '6a047b28462076445d9d443c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Kanneragaon'
  },
  {
    _id: { $oid: '6a047b28de1f878a53b32ba0' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Khamana'
  },
  {
    _id: { $oid: '6a047b28996f242849b81906' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Khirdi'
  },
  {
    _id: { $oid: '6a047b28b939bed397fc5ece' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Komatiguda'
  },
  {
    _id: { $oid: '6a047b28537a40fbdc931a2f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Laxmipur'
  },
  {
    _id: { $oid: '6a047b284ee1ed8171eef3c6' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Lendiguda'
  },
  {
    _id: { $oid: '6a047b28dcd5d5c64703f9d4' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Navedhari'
  },
  {
    _id: { $oid: '6a047b28671679f9c80541cf' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Navegaon'
  },
  {
    _id: { $oid: '6a047b28c6cf6ad2385d806c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Naveguda'
  },
  {
    _id: { $oid: '6a047b288022f2fcb510181a' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Pataguda'
  },
  {
    _id: { $oid: '6a047b2825ddf6213fadfd5e' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Pippergonadi'
  },
  {
    _id: { $oid: '6a047b28492776a656ba5e40' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Samela'
  },
  {
    _id: { $oid: '6a047b28db87bd87c4177e91' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Sarandi'
  },
  {
    _id: { $oid: '6a047b2844ab1ab6aea8505b' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Sawathi'
  },
  {
    _id: { $oid: '6a047b283381a7b29d9efc00' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Sonapur'
  },
  {
    _id: { $oid: '6a047b28f08de8bc75f27c31' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Tejapur'
  },
  {
    _id: { $oid: '6a047b28908e282b3b2fe3bc' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Velgi'
  },
  {
    _id: { $oid: '6a047b28004c4b5764e1babe' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Wankidi',
    village: 'Wankidi Kalan'
  },

  {
    _id: { $oid: '6a047af45be43c2f67f15cb1' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Bheemjiguda'
  },
  {
    _id: { $oid: '6a047af4ade28323b4e45afd' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Chintapally'
  },
  {
    _id: { $oid: '6a047af4f558dfd7e6fda54d' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Devaiguda'
  },
  {
    _id: { $oid: '6a047af44ed412bab915bc21' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Edulapahad'
  },
  {
    _id: { $oid: '6a047af45308c949943c46fb' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Gambiraopet'
  },
  {
    _id: { $oid: '6a047af4b1b6fcecadab5f0f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Ginnedari'
  },
  {
    _id: { $oid: '6a047af499d2570bfdcd9592' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Godelpalle'
  },
  {
    _id: { $oid: '6a047af4c63895435a726ac2' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Goperanaguguda'
  },
  {
    _id: { $oid: '6a047af4633983fe17eb205d' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Govena'
  },
  {
    _id: { $oid: '6a047af4bf4da996f02260b0' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Goyagoan'
  },
  {
    _id: { $oid: '6a047af40473c496fc15f20f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Gudipet'
  },
  {
    _id: { $oid: '6a047af4dcfd50481ce72878' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Kannepalle'
  },
  {
    _id: { $oid: '6a047af4693ff351a67f99a6' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Khariguda'
  },
  {
    _id: { $oid: '6a047af4f1cc327c2e73cef3' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Koutagam'
  },
  {
    _id: { $oid: '6a047af422a64dfa2bd7c64d' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Mandaguda'
  },
  {
    _id: { $oid: '6a047af4ecab2bca941f0ca6' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Mangi'
  },
  {
    _id: { $oid: '6a047af441311872cf38c833' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Manikyapur'
  },
  {
    _id: { $oid: '6a047af432f6a779a20beabe' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Markaguda'
  },
  {
    _id: { $oid: '6a047af4759357cad3a1bc07' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Mesramguda'
  },
  {
    _id: { $oid: '6a047af489340c5dd111cd16' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Morriguda'
  },
  {
    _id: { $oid: '6a047af4841eabb7ae8d0df6' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Mulkalamanda'
  },
  {
    _id: { $oid: '6a047af456f19ef8111b79d2' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Nayakapuguda'
  },
  {
    _id: { $oid: '6a047af4432d26095eddd219' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Pangidi Madra'
  },
  {
    _id: { $oid: '6a047af4bc17f943c244c640' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Rajaguda'
  },
  {
    _id: { $oid: '6a047af4995b81cd4b0f4e1f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Rompalle'
  },
  {
    _id: { $oid: '6a047af466b65f6958e832ea' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Sungapur'
  },
  {
    _id: { $oid: '6a047af46dd9d6a6415426e8' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Thalandi'
  },
  {
    _id: { $oid: '6a047af47f2d98a6dc30afc3' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Tiryani'
  },
  {
    _id: { $oid: '6a047af474c635afb41e5639' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Tiryani',
    village: 'Ullipitadorli'
  },

  {
    _id: { $oid: '6a047adef9942deb99b021f3' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur U',
    village: 'Babjipet'
  },
  {
    _id: { $oid: '6a047adef9623d31c5dc1149' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur U',
    village: 'Bandair'
  },
  {
    _id: { $oid: '6a047ade9e67c945c8cef726' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur U',
    village: 'Burnoor-B'
  },
  {
    _id: { $oid: '6a047adeda1bf31884a5cf2c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur U',
    village: 'Dhanora-P'
  },
  {
    _id: { $oid: '6a047ade54c41c14a8ef72f0' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur U',
    village: 'Kohinoor-B'
  },
  {
    _id: { $oid: '6a047adeac8a4ea03d2d7272' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur U',
    village: 'Mahagaon'
  },
  {
    _id: { $oid: '6a047ade75454bc98254e393' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur U',
    village: 'Netnoor'
  },
  {
    _id: { $oid: '6a047ade6cd433375137c17f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur U',
    village: 'Pamulawada'
  },
  {
    _id: { $oid: '6a047adef5b7798ff20d12ac' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur U',
    village: 'Pangidi'
  },
  {
    _id: { $oid: '6a047ade42ce908a723e9d85' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur U',
    village: 'Phullara'
  },
  {
    _id: { $oid: '6a047adeed7423baef92ace0' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur U',
    village: 'Powarguda'
  },
  {
    _id: { $oid: '6a047ade4e627498285b0513' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur U',
    village: 'Raghapur'
  },
  {
    _id: { $oid: '6a047ade61c4b20f67fc4a5c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur U',
    village: 'Seethagondi'
  },
  {
    _id: { $oid: '6a047ade5d160eb6300d9615' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur U',
    village: 'Shettihadapnur'
  },
  {
    _id: { $oid: '6a047ade6b4bae0ca4ce07fe' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur U',
    village: 'Sirpur (U)'
  },

  {
    _id: { $oid: '6a047acaaae4ebaa4830dc52' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Achelly'
  },
  {
    _id: { $oid: '6a047aca0362bfc3c0211116' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Bhupalapatnam'
  },
  {
    _id: { $oid: '6a047acaca6f9211334eba71' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Cheelapalle'
  },
  {
    _id: { $oid: '6a047aca3e9edd8f8d45c900' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Chintakunta'
  },
  {
    _id: { $oid: '6a047aca23a485205bf0fde9' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Dabba'
  },
  {
    _id: { $oid: '6a047aca745388174e9d76c2' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Dhorpalle'
  },
  {
    _id: { $oid: '6a047aca5c60fecc5dc18e9e' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Hudkili'
  },
  {
    _id: { $oid: '6a047aca720db6e6335e7038' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Itikyalapahad'
  },
  {
    _id: { $oid: '6a047acaf0cd2f62c5a6a60b' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Karjepally'
  },
  {
    _id: { $oid: '6a047aca0354ac6c20799dcc' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Laxmipur'
  },
  {
    _id: { $oid: '6a047acab547972c5bab259c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Loanvelli'
  },
  {
    _id: { $oid: '6a047aca1fa087e2491e6819' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Medipally'
  },
  {
    _id: { $oid: '6a047aca152ace879e61d384' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Navegoan'
  },
  {
    _id: { $oid: '6a047aca5f04d3a88013c882' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Parigaon'
  },
  {
    _id: { $oid: '6a047acabf014ebf8da29b64' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Sirpur(T)'
  },
  {
    _id: { $oid: '6a047aca7725928ae739363a' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Vempalle'
  },
  {
    _id: { $oid: '6a047aca229f77647c733573' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Sirpur (T)',
    village: 'Venkatraopet'
  },

  {
    _id: { $oid: '6a047aba01ed5686a8af6b5a' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Dharmaram'
  },
  {
    _id: { $oid: '6a047abad44412f9af2fdba6' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Gangapur'
  },
  {
    _id: { $oid: '6a047aba230718b0e23f54db' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Golleti'
  },
  {
    _id: { $oid: '6a047aba377c89ec6817f57a' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Indranagar'
  },
  {
    _id: { $oid: '6a047aba44c4c437abc0670d' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Jakkulapally'
  },
  {
    _id: { $oid: '6a047aba71b82b3d4ff41f2a' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Khairgaon'
  },
  {
    _id: { $oid: '6a047abae64a61af6bc08d84' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Khairguda'
  },
  {
    _id: { $oid: '6a047abaff8b6ce3454779a1' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Kistapur'
  },
  {
    _id: { $oid: '6a047aba7e647f880acf9863' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Komuravelly'
  },
  {
    _id: { $oid: '6a047abaa9abb5b90909f154' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Kondapalle'
  },
  {
    _id: { $oid: '6a047abad01a20e0f9880240' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Laxmipur'
  },
  {
    _id: { $oid: '6a047aba4b0a28c4c70e22ea' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Madavaiguda'
  },
  {
    _id: { $oid: '6a047abac285009cf6bc7de5' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Nambal'
  },
  {
    _id: { $oid: '6a047abafbb0ef9e7f7d6ce4' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Narayanpur'
  },
  {
    _id: { $oid: '6a047abae22edcccf29baede' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Navegaon'
  },
  {
    _id: { $oid: '6a047aba9aa7df1384e937d9' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Pasigaon'
  },
  {
    _id: { $oid: '6a047aba5b89a48bcfe44420' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Pulikunta'
  },
  {
    _id: { $oid: '6a047ababe22325338638693' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Rajaram'
  },
  {
    _id: { $oid: '6a047aba55bb6da7d4f39171' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Rampur'
  },
  {
    _id: { $oid: '6a047aba54b549ab3cfcb379' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Rebbana'
  },
  {
    _id: { $oid: '6a047aba3549b8b97699e0fd' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Rollapahad'
  },
  {
    _id: { $oid: '6a047aba7871b0768b8cff0a' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Takkallapalle'
  },
  {
    _id: { $oid: '6a047abafa4f20126780cc2c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Tungeda'
  },
  {
    _id: { $oid: '6a047abaa9e5b66723a303db' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Rebbena',
    village: 'Venkulam'
  },

  {
    _id: { $oid: '6a047aa5b0054d3abb242f51' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Penchicalpet',
    village: 'Agarguda'
  },
  {
    _id: { $oid: '6a047aa590be6736d42f23fe' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Penchicalpet',
    village: 'Bombaiguda'
  },
  {
    _id: { $oid: '6a047aa5d58c9121c1b7a77f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Penchicalpet',
    village: 'Chedvai'
  },
  {
    _id: { $oid: '6a047aa5c0ce89a92a467656' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Penchicalpet',
    village: 'Darogapally'
  },
  {
    _id: { $oid: '6a047aa515e505fe0d600465' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Penchicalpet',
    village: 'Kamergaon'
  },
  {
    _id: { $oid: '6a047aa548c39ca0e1ebb147' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Penchicalpet',
    village: 'Kondapalle'
  },
  {
    _id: { $oid: '6a047aa58edf844f8f656bc0' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Penchicalpet',
    village: 'Lodpalle'
  },
  {
    _id: { $oid: '6a047aa503d7ca04587db5a9' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Penchicalpet',
    village: 'Muraliguda'
  },
  {
    _id: { $oid: '6a047aa558f08806a0489b40' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Penchicalpet',
    village: 'Penchikalpet'
  },
  {
    _id: { $oid: '6a047aa5dd274c4adec86746' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Penchicalpet',
    village: 'Yelkapalle'
  },
  {
    _id: { $oid: '6a047aa541c57884c75236af' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Penchicalpet',
    village: 'Yellur'
  },

  {
    _id: { $oid: '6a047a59d838b0910634107b' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Lingapur',
    village: 'Chinnadampur'
  },
  {
    _id: { $oid: '6a047a59ee96ba606682751b' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Lingapur',
    village: 'Chorapalle'
  },
  {
    _id: { $oid: '6a047a59ccc84088d9e5a8e6' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Lingapur',
    village: 'Gumnoor-B'
  },
  {
    _id: { $oid: '6a047a59f06867c9eaf9ef85' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Lingapur',
    village: 'Jamuldhara'
  },
  {
    _id: { $oid: '6a047a591497061b63782b39' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Lingapur',
    village: 'Kanchanpalli'
  },
  {
    _id: { $oid: '6a047a59d60f1f42cd94c4f0' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Lingapur',
    village: 'Keemnayak Tanda'
  },
  {
    _id: { $oid: '6a047a5925bcfe7c44ceb759' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Lingapur',
    village: 'Kothapalli'
  },
  {
    _id: { $oid: '6a047a599f541dfb9950ca84' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Lingapur',
    village: 'Lingapur'
  },
  {
    _id: { $oid: '6a047a59e1c6f3ced8d1ff3f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Lingapur',
    village: 'Loddiguda'
  },
  {
    _id: { $oid: '6a047a597778be9c8795904f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Lingapur',
    village: 'Mamidipalli'
  },
  {
    _id: { $oid: '6a047a59b09bea807dbb3894' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Lingapur',
    village: 'Mothipatar'
  },
  {
    _id: { $oid: '6a047a59a5b050d0275de9fe' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Lingapur',
    village: 'Piklathanda'
  },
  {
    _id: { $oid: '6a047a59cf71989a660a6b1b' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Lingapur',
    village: 'Pittaguda'
  },
  {
    _id: { $oid: '6a047a59a6436c1dd54a6c29' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Lingapur',
    village: 'Yellapatar'
  },

  {
    _id: { $oid: '6a047a3dbbca29c86ff4081f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Bhalepalli'
  },
  {
    _id: { $oid: '6a047a3d718cb94acdc369a6' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Bodhampalli'
  },
  {
    _id: { $oid: '6a047a3deb7eb8adfd3cafb6' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Gudlabori'
  },
  {
    _id: { $oid: '6a047a3dcce613b4d49b73c9' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Gundaipeta'
  },
  {
    _id: { $oid: '6a047a3dc7f787bebdcd0d5c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Gurudpeta'
  },
  {
    _id: { $oid: '6a047a3dfa0e78ff6920465d' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Kanki'
  },
  {
    _id: { $oid: '6a047a3d02ed15236a83d002' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Kannepalle'
  },
  {
    _id: { $oid: '6a047a3dc29a1d55cae75ac5' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Kouthala'
  },
  {
    _id: { $oid: '6a047a3d1048e030c6398238' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Mogadhagad'
  },
  {
    _id: { $oid: '6a047a3d65f68f66e7cdf687' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Muthampet'
  },
  {
    _id: { $oid: '6a047a3dc47a588ba30b0500' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Nagepalli'
  },
  {
    _id: { $oid: '6a047a3ddc029376e1308d3b' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Pardi'
  },
  {
    _id: { $oid: '6a047a3d298df2296bfa2346' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Sandgoan'
  },
  {
    _id: { $oid: '6a047a3ded666d5dd0177eac' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Shirsha'
  },
  {
    _id: { $oid: '6a047a3df6b4d3967d28dcb6' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Talodi'
  },
  {
    _id: { $oid: '6a047a3d02b09112e035833e' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Thatinagar'
  },
  {
    _id: { $oid: '6a047a3dd7e96c6a43ff04e8' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Thatipally'
  },
  {
    _id: { $oid: '6a047a3d1595db021e0d7090' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Tumdihetty'
  },
  {
    _id: { $oid: '6a047a3dc5f82b9b3b0703c1' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Veeravelly'
  },
  {
    _id: { $oid: '6a047a3dbc490c84e94fb0db' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Koutala',
    village: 'Veerdandi'
  },

  {
    _id: { $oid: '6a047a0ab2ef9b6839e2304e' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Agarwada'
  },
  {
    _id: { $oid: '6a047a0a9302d82ff44ea4bc' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Ananthapur'
  },
  {
    _id: { $oid: '6a047a0aed91f114f9f09fbf' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Anarpalli'
  },
  {
    _id: { $oid: '6a047a0abf7839550b9fa69a' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Babejhari'
  },
  {
    _id: { $oid: '6a047a0ad59360c215221996' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Bolapatar'
  },
  {
    _id: { $oid: '6a047a0a32448de59b034178' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Borilalguda'
  },
  {
    _id: { $oid: '6a047a0a9b4824635b10dcb6' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Devapur'
  },
  {
    _id: { $oid: '6a047a0a91b2fca344449f1d' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Dhanora'
  },
  {
    _id: { $oid: '6a047a0a14b8f182e4e2c367' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Gondguda'
  },
  {
    _id: { $oid: '6a047a0ac3591065bb81c537' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Goyagaon'
  },
  {
    _id: { $oid: '6a047a0a980589c10e590e5b' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Indapur'
  },
  {
    _id: { $oid: '6a047a0a1b93331bfbcc55db' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Jhari'
  },
  {
    _id: { $oid: '6a047a0ae25e7403aa6b2967' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Jhodeghat'
  },
  {
    _id: { $oid: '6a047a0a433eae15127e47f6' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Karanjiwada'
  },
  {
    _id: { $oid: '6a047a0aa7a63bede24018ae' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Keli-B'
  },
  {
    _id: { $oid: '6a047a0a4a1be41faeaaec0d' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Kerameri'
  },
  {
    _id: { $oid: '6a047a0abf479eb78d1cf139' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Keslaguda'
  },
  {
    _id: { $oid: '6a047a0ab9d9a71654c83abf' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Khairi'
  },
  {
    _id: { $oid: '6a047a0a258d199170608201' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Kothari'
  },
  {
    _id: { $oid: '6a047a0a6eea9475e9673dee' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Metapipri'
  },
  {
    _id: { $oid: '6a047a0a2199554c922848b5' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Modi'
  },
  {
    _id: { $oid: '6a047a0a2bb6b72fc33352f4' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Mukadhamguda'
  },
  {
    _id: { $oid: '6a047a0ab60a14bc32d3748f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Nishani'
  },
  {
    _id: { $oid: '6a047a0a06ff5504bd2e0911' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Parandholi'
  },
  {
    _id: { $oid: '6a047a0a1e02f14b575bc7e8' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Parda'
  },
  {
    _id: { $oid: '6a047a0a255a32d71968cad6' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Ringhanghat'
  },
  {
    _id: { $oid: '6a047a0ab0c2dd19d484a8f9' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Sakada'
  },
  {
    _id: { $oid: '6a047a0ac4e3ff40b4c6dd48' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Sangvi'
  },
  {
    _id: { $oid: '6a047a0a6beb3637e1afb07c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Saverkeda'
  },
  {
    _id: { $oid: '6a047a0a7076b9f39c4a861a' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Surdapur'
  },
  {
    _id: { $oid: '6a047a0a4b14d14e5f3d0310' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kerameri',
    village: 'Thummaguda'
  },

  {
    _id: { $oid: '6a0479cd4a532f718c7ad963' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Andevelly'
  },
  {
    _id: { $oid: '6a0479cd9c048ab3ce045bbc' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Ankoda'
  },
  {
    _id: { $oid: '6a0479cd6f4b227a65c24988' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Ankusapur'
  },
  {
    _id: { $oid: '6a0479cd551676bea0e2431f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Bareguda'
  },
  {
    _id: { $oid: '6a0479cdf4d8e8018e5c5fb4' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Basantinagar'
  },
  {
    _id: { $oid: '6a0479cdfe77cd08b3622f85' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Bhat Palle'
  },
  {
    _id: { $oid: '6a0479cdef9049449ddce981' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Bodepalle'
  },
  {
    _id: { $oid: '6a0479cdf34f19014afeb848' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Burdagudem'
  },
  {
    _id: { $oid: '6a0479cd520d35d715c5ec1a' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Chinthaguda'
  },
  {
    _id: { $oid: '6a0479cdccf2e915617a6370' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Chinthaguda Koyawagu'
  },
  {
    _id: { $oid: '6a0479cd6b03278c1307e232' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Durga Nagar'
  },
  {
    _id: { $oid: '6a0479cdc21eb373d35ab803' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Easgaon'
  },
  {
    _id: { $oid: '6a0479cd373c264c48611157' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Gannaram'
  },
  {
    _id: { $oid: '6a0479cd70b2981faa572724' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Jaganathpur'
  },
  {
    _id: { $oid: '6a0479cd9cf60c8b3c992a14' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Kadamba'
  },
  {
    _id: { $oid: '6a0479cd5a247ff4194450ff' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Kosini'
  },
  {
    _id: { $oid: '6a0479cd35f9d4ec6f939485' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Kotha Sarsala'
  },
  {
    _id: { $oid: '6a0479cd4cfb122cd1138fe4' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Lineguda'
  },
  {
    _id: { $oid: '6a0479cd185f070b143c13ba' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Malni'
  },
  {
    _id: { $oid: '6a0479cd2f8cda47c59873fb' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Mosam'
  },
  {
    _id: { $oid: '6a0479cd0d5a1dce61f6bb52' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Nagampet'
  },
  {
    _id: { $oid: '6a0479cdceb8c3434f79f5c0' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Nazurulnagar'
  },
  {
    _id: { $oid: '6a0479cde8231cd2c4fd88c6' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Ngos Colony'
  },
  {
    _id: { $oid: '6a0479cda8e5f907acd44b80' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Pothapalli'
  },
  {
    _id: { $oid: '6a0479cd3441e060c798aebd' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Ramnagar (N)'
  },
  {
    _id: { $oid: '6a0479cd08393bf7ae9936c1' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Raspally'
  },
  {
    _id: { $oid: '6a0479cd7c09a3b4233039e3' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Regulaguda'
  },
  {
    _id: { $oid: '6a0479cd7ca67a46ecf17565' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Vallakonda'
  },
  {
    _id: { $oid: '6a0479cd3a8bf355ce287e2f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Kagaznagar',
    village: 'Vanjari'
  },

  {
    _id: { $oid: '6a0479aa2917c8347dd5ccb5' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Addesara'
  },
  {
    _id: { $oid: '6a0479aac3797b2e82763479' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Andh Guda'
  },
  {
    _id: { $oid: '6a0479aa69b35c51504c6d76' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Ashapalle'
  },
  {
    _id: { $oid: '6a0479aa3640d01f9bb341fa' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Bhusimetta'
  },
  {
    _id: { $oid: '6a0479aa6b0c138d3c543f99' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Chinthakara'
  },
  {
    _id: { $oid: '6a0479aa1cc86c97f3bba1a5' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Daboli'
  },
  {
    _id: { $oid: '6a0479aac477aa556ab91eba' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Dubbaguda'
  },
  {
    _id: { $oid: '6a0479aa95beba76010981fc' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Gowri Kolamguda'
  },
  {
    _id: { $oid: '6a0479aafb80b6dd714d5717' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Gudamamda'
  },
  {
    _id: { $oid: '6a0479aaeebaf8c761f879fb' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Jainoor'
  },
  {
    _id: { $oid: '6a0479aa27b8af51e11eb14d' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Jamgaon'
  },
  {
    _id: { $oid: '6a0479aa65115b47af456455' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Jamni'
  },
  {
    _id: { $oid: '6a0479aabe8a58e81acc2c15' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Jandaguda'
  },
  {
    _id: { $oid: '6a0479aa07374f4652d19e9e' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Maniguda'
  },
  {
    _id: { $oid: '6a0479aa9b7c1d9c4802cd03' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Mankuguda'
  },
  {
    _id: { $oid: '6a0479aad50a200c71f43bd9' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Marlawai'
  },
  {
    _id: { $oid: '6a0479aaa73e2206055b21a7' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Panapatar'
  },
  {
    _id: { $oid: '6a0479aad835eaf369ea8768' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Para'
  },
  {
    _id: { $oid: '6a0479aa145b654ae5bffd2f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Patnapur'
  },
  {
    _id: { $oid: '6a0479aa8ddac2f75a89a665' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Pocham Loddi'
  },
  {
    _id: { $oid: '6a0479aa8a4cbcb9bf71dcde' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Power Guda'
  },
  {
    _id: { $oid: '6a0479aaf839e999daba613b' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Ramnayak Thanda'
  },
  {
    _id: { $oid: '6a0479aa5ed284f84ad4e59d' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Raoji Guda'
  },
  {
    _id: { $oid: '6a0479aad54135817f3fddc0' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Rasimatta'
  },
  {
    _id: { $oid: '6a0479aac55542dd32e01110' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Shivnoor'
  },
  {
    _id: { $oid: '6a0479aa9c4640d744ca59d4' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Jainoor',
    village: 'Ushegaon'
  },

  {
    _id: { $oid: '6a047982b303950119be57d6' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Ainam'
  },
  {
    _id: { $oid: '6a04798278e717a4ff9c513c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Beebra'
  },
  {
    _id: { $oid: '6a04798298ca683e3459e8a5' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Bhamanagar'
  },
  {
    _id: { $oid: '6a0479827ecf13a43cc88eec' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Borlakunta'
  },
  {
    _id: { $oid: '6a047982f262695f50fff13c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Chandrapalle'
  },
  {
    _id: { $oid: '6a0479829bdf5271d1a7b834' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Chinnaraspalle'
  },
  {
    _id: { $oid: '6a047982429fce1160fc93e7' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Chowka'
  },
  {
    _id: { $oid: '6a04798200ebc445b87c11b0' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Dahegaon'
  },
  {
    _id: { $oid: '6a047982299691215a656f96' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Digida'
  },
  {
    _id: { $oid: '6a047982cf2ac37821880369' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Gerre'
  },
  {
    _id: { $oid: '6a047982c453c455434f634c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Girvelli'
  },
  {
    _id: { $oid: '6a047982e5170cc3df6e44f1' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Hathni'
  },
  {
    _id: { $oid: '6a0479825ca542cd2d2f735d' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Ityal'
  },
  {
    _id: { $oid: '6a0479829cbd93d9883cfe72' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Kalwada'
  },
  {
    _id: { $oid: '6a04798228f31678eb8f3495' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Kamarpally'
  },
  {
    _id: { $oid: '6a047982ca6ec2113e19623f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Kharji'
  },
  {
    _id: { $oid: '6a0479826c63352f823339a0' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Kothmir'
  },
  {
    _id: { $oid: '6a047982e96b920d465b0c59' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Kunchavelli'
  },
  {
    _id: { $oid: '6a047982ce4fa4c209f80f03' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Laggaon'
  },
  {
    _id: { $oid: '6a04798272aa416965dda63c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Motleguda'
  },
  {
    _id: { $oid: '6a047982f335b9c7957f8c06' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Pesarikunta'
  },
  {
    _id: { $oid: '6a047982fc89893473b02a34' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Pp Rao Colony'
  },
  {
    _id: { $oid: '6a047982526095bae1f6cb7f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Rampur'
  },
  {
    _id: { $oid: '6a0479823bd079103326e9d1' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Dahegoan',
    village: 'Vodduguda'
  },

  {
    _id: { $oid: '6a0479610ffa3ef59a34ebd5' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Adepally'
  },
  {
    _id: { $oid: '6a047961b9ca7857e6500f8a' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Babapur'
  },
  {
    _id: { $oid: '6a0479617e253a43b076ca4f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Babasagar'
  },
  {
    _id: { $oid: '6a047961d936da2def187b0b' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Balaji Ankoda'
  },
  {
    _id: { $oid: '6a0479613391640b3956cfcb' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Burepalli'
  },
  {
    _id: { $oid: '6a0479614840fc84f0254d01' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Chintala Manepalle'
  },
  {
    _id: { $oid: '6a047961e0b8b2b08ecac93c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Dimda'
  },
  {
    _id: { $oid: '6a047961a6ba9190060e525c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Gangapur'
  },
  {
    _id: { $oid: '6a04796169feff9279817c2c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Gudem'
  },
  {
    _id: { $oid: '6a047961e54d09e9cd0198a2' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Hetiguda'
  },
  {
    _id: { $oid: '6a0479613468403887cac2fc' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Karjavelli'
  },
  {
    _id: { $oid: '6a0479616947adb59a4238e9' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Korsini'
  },
  {
    _id: { $oid: '6a0479613904439323b11901' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Koyapally'
  },
  {
    _id: { $oid: '6a047961c2a659aff3014423' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Lamberhetti'
  },
  {
    _id: { $oid: '6a0479618bee0974c2610974' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Ranvalli'
  },
  {
    _id: { $oid: '6a0479614a9b0c0510baf730' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Ravindranagar'
  },
  {
    _id: { $oid: '6a0479611bc21e8399671323' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Ravindranagar-II'
  },
  {
    _id: { $oid: '6a0479617fb76df9d1f2546d' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Chintalamanepalli',
    village: 'Rudrapur'
  },

  {
    _id: { $oid: '6a04791657f130b87b9365f4' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Ambhaghat'
  },
  {
    _id: { $oid: '6a0479160ada0a4dffd6571c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Andhugulaguda'
  },
  {
    _id: { $oid: '6a047916d3275e4b30d34a38' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Bareguda'
  },
  {
    _id: { $oid: '6a04791683b940c0993d9054' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Bejjur'
  },
  {
    _id: { $oid: '6a047916d8d275830d50e499' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Katepalli'
  },
  {
    _id: { $oid: '6a04791672b9194e90e5eddd' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Kukuda'
  },
  {
    _id: { $oid: '6a047916085b53d4b6e1345c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Kuntalamanepalli'
  },
  {
    _id: { $oid: '6a047916a717f03284d35329' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Kushnepalle'
  },
  {
    _id: { $oid: '6a0479169dddf97b26f7707f' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Lambadiguda'
  },
  {
    _id: { $oid: '6a047916867b407aff9812bd' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Marthadi'
  },
  {
    _id: { $oid: '6a047916108488d245169153' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Mogavelly'
  },
  {
    _id: { $oid: '6a0479160a2facbfbaf4d1ea' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Munjampalle'
  },
  {
    _id: { $oid: '6a047916e3e0aea5bce279cb' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Outsarangipalle'
  },
  {
    _id: { $oid: '6a0479161b10e68823910b08' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Papanpet'
  },
  {
    _id: { $oid: '6a0479168c3bbb68a18e781b' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Pedda Siddapur'
  },
  {
    _id: { $oid: '6a0479160c33ae437e7a31a7' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Pothepally'
  },
  {
    _id: { $oid: '6a0479168ec79df8463e256c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Rebbena'
  },
  {
    _id: { $oid: '6a047916f9d62c615166e3dc' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Somini'
  },
  {
    _id: { $oid: '6a047916c78c7eddbff2d851' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Sulugupalli'
  },
  {
    _id: { $oid: '6a047916b05d8d8f7ff7f4e0' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Sushmir'
  },
  {
    _id: { $oid: '6a04791676f83f72fb7f0de3' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Talai'
  },
  {
    _id: { $oid: '6a04791690592c3bca8cf142' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Bejjur',
    village: 'Thummala guda'
  },

  {
    _id: { $oid: '6a0478c1afab45e3cef6d37c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Ada'
  },
  {
    _id: { $oid: '6a0478c139c9d4b0f3bdc408' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Dasnapur'
  },
  {
    _id: { $oid: '6a0478c1f9aea866cbd68f82' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Ankusapur'
  },
  {
    _id: { $oid: '6a0478c1646a2eab66d1bf92' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Appapally'
  },
  {
    _id: { $oid: '6a0478c108f96014afcf9983' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Babapur'
  },
  {
    _id: { $oid: '6a0478c16fac11908b12ee96' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Buruguda'
  },
  {
    _id: { $oid: '6a0478c1763ab3246447c332' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Chilatiguda'
  },
  {
    _id: { $oid: '6a0478c19dcc931e5722875c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Chirrakunta'
  },
  {
    _id: { $oid: '6a0478c1e9c4e8452415cb35' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Chorpalli'
  },
  {
    _id: { $oid: '6a0478c1f5a4fa6ffd4cea58' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Edulawada'
  },
  {
    _id: { $oid: '6a0478c1d8975da02d39bc11' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Govindapur'
  },
  {
    _id: { $oid: '6a0478c15dc1e7505cd47057' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Gundi'
  },
  {
    _id: { $oid: '6a0478c1c6df538e1ec2ab09' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Kosara'
  },
  {
    _id: { $oid: '6a0478c138fea3c1a8958b1c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Koutaguda'
  },
  {
    _id: { $oid: '6a0478c1e5f0c6ea5e3d5a26' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Malangondi'
  },
  {
    _id: { $oid: '6a0478c1a35b32303b39518c' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Manikguda'
  },
  {
    _id: { $oid: '6a0478c10e4ed12ceba17fbc' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Motuguda'
  },
  {
    _id: { $oid: '6a0478c12b877f9c028f8785' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Mowad'
  },
  {
    _id: { $oid: '6a0478c18bfc7f45113bd130' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Padibanda'
  },
  {
    _id: { $oid: '6a0478c101a72336a8e2e170' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Rahapally'
  },
  {
    _id: { $oid: '6a0478c18ebf224f8e955751' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Rajampet'
  },
  {
    _id: { $oid: '6a0478c10f48261e582089b3' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Routsankepalle'
  },
  {
    _id: { $oid: '6a0478c1b6be3dc20676c1d1' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Saleguda'
  },
  {
    _id: { $oid: '6a0478c1e79b1aad9687d8ee' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Tumpelli'
  },
  {
    _id: { $oid: '6a0478c13c07b699b6993c37' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Venkatapur'
  },
  {
    _id: { $oid: '6a0478c108f293040d9b7b67' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Wavudam'
  },
  {
    _id: { $oid: '6a0478c19868e739a427ec63' },
    state: 'Telangana',
    district: 'Kumuram Bheem Asifabad',
    block: 'Asifabad',
    village: 'Yellaram'
  },

  {
    _id: { $oid: '6a04759c2a421132fcf3f72f' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mallampally',
    village: 'Mallampally'
  },
  {
    _id: { $oid: '6a04759cf732e842120c6e33' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mallampally',
    village: 'Md Gausepally'
  },
  {
    _id: { $oid: '6a04759cc2de124e46ac4d2c' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mallampally',
    village: 'Mudhurur thanda'
  },
  {
    _id: { $oid: '6a04759c56b7f9a511dc5a03' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mallampally',
    village: 'Ramachandrapur'
  },
  {
    _id: { $oid: '6a04759c24a5ccc7df2fc3d3' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mallampally',
    village: 'Shivathanda'
  },
  {
    _id: { $oid: '6a04759c34ceb19eb66330ba' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mallampally',
    village: 'Srinagr'
  },
  {
    _id: { $oid: '6a04759c412b4586893036fc' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mallampally',
    village: 'Guthurthanda'
  },
  {
    _id: { $oid: '6a04759c5c34b928d915b417' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mallampally',
    village: 'Devangar'
  },
  {
    _id: { $oid: '6a04759c4ecc23972e047973' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mallampally',
    village: 'Bhupalmnagar'
  },
  {
    _id: { $oid: '6a04759c498dce52e6688102' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mallampally',
    village: 'Kodishalakunta'
  },

  {
    _id: { $oid: '6a04753a9a205dbae7534b0a' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Ayyavaripeta'
  },
  {
    _id: { $oid: '6a04753abfdf498457360c1f' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Chandrupatla'
  },
  {
    _id: { $oid: '6a04753a1d3bcdeb379abefa' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Cheekupalli'
  },
  {
    _id: { $oid: '6a04753a576b84fbf92a9932' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Cherukuru'
  },
  {
    _id: { $oid: '6a04753a7bb51dab8737100a' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Chintoor'
  },
  {
    _id: { $oid: '6a04753a4a27e36d291a93c7' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Dharmavaram'
  },
  {
    _id: { $oid: '6a04753abca749bec83fd6ba' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Dhulapuram'
  },
  {
    _id: { $oid: '6a04753ab6008f8461dc583f' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Edjerlapally'
  },
  {
    _id: { $oid: '6a04753a8fe270af36aa4fb0' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Gummadidoddi'
  },
  {
    _id: { $oid: '6a04753af0915c92f2de7468' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Kongala'
  },
  {
    _id: { $oid: '6a04753a37c5246a6473bf42' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Krishnapuram'
  },
  {
    _id: { $oid: '6a04753a875cbfa95b4eb170' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Murumuru'
  },
  {
    _id: { $oid: '6a04753ac1100a39c4a1c8bd' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Nagaram'
  },
  {
    _id: { $oid: '6a04753a7551b6e19f9ef65c' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Peddagollagudem'
  },
  {
    _id: { $oid: '6a04753ae89832030ca656f7' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Peruru'
  },
  {
    _id: { $oid: '6a04753a72c9892dc3ed1b7a' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Pusuru'
  },
  {
    _id: { $oid: '6a04753ad655f0ceef2249f4' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Wazeedu',
    village: 'Tekulagudem'
  },

  {
    _id: { $oid: '6a0475095d2fc84044747e48' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Adavirangapur'
  },
  {
    _id: { $oid: '6a0475097ca9a4cb54c798d7' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Burgupet'
  },
  {
    _id: { $oid: '6a047509a9775701959ff0cf' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Chakravarthipally'
  },
  {
    _id: { $oid: '6a047509ff63d986d41bc37c' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Inchenchervupally'
  },
  {
    _id: { $oid: '6a04750969c65485b9a08408' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Jawaharnagar'
  },
  {
    _id: { $oid: '6a047509b7c49aceeb4613c9' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Keshavapur'
  },
  {
    _id: { $oid: '6a04750929d212ea0b45c593' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Laxmidevipet'
  },
  {
    _id: { $oid: '6a047509562c22e97c6d7a41' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Laxmipuram'
  },
  {
    _id: { $oid: '6a0475097c1dd0ac02e78c05' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Lingapur'
  },
  {
    _id: { $oid: '6a0475092d13dca7e089f19e' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Mallaiapally'
  },
  {
    _id: { $oid: '6a04750968c58f4a20354350' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Nallagunta'
  },
  {
    _id: { $oid: '6a047509916327b25e9b35df' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Narayanagiripally'
  },
  {
    _id: { $oid: '6a04750980ac749eae1cb6df' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Narsapur'
  },
  {
    _id: { $oid: '6a047509a5c7991688a30106' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Narsingspur'
  },
  {
    _id: { $oid: '6a047509e4b269922f367686' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Palampet'
  },
  {
    _id: { $oid: '6a047509d722cc380d2aa1ea' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Papaiahpally'
  },
  {
    _id: { $oid: '6a047509e63b7077768c153a' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Raheshwararaopalli'
  },
  {
    _id: { $oid: '6a04750936802f4cbd0173f9' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Ramanjapur'
  },
  {
    _id: { $oid: '6a047509c80a0a8641f9ca69' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Singaraguntapally'
  },
  {
    _id: { $oid: '6a047509fbd0a6e35e5ee7c8' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Thimmapur'
  },
  {
    _id: { $oid: '6a047509e7fa4484591edfc1' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Velthurlapally'
  },
  {
    _id: { $oid: '6a047509ea10a0a8053dc36c' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Venkapur'
  },
  {
    _id: { $oid: '6a047509211bf99c98fa2579' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatpur',
    village: 'Yellareddypally'
  },

  {
    _id: { $oid: '6a0474ee45c14c41313d97dc' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'Alubaka'
  },
  {
    _id: { $oid: '6a0474ee27b5d2a60acb0838' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'Bartagudem'
  },
  {
    _id: { $oid: '6a0474ee64635091397526af' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'BC Marrigudem'
  },
  {
    _id: { $oid: '6a0474ee896bc7a83b5a1d16' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'Bestagudem'
  },
  {
    _id: { $oid: '6a0474ee2dad913fdf759592' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'Bodapuram'
  },
  {
    _id: { $oid: '6a0474ee855472ee0eeb4aa9' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'Edira'
  },
  {
    _id: { $oid: '6a0474ee433dfd9060645e5b' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'Marikala'
  },
  {
    _id: { $oid: '6a0474eee456698d78b691f8' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'Morravanigudem'
  },
  {
    _id: { $oid: '6a0474ee5dab5d82049b8243' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'Nuguru'
  },
  {
    _id: { $oid: '6a0474ee5496621ad532db09' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'Pathrapuram'
  },
  {
    _id: { $oid: '6a0474ee0b501d15cad21628' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'Rachapalli'
  },
  {
    _id: { $oid: '6a0474ee56e4412edb18868d' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'Ramachandrumipuram'
  },
  {
    _id: { $oid: '6a0474eee0ad7ed9d31c07d0' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'Suraveedu'
  },
  {
    _id: { $oid: '6a0474ee276e84290f039df6' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'Thippapuram'
  },
  {
    _id: { $oid: '6a0474ee39244422d0f715cc' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'Uppedu veerapuram'
  },
  {
    _id: { $oid: '6a0474ee19b315e01f2cc3ac' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'Veerabhadravaram'
  },
  {
    _id: { $oid: '6a0474eec3801b899b6b8c8e' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'Venkatapuram'
  },
  {
    _id: { $oid: '6a0474eecd766b2ad0c24d0c' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Venkatapuram',
    village: 'VPK Puram'
  },

  {
    _id: { $oid: '6a0474e1dbeef99366241cb7' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Abbapur'
  },
  {
    _id: { $oid: '6a0474e12a15872fb31143fd' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Ankannagudem'
  },
  {
    _id: { $oid: '6a0474e134c5fd5b0acd191a' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Bandarupally'
  },
  {
    _id: { $oid: '6a0474e15dcdd8c745f94425' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Banjarupally'
  },
  {
    _id: { $oid: '6a0474e1f0f74fd0a8561a3a' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Barigalapally'
  },
  {
    _id: { $oid: '6a0474e126854afc24332f55' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Devagiri Patnam'
  },
  {
    _id: { $oid: '6a0474e1338734623d392654' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Incherla'
  },
  {
    _id: { $oid: '6a0474e12935ce4ef3ec73ce' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Jagganapet'
  },
  {
    _id: { $oid: '6a0474e1ee16a0680df7f020' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Jakaram'
  },
  {
    _id: { $oid: '6a0474e18d1decdd7a322bf5' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Jangalapally'
  },
  {
    _id: { $oid: '6a0474e12759aba097968195' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Jeevantharapally'
  },
  {
    _id: { $oid: '6a0474e145c0c7e9ce9b7c38' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Kannaigudem'
  },
  {
    _id: { $oid: '6a0474e1a50c245ca3130190' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Kasimdevipet'
  },
  {
    _id: { $oid: '6a0474e137b10a63796b4bdb' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Kodishalakunta'
  },
  {
    _id: { $oid: '6a0474e19c1c9ba4faecbe3e' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Kothur'
  },
  {
    _id: { $oid: '6a0474e1b39c17aa4f1b120c' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Madannapally'
  },
  {
    _id: { $oid: '6a0474e1d455fa506a5e77e1' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Mulugu'
  },
  {
    _id: { $oid: '6a0474e1cc7be4e42e971111' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Panchothkalapally'
  },
  {
    _id: { $oid: '6a0474e104a263cc00fd6c55' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Pathipally'
  },
  {
    _id: { $oid: '6a0474e1a7516145faa7aeb9' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Pegadapally'
  },
  {
    _id: { $oid: '6a0474e14393063cfd38c087' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Potlapur'
  },
  {
    _id: { $oid: '6a0474e1538c25d920e6791c' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Rainigudem'
  },
  {
    _id: { $oid: '6a0474e1a14203a3225ec747' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mulugu',
    village: 'Sarvapur'
  },

  
  {
    _id: { $oid: '6a1566044992e7626af60c6d' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Alligudem'
  },
  {
    _id: { $oid: '6a1566048d02635cbb255ab8' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Ankampalli'
  },
  {
    _id: { $oid: '6a15660422346028f5c1fad8' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Annaram'
  },
  {
    _id: { $oid: '6a1566043c864dd6a05742d1' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Ashannaguda Yellapur'
  },
  {
    _id: { $oid: '6a156604550c5593ae38dcb6' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Banjar Yellapur'
  },
  {
    _id: { $oid: '6a156604270aafb8407caf92' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Bhupathipur'
  },
  {
    _id: { $oid: '6a156604f244c529711ce385' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Bittupalli'
  },
  {
    _id: { $oid: '6a156604e4d25acef61db0c6' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Bollepalli'
  },
  {
    _id: { $oid: '6a156604aeadff786b1ff066' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Chowledu'
  },
  {
    _id: { $oid: '6a1566046060ab4b0def3c0d' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Elbaka'
  },
  {
    _id: { $oid: '6a15660421530299f19279b9' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Gonepalli'
  },
  {
    _id: { $oid: '6a156604247171e91be6d59b' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Immadigudem'
  },
  {
    _id: { $oid: '6a15660463719ab9a7080bbe' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Jampangavai'
  },
  {
    _id: { $oid: '6a1566046b466f5e87d3dc96' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Kamaram'
  },
  {
    _id: { $oid: '6a156604bd9514a16fb836ab' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Kanneboinapalli'
  },
  {
    _id: { $oid: '6a156604e579be6d43a78b92' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Kondaparthi'
  },
  {
    _id: { $oid: '6a1566049bcac479088721a1' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Koushettivai'
  },
  {
    _id: { $oid: '6a15660407e177292cf3e846' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Lavvala'
  },
  {
    _id: { $oid: '6a1566044d9e2eccc18de540' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Medaram (Sammakka Jathara)'
  },
  {
    _id: { $oid: '6a1566040a962b0d067a2b9a' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Narsapur (PA)'
  },
  {
    _id: { $oid: '6a156604bf5bdd66f4cdda9a' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Narsapur (PL)'
  },
  {
    _id: { $oid: '6a1566041ae370a25477db74' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Narsingapur'
  },
  {
    _id: { $oid: '6a156604e72981529d8a145d' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Padigapur'
  },
  {
    _id: { $oid: '6a15660414b3aedcc7d91c9c' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Pochapur'
  },
  {
    _id: { $oid: '6a15660447a92d291a042734' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Singaram'
  },
  {
    _id: { $oid: '6a156604c518b330cced8227' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Veerapur'
  },
  {
    _id: { $oid: '6a15660411b39c30fe57fc45' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Waddegudem'
  },
{
    _id: { $oid: '6a0474cddafab68544e3b8e4' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Ankamapalli'
  },
  {
    _id: { $oid: '6a0474cdc44756b308217911' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Bandala'
  },
  {
    _id: { $oid: '6a0474cd70bdc379efd16d2d' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Bayyakkapet'
  },
  {
    _id: { $oid: '6a0474cd096c5b2bc65e8841' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Beerelli'
  },
  {
    _id: { $oid: '6a0474cd7c486366a48fec3c' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Dameravai'
  },
  {
    _id: { $oid: '6a0474cd67e8d77dd7ed9428' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Gangaram'
  },
  {
    _id: { $oid: '6a0474cd129c4b45e045de49' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Kalwapalli'
  },
  {
    _id: { $oid: '6a0474cd939ab2c10bee2ef0' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Kamaram PT'
  },
  {
    _id: { $oid: '6a0474cda9cc3262b588382e' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Katapur'
  },
  {
    _id: { $oid: '6a0474cd20b9c479a41a4a61' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Lingala'
  },
  {
    _id: { $oid: '6a0474cd35e221629a458a16' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Medaram'
  },
  {
    _id: { $oid: '6a0474cd2fea69008be0ba7c' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Narlapur'
  },
  {
    _id: { $oid: '6a0474cdc20216cb248e82da' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Narsapur PA'
  },
  {
    _id: { $oid: '6a0474cdcad4bc578f58a8c1' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Oorattam'
  },
  {
    _id: { $oid: '6a0474cd3676c6e785ca1479' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Pambapur'
  },
  {
    _id: { $oid: '6a0474cd4aeec7f2eeed0442' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Rangapur'
  },
  {
    _id: { $oid: '6a0474cd20cf2f0911aa73be' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Tadvai'
  },
  {
    _id: { $oid: '6a0474cdb5ee0b0817caf567' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'S S Tadvai',
    village: 'Vengalapur'
  },

  {
    _id: { $oid: '6a04748eab74398ab77551b4' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Akinapally Mallaram'
  },
  {
    _id: { $oid: '6a04748ebd56df41e5f88bde' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Balannagudem'
  },
  {
    _id: { $oid: '6a04748e5426ac18026e7167' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Brahmanapally'
  },
  {
    _id: { $oid: '6a04748e678b746316a7eee6' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Buchampet'
  },
  {
    _id: { $oid: '6a04748ed377c1439a53d0be' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Cherupally'
  },
  {
    _id: { $oid: '6a04748e4b7fa20447a9ab2c' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Chunchupally'
  },
  {
    _id: { $oid: '6a04748e516f08bbbe340751' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Domeda'
  },
  {
    _id: { $oid: '6a04748e96828af36b4d2287' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Kamalapur'
  },
  {
    _id: { $oid: '6a04748e5eb119466969fcb8' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Kathigudem'
  },
  {
    _id: { $oid: '6a04748ee9d651bb2fa50d5e' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Komatipally'
  },
  {
    _id: { $oid: '6a04748e35cee5e7b9c8a346' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Kotha Malluru'
  },
  {
    _id: { $oid: '6a04748e2fe92b4759f24d9f' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Kothur Motlagudem'
  },
  {
    _id: { $oid: '6a04748e9c0901d3fb32787c' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Malluru'
  },
  {
    _id: { $oid: '6a04748ec3f98d48a88c511f' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Mangapet'
  },
  {
    _id: { $oid: '6a04748e3f5522a8706ab5ce' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Narsaigudem'
  },
  {
    _id: { $oid: '6a04748e878f9990690ba33d' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Narsapur Bore'
  },
  {
    _id: { $oid: '6a04748e5e8b195f309b400e' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Narsima Sagar'
  },
  {
    _id: { $oid: '6a04748e949e69f44eaa67d5' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Nimmagudem'
  },
  {
    _id: { $oid: '6a04748ec3cffe33c349389b' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Puredupally'
  },
  {
    _id: { $oid: '6a04748e15d76c2aff43a052' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Rajupet'
  },
  {
    _id: { $oid: '6a04748e57ae3b7a0e8cc74c' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Ramachandrunipet'
  },
  {
    _id: { $oid: '6a04748ec82eab218883ea9b' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Ramanakkapet'
  },
  {
    _id: { $oid: '6a04748e5e90703cf5d1a446' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Thimmampet'
  },
  {
    _id: { $oid: '6a04748ed2f6c8f22a877e1b' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Vagoddugudem'
  },
  {
    _id: { $oid: '6a04748e3772db9d72b5bcde' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Mangapet',
    village: 'Wadagudem'
  },

  {
    _id: { $oid: '6a04747c6518f3a22ad015c7' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Kannaigudem',
    village: 'Buttaigudem'
  },
  {
    _id: { $oid: '6a04747ca7aa89d0fb0da4eb' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Kannaigudem',
    village: 'Chinthagudem'
  },
  {
    _id: { $oid: '6a04747c8dab15a1a6ff4fa0' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Kannaigudem',
    village: 'Etur'
  },
  {
    _id: { $oid: '6a04747c813d1554ec93f995' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Kannaigudem',
    village: 'Gurrevula'
  },
  {
    _id: { $oid: '6a04747c1ffb04e4dfeaba58' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Kannaigudem',
    village: 'Ilapur'
  },
  {
    _id: { $oid: '6a04747c5a88893411f9bb29' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Kannaigudem',
    village: 'Kanthanapally'
  },
  {
    _id: { $oid: '6a04747c9d0315ac3267f57d' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Kannaigudem',
    village: 'Laxmipuram'
  },
  {
    _id: { $oid: '6a04747c7bd34da834e016fa' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Kannaigudem',
    village: 'Muppanapally'
  },
  {
    _id: { $oid: '6a04747cbd33bfe37d4b25e8' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Kannaigudem',
    village: 'Rajannapeta'
  },
  {
    _id: { $oid: '6a04747cc32c1e05b892f00d' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Kannaigudem',
    village: 'Sarvai'
  },
  {
    _id: { $oid: '6a04747ca34d83b1243ad47f' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Kannaigudem',
    village: 'Thupakala Gudem'
  },

  {
    _id: { $oid: '6a04742e37a4185b4e05fc2b' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Govindaraopet',
    village: 'Balajinagar'
  },
  {
    _id: { $oid: '6a04742e8751e9fdd0be3833' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Govindaraopet',
    village: 'Bussapur'
  },
  {
    _id: { $oid: '6a04742e7e910652c02126db' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Govindaraopet',
    village: 'Chalwai'
  },
  {
    _id: { $oid: '6a04742e0fde116233f623f7' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Govindaraopet',
    village: 'Gandhinagar'
  },
  {
    _id: { $oid: '6a04742e9946154ab4ae583b' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Govindaraopet',
    village: 'Govindaraopet'
  },
  {
    _id: { $oid: '6a04742e9925b96939cfb428' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Govindaraopet',
    village: 'Karlapally'
  },
  {
    _id: { $oid: '6a04742e9af38473f8f032b6' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Govindaraopet',
    village: 'Kotagadda'
  },
  {
    _id: { $oid: '6a04742e3325b4a203560991' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Govindaraopet',
    village: 'Laknavaram'
  },
  {
    _id: { $oid: '6a04742efbaabf969a5dfcc4' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Govindaraopet',
    village: 'Pasra'
  },
  {
    _id: { $oid: '6a04742e9ed343fd93e3452e' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Govindaraopet',
    village: 'Raghavapatnam'
  },
  {
    _id: { $oid: '6a04742ee6d07bd626371ea5' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Govindaraopet',
    village: 'Ramnagar'
  },
  {
    _id: { $oid: '6a04742e75d305693a3d80d3' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Govindaraopet',
    village: 'Rangapur'
  },
  {
    _id: { $oid: '6a04742e2afb30ca1647a20c' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Govindaraopet',
    village: 'Somalagadda'
  },

  {
    _id: { $oid: '6a04742047ab511bbf2c0852' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Eturnagaram',
    village: 'Akulavarighanpur'
  },
  {
    _id: { $oid: '6a0474206fa7472dd96cd012' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Eturnagaram',
    village: 'Chalpaka'
  },
  {
    _id: { $oid: '6a047420dbf498d9f9fe15f5' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Eturnagaram',
    village: 'Chinaboinapally'
  },
  {
    _id: { $oid: '6a047420fe2013b7c4063386' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Eturnagaram',
    village: 'Eturnagaram'
  },
  {
    _id: { $oid: '6a047420e8d4c5a43cc82a1f' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Eturnagaram',
    village: 'Kondai'
  },
  {
    _id: { $oid: '6a04742054c75301c9293741' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Eturnagaram',
    village: 'Koyaguda'
  },
  {
    _id: { $oid: '6a047420043541339c9cd6a2' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Eturnagaram',
    village: 'Mullakata'
  },
  {
    _id: { $oid: '6a04742098e2d3ff93c53d2e' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Eturnagaram',
    village: 'Ramnnagudem'
  },
  {
    _id: { $oid: '6a047420b2569f72ae33011e' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Eturnagaram',
    village: 'Roheer'
  },
  {
    _id: { $oid: '6a0474208dc32d229628ef6b' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Eturnagaram',
    village: 'Shankarajpally'
  },
  {
    _id: { $oid: '6a047420de819b89b3dcc5f6' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Eturnagaram',
    village: 'Shapally'
  },
  {
    _id: { $oid: '6a04742031f5ceb9379f556b' },
    state: 'Telangana',
    district: 'Mulugu',
    block: 'Eturnagaram',
    village: 'Shivapur'
  },

  {
    _id: { $oid: '69c3e7dfff0466899ca6af6c' },
    state: 'Karnataka',
    district: 'Chikkaballapura',
    block: 'Chintamani',
    village: 'Kuratahallli'
  },
  {
    _id: { $oid: '69c3e7df4f541c59ff45d258' },
    state: 'Karnataka',
    district: 'Chikkaballapura',
    block: 'Chintamani',
    village: 'Hadigere'
  },
  {
    _id: { $oid: '69c3e7df1aeb8d558ae6f8de' },
    state: 'Karnataka',
    district: 'Chikkaballapura',
    block: 'Chintamani',
    village: 'Moodachinthalahalli'
  },
  {
    _id: { $oid: '69c3e7df12fec705ab3fb065' },
    state: 'Karnataka',
    district: 'Chikkaballapura',
    block: 'Chintamani',
    village: 'Chimanahalli'
  },
  {
    _id: { $oid: '69c3e7dfda98cec56d646839' },
    state: 'Karnataka',
    district: 'Chikkaballapura',
    block: 'Chintamani',
    village: 'Kachahalli'
  },
  {
    _id: { $oid: '69c3e7df72b2fd8a0c023a27' },
    state: 'Karnataka',
    district: 'Chikkaballapura',
    block: 'Chintamani',
    village: 'Doddanatta'
  },
  {
    _id: { $oid: '69c3e7df173662d2c8c539a7' },
    state: 'Karnataka',
    district: 'Chikkaballapura',
    block: 'Chintamani',
    village: 'Koodihalli'
  },
  {
    _id: { $oid: '69c3e7df86424ab269fe524e' },
    state: 'Karnataka',
    district: 'Chikkaballapura',
    block: 'Chintamani',
    village: 'K Hosuru'
  },
  {
    _id: { $oid: '69c3e7df76975331efb56be0' },
    state: 'Karnataka',
    district: 'Chikkaballapura',
    block: 'Chintamani',
    village: 'Madikere'
  },
  {
    _id: { $oid: '69c3e7dfa347de74485cd609' },
    state: 'Karnataka',
    district: 'Chikkaballapura',
    block: 'Chintamani',
    village: 'Kaiwara'
  },
  {
    _id: { $oid: '69c3e7dfdd70306b4001d3aa' },
    state: 'Karnataka',
    district: 'Chikkaballapura',
    block: 'Chintamani',
    village: 'Banahalli'
  },
  {
    _id: { $oid: '69c3e7dfabb4be6cd60dee7a' },
    state: 'Karnataka',
    district: 'Chikkaballapura',
    block: 'Chintamani',
    village: 'Kuruburu'
  },
  {
    _id: { $oid: '69c3e7dfbb98098b84dc85d2' },
    state: 'Karnataka',
    district: 'Chikkaballapura',
    block: 'Chintamani',
    village: 'Doddapura'
  },
  {
    _id: { $oid: '69c3e7dfe07ec7bdf4a9291f' },
    state: 'Karnataka',
    district: 'Chikkaballapura',
    block: 'Chintamani',
    village: 'Nandhiganahalli'
  },
  {
    _id: { $oid: '69c3e7df56cbbe83a1015206' },
    state: 'Karnataka',
    district: 'Chikkaballapura',
    block: 'Chintamani',
    village: 'Peramachanahalli'
  },
  {
    _id: { $oid: '69c3e7dfeb8c203750f9e034' },
    state: 'Karnataka',
    district: 'Chikkaballapura',
    block: 'Chintamani',
    village: 'Doddaganjuru'
  },

  {
    _id: { $oid: '69ab80570db097e347d9788a' },
    state: 'Manipur',
    district: 'Tamenglong',
    block: 'Tousem',
    village: 'Tousem'
  },
  {
    _id: { $oid: '69ab80572f7bc0c906530add' },
    state: 'Manipur',
    district: 'Tamenglong',
    block: 'Tousem',
    village: 'Phoklong'
  },
  {
    _id: { $oid: '69ab8057a296d316e3533a8e' },
    state: 'Manipur',
    district: 'Tamenglong',
    block: 'Tousem',
    village: 'Taguaram'
  },
  {
    _id: { $oid: '69ab8057496c02111ef43369' },
    state: 'Manipur',
    district: 'Tamenglong',
    block: 'Tousem',
    village: 'Mandeu'
  },
  {
    _id: { $oid: '69ab8057828fa5a986c57a34' },
    state: 'Manipur',
    district: 'Tamenglong',
    block: 'Tousem',
    village: 'Aben'
  },
  {
    _id: { $oid: '69ab8057e20649cb6a92161c' },
    state: 'Manipur',
    district: 'Tamenglong',
    block: 'Tousem',
    village: 'Zenamdi'
  },
  {
    _id: { $oid: '69ab8057cef6ba8b28c33b19' },
    state: 'Manipur',
    district: 'Tamenglong',
    block: 'Tousem',
    village: 'Impa'
  },
  {
    _id: { $oid: '69ab8057ff369031f0a38e4d' },
    state: 'Manipur',
    district: 'Tamenglong',
    block: 'Tousem',
    village: 'Inem'
  },

  {
    _id: { $oid: '69ab80333c8d6878ed8572db' },
    state: 'Manipur',
    district: 'Tamenglong',
    block: 'Tamei',
    village: 'Lamlaba'
  },

  {
    _id: { $oid: '69ab80133517bc5c2eca8d4b' },
    state: 'Manipur',
    district: 'Tamenglong',
    block: 'Tamenglong',
    village: 'Khangchiuluang'
  },
  {
    _id: { $oid: '69ab8013df36c388fe3e741e' },
    state: 'Manipur',
    district: 'Tamenglong',
    block: 'Tamenglong',
    village: 'Tamenglong HQS and surroundings'
  },

  
  {
    _id: { $oid: '6a047c759a43c2ed545c19a7' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Amaragiri'
  },
  {
    _id: { $oid: '6a047c758aa65e886172177e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Yellur'
  },
  {
    _id: { $oid: '6a047c75f004e23636d3b34f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Yenmanbetla'
  },
  {
    _id: { $oid: '6a047c757c1a9375026de891' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Machinenipally'
  },
  {
    _id: { $oid: '6a047c753847428c9c66754b' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Choutabetla'
  },
  {
    _id: { $oid: '6a047c75eda49292fff0391b' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Chukkaipally'
  },
  {
    _id: { $oid: '6a047c75284b52742d8e93f4' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Kudikilla'
  },
  {
    _id: { $oid: '6a047c75661d68c7b298b3f1' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Narlapur'
  },
  {
    _id: { $oid: '6a047c756288776badbf2afa' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Mallabaswapur'
  },
  {
    _id: { $oid: '6a047c75a4a096d633366274' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Vardyal'
  },
  {
    _id: { $oid: '6a047c75985b5c1f389b0727' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Kollapur'
  },
  {
    _id: { $oid: '6a047c7560e3317f771d0a5e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Chennampally'
  },
  {
    _id: { $oid: '6a047c7523f9b467fef42553' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Narsimharapuram'
  },
  {
    _id: { $oid: '6a047c75416baf382cfbed26' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Singotam'
  },
  {
    _id: { $oid: '6a047c75656e96116e622e4f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Malachinthapally'
  },
  {
    _id: { $oid: '6a047c75c7581b97216b6b10' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Chinthalapally'
  },
  {
    _id: { $oid: '6a047c75b9e764be7c3e73c8' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Jawaipally'
  },
  {
    _id: { $oid: '6a047c7500eacd8a9f6cdbc6' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Ankiraopally'
  },
  {
    _id: { $oid: '6a047c753b8e0b47f7a336a5' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Narsingaraopally'
  },
  {
    _id: { $oid: '6a047c75a5aaead2f0f8bb44' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Ramanpur'
  },
  {
    _id: { $oid: '6a047c7598a2d39bd93c5561' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Ramapuram'
  },
  {
    _id: { $oid: '6a047c7586630d8f48adac2f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Somashila'
  },
  {
    _id: { $oid: '6a047c75adda36c533a99bad' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Bollaram'
  },
{
    _id: { $oid: '69ab08a8633cdb5e52f76d00' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Chenchugudem (Lachanayak)'
  },
  {
    _id: { $oid: '69ab08a8865b876e5baf691d' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Molachinthalapally'
  },
  {
    _id: { $oid: '69ab08a8d0a1ca194f22d188' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Tirnalapally'
  },
  {
    _id: { $oid: '69ab08a8690763ec5f2356f1' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Brhamaramba Chenchu Colony'
  },
  {
    _id: { $oid: '69ab08a816088240db4e3323' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Ellur Chenchu Gudem'
  },
  {
    _id: { $oid: '69ab08a88cf942828eb173b1' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Peddakarpamula'
  },
  {
    _id: { $oid: '69ab08a8b553af6d160b025b' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Marikal Chenchu'
  },
  {
    _id: { $oid: '69ab08a84a7967d1bfe717c6' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Maredumandinne'
  },
  {
    _id: { $oid: '69ab08a8d42d524283d44bcf' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Kollapur',
    village: 'Kotha Yapatla'
  },

  
  {
    _id: { $oid: '6a047f981873f1e97eb31526' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Ganeshpur'
  },
  {
    _id: { $oid: '6a047f988a2477d943a98b6e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Ramajipally'
  },
  {
    _id: { $oid: '6a047f98b54782f8bf4d3892' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Kondanagula'
  },
  {
    _id: { $oid: '6a047f984bb898838a15fafd' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Kodareddypally'
  },
  {
    _id: { $oid: '6a047f98dc4a583afbd90f5a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Billakal'
  },
  {
    _id: { $oid: '6a047f987143dcadba99da5f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Gattuthummain'
  },
  {
    _id: { $oid: '6a047f98520acf33334d1bb7' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Polepally'
  },
  {
    _id: { $oid: '6a047f98ea619b150f26d9ac' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Chennaram Pattigodal'
  },
  {
    _id: { $oid: '6a047f987d9a27313fca169a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Polishettipally'
  },
  {
    _id: { $oid: '6a047f98cefb77186c1acb39' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Mahadevpur'
  },
  {
    _id: { $oid: '6a047f98688113940d616a13' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Thummanpet'
  },
  {
    _id: { $oid: '6a047f98ec9b7512f710fe2c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Godal'
  },
  {
    _id: { $oid: '6a047f98b8788747765aa271' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Mylaram'
  },
  {
    _id: { $oid: '6a047f985245253820bf7e09' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Balmoor'
  },
  {
    _id: { $oid: '6a047f980ebfd0f86df6e687' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Narsaipally'
  },
  {
    _id: { $oid: '6a047f981cac86ff16ebe2cf' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Jillelapally'
  },
  {
    _id: { $oid: '6a047f98e8a863c480b9cefd' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Ananthavaram'
  },
  {
    _id: { $oid: '6a047f98094956c2b72cb87d' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Jinkunta'
  },
  {
    _id: { $oid: '6a047f985fba65c37fe0ed2e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Veeramrajupally'
  },
  {
    _id: { $oid: '6a047f983653222b4c34840a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Banala'
  },
  {
    _id: { $oid: '6a047f98d5aadf5ea7500c7c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Ambagiri'
  },
  {
    _id: { $oid: '6a047f989f1769db0c286468' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Ramgiri'
  },
{
    _id: { $oid: '69ab08383d895ea6cd374462' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Balmoor'
  },
  {
    _id: { $oid: '69ab08380b639bf7f8fc3e7c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Banala'
  },
  {
    _id: { $oid: '69ab083881eb3ee4ea4d3725' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Ambagiri'
  },
  {
    _id: { $oid: '69ab0838b3a979afaf7291ec' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Billakal'
  },
  {
    _id: { $oid: '69ab08387356c4de20f6bdf9' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Chenchugudem'
  },
  {
    _id: { $oid: '69ab083826925ceab6902961' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Balmoor',
    village: 'Gudibanda'
  },

  
  {
    _id: { $oid: '6a04802141349de68a5b1cc2' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Padara',
    village: 'Padara'
  },
  {
    _id: { $oid: '6a048021b23508f27adcd684' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Padara',
    village: 'Udimilla'
  },
  {
    _id: { $oid: '6a0480216f9e554e2201ee6e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Padara',
    village: 'Vankeshwaram'
  },
  {
    _id: { $oid: '6a0480219a6a11afa4e0be38' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Padara',
    village: 'Ippalapally'
  },
  {
    _id: { $oid: '6a048021220548386640e7c0' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Padara',
    village: 'Ganugapenta'
  },
  {
    _id: { $oid: '6a04802185ec4b825d27ed7c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Padara',
    village: 'Maddimadugu'
  },
  {
    _id: { $oid: '6a048021906162905eec8726' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Padara',
    village: 'Gudur'
  },
  {
    _id: { $oid: '6a04802108dd6d8ce1ea016e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Padara',
    village: 'Maradugu'
  },
{
    _id: { $oid: '69ab080b43806397aacff193' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Padara',
    village: 'Dhararam'
  },
  {
    _id: { $oid: '69ab080b8c39a2cabc377d34' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Padara',
    village: 'Pentrancheru'
  },
  {
    _id: { $oid: '69ab080b537424c65699e573' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Padara',
    village: 'Bapanpad'
  },
  {
    _id: { $oid: '69ab080b2b1b825d03d45afc' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Padara',
    village: 'Maddimadugu'
  },
  {
    _id: { $oid: '69ab080b2728f41f51fa3ce9' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Padara',
    village: 'Prasanthnagar Colony'
  },

  
  {
    _id: { $oid: '6a047ff65352bb9259132480' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Ambatpally'
  },
  {
    _id: { $oid: '6a047ff6e0a8e1d414b0115a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Rayavaram'
  },
  {
    _id: { $oid: '6a047ff6faf3da1c4f79c942' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Shainpet'
  },
  {
    _id: { $oid: '6a047ff60ec837764627680e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Lingal'
  },
  {
    _id: { $oid: '6a047ff6bbc5d9e5298c2da8' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Aousalikunta'
  },
  {
    _id: { $oid: '6a047ff6cd8460bed83dc477' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Jeelugupally'
  },
  {
    _id: { $oid: '6a047ff6a250bb6ff49c791c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Datharam'
  },
  {
    _id: { $oid: '6a047ff6549382046cf3c999' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Mukdhampur'
  },
  {
    _id: { $oid: '6a047ff66f340aaee4464fce' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Komatikunta'
  },
  {
    _id: { $oid: '6a047ff63c54216e31ff83d3' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Manajipet'
  },
  {
    _id: { $oid: '6a047ff6f8622dea185535a3' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Kothakuntapally'
  },
  {
    _id: { $oid: '6a047ff656e82d6dd228a138' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Rampur'
  },
  {
    _id: { $oid: '6a047ff65a6381bca050684f' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Madapur'
  },
  {
    _id: { $oid: '6a047ff6299e6da755b33fb8' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Surapur'
  },
  {
    _id: { $oid: '6a047ff6ea744b2bcaa028ea' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Bakaram'
  },
  {
    _id: { $oid: '6a047ff6f71c35aeac7a2922' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Vallabhapur'
  },
  {
    _id: { $oid: '6a047ff69a3c1d82a1fb432e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Chandapur'
  },
  {
    _id: { $oid: '6a047ff676be329a15758384' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Rangayipally'
  },
{
    _id: { $oid: '69ab07644f130542aff51778' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Thummanpenta'
  },
  {
    _id: { $oid: '69ab0764a0894880ad58a143' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Yerrapenta'
  },
  {
    _id: { $oid: '69ab076498fa6929412686e8' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Appapur Penta'
  },
  {
    _id: { $oid: '69ab0764ad84cee895dee0f2' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Lingal',
    village: 'Srirangapur'
  },

  
  {
    _id: { $oid: '6a047b68ee07ea699b7a6e0c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Amrabad'
  },
  {
    _id: { $oid: '6a047b68f7da4b049aad23eb' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Brahmagiri'
  },
  {
    _id: { $oid: '6a047b685a39626e832c7686' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Jangam Reddy Pally'
  },
  {
    _id: { $oid: '6a047b6842000d3565327547' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Kalvanonipally'
  },
  {
    _id: { $oid: '6a047b68c44181c65e8dd1ff' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Kothapally'
  },
  {
    _id: { $oid: '6a047b68d703ea9a2d996548' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Kummaronipally'
  },
  {
    _id: { $oid: '6a047b68d7dbd659538a0b53' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Kudchintlabailu'
  },
  {
    _id: { $oid: '6a047b68c16cf289df45209a' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Laxmapoor (Bk)'
  },
  {
    _id: { $oid: '6a047b6811ac481eb706bef3' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Laxmapur Thanda'
  },
  {
    _id: { $oid: '6a047b681e6a337183f77454' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Macharam'
  },
  {
    _id: { $oid: '6a047b68a5ecae70069e5641' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Madhavanipally'
  },
  {
    _id: { $oid: '6a047b685dbdf9fd04fabcbf' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Mallapur Penta'
  },
  {
    _id: { $oid: '6a047b680eb968afbdc64f6e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Mannanoor'
  },
  {
    _id: { $oid: '6a047b68e38f3ca0ffaad342' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Prashanth Colony'
  },
  {
    _id: { $oid: '6a047b689862450778e8e43d' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Sarlapally'
  },
  {
    _id: { $oid: '6a047b681e70f3fd89983bdd' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Telugupally'
  },
  {
    _id: { $oid: '6a047b6889b9443cea363bd3' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Thirumalapoor'
  },
  {
    _id: { $oid: '6a047b6886784fcb5eb74865' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Thurkapally'
  },
  {
    _id: { $oid: '6a047b68a0753ef0e5078636' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Uppununthala'
  },
  {
    _id: { $oid: '6a047b68b9af21f9307df4d9' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Vangooronipally'
  },
  {
    _id: { $oid: '6a047b68e75798dcbae66ada' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Vattavarlapally'
  },
  {
    _id: { $oid: '6a047b68a51e89f038d9ba4e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Venkaswarla Bavi'
  },
{
    _id: { $oid: '69ab072e312dea664f931009' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Sarlapally'
  },
  {
    _id: { $oid: '69ab072e8d797de7624c8d40' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Mallapurpenta'
  },
  {
    _id: { $oid: '69ab072ea5b0e694eeedb451' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Jangamreddypally'
  },
  {
    _id: { $oid: '69ab072e120e48b25d102d43' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Venkateshwarla Bavi'
  },
  {
    _id: { $oid: '69ab072e90660dbe62dbbf5e' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Watervarlapally'
  },
  {
    _id: { $oid: '69ab072e5eef6358a936bd29' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Mannanoor'
  },
  {
    _id: { $oid: '69ab072e970308c16628ecaf' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Macharam'
  },
  {
    _id: { $oid: '69ab072e75351507e8aa97f6' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Tirmalapur'
  },
  {
    _id: { $oid: '69ab072ea0dc7279a12fb1d2' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Laxmapur'
  },
  {
    _id: { $oid: '69ab072e8de4e517a52f2b13' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'B.K. Uppununthala'
  },
  {
    _id: { $oid: '69ab072ead47610a860f311c' },
    state: 'Telangana',
    district: 'Nagarkurnool',
    block: 'Amrabad',
    village: 'Kotham Penta'
  },

  {
    _id: { $oid: '699e85853e3cc9b7d7fed68e' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Dantewada',
    village: 'Bhairam Bhar'
  },
  {
    _id: { $oid: '699e85853f5fb1acc22c2254' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Dantewada',
    village: 'Teeknar'
  },

  {
    _id: { $oid: '6986e97f2e0f2f48fdf5d555' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Ghotpal'
  },
  {
    _id: { $oid: '6986e97f286e11f7a03c60ea' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Bade Panera'
  },
  {
    _id: { $oid: '6986e97ff5e0f2facfc45f33' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Hiranar'
  },
  {
    _id: { $oid: '696488c89ce6319a75bf236a' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Geedam'
  },
  {
    _id: { $oid: '696488c89afc34e604e871d7' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Budhpadar'
  },
  {
    _id: { $oid: '696488c847e2c9b30b8e2e90' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Gunda'
  },
  {
    _id: { $oid: '696488c89656f5b3450df3b1' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Harla'
  },
  {
    _id: { $oid: '696488c86e19ed7a4b3a44c0' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Jofatorai'
  },
  {
    _id: { $oid: '696488c8603e3089d41697fd' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Karli'
  },
  {
    _id: { $oid: '696488c80300876e5785a100' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Kasoli'
  },
  {
    _id: { $oid: '696488c84a54d63d476912b5' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Mustalnar'
  },
  {
    _id: { $oid: '696488c863ad10dca2828f0b' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Naglei'
  },
  {
    _id: { $oid: '696488c8ba9478f6fff51bce' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Norli'
  },
  {
    _id: { $oid: '696488c81bf128bd9e23b0f3' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Pahurnar'
  },
  {
    _id: { $oid: '696488c87c5c55f22407298c' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Ronje'
  },
  {
    _id: { $oid: '696488c8ea725163705f937b' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Sonarpara'
  },
  {
    _id: { $oid: '696488c8ab94f4620f88d7a8' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Tumrigunda'
  },
  {
    _id: { $oid: '696488c8fcc27cb012062dc2' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Bijam'
  },
  {
    _id: { $oid: '696488c895ee94f5d22ddcaa' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Aalnar'
  },
  {
    _id: { $oid: '696488c803e966885730250d' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Masodi'
  },
  {
    _id: { $oid: '696488c804cda8a0fcee735d' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Kundenar'
  },
  {
    _id: { $oid: '696488c8110ccbd2c099b25a' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Siyanar'
  },
  {
    _id: { $oid: '696488c81d6e2b996b867b6c' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Bade Surokhi'
  },
  {
    _id: { $oid: '696488c829b8b4be3a159af0' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Faraspal'
  },
  {
    _id: { $oid: '696488c822d11a6228da1860' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Baugapal'
  },
  {
    _id: { $oid: '696488c81286ae31ccecddec' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Munder'
  },
  {
    _id: { $oid: '696488c8f12b2e5dece117a1' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Samloor'
  },
  {
    _id: { $oid: '696488c88e7f95269dc663fe' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Jhodiyabadam'
  },
  {
    _id: { $oid: '696488c8fe8e09d9bcf193be' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Kutulnar'
  },

  {
    _id: { $oid: '69648831da7901c869799539' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Badegodre'
  },
  {
    _id: { $oid: '69648831d0e888c6fa5fee86' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Badekameli'
  },
  {
    _id: { $oid: '69648831e87fed844f980cbb' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Bainpal'
  },
  {
    _id: { $oid: '69648831c13e1ccc3c40b965' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Balood'
  },
  {
    _id: { $oid: '69648831d6c40a565f836969' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Balpet'
  },
  {
    _id: { $oid: '69648831ca569685fbc1b4db' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Basanpur'
  },
  {
    _id: { $oid: '69648831b49d170998eb1fae' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Behnar'
  },
  {
    _id: { $oid: '69648831acdb6500ad478b32' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Bhairamband'
  },
  {
    _id: { $oid: '6964883100eaba029253367f' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Bhansi'
  },
  {
    _id: { $oid: '696488317db967dd66d1eb12' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Bhogam'
  },
  {
    _id: { $oid: '69648831eb844be099c5b028' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Chandenar'
  },
  {
    _id: { $oid: '69648831bfa29b9b95564f65' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Chhotegodre'
  },
  {
    _id: { $oid: '6964883111564e774d32f792' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Chitalanka'
  },
  {
    _id: { $oid: '69648831eac5036cd1bb68eb' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Chitaloor'
  },
  {
    _id: { $oid: '696488315cc1c2cf5ad38dae' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Cholnar(Siwanapdar)'
  },
  {
    _id: { $oid: '69648831e55737c51a963d4a' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Dabpal'
  },
  {
    _id: { $oid: '6964883178c30b0d268d9c89' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Dantewada (NP)'
  },
  {
    _id: { $oid: '6964883125e404f7141f8e2e' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Degalras'
  },
  {
    _id: { $oid: '69648831348b000a9e80237b' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Dhurli'
  },
  {
    _id: { $oid: '69648831b7a0483ababa0b26' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Dugeli'
  },
  {
    _id: { $oid: '69648831c44be1916c700624' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Dumam'
  },
  {
    _id: { $oid: '69648831c46f28d77dc4a7ab' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Fulnar'
  },
  {
    _id: { $oid: '696488312fa76f2b361302c8' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Gadapal'
  },
  {
    _id: { $oid: '69648831356452594cecc29e' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Gamawada'
  },
  {
    _id: { $oid: '696488310efc10ee1124c0a6' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Ganjenar'
  },
  {
    _id: { $oid: '6964883140a3a0be3cb342da' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Gondpal'
  },
  {
    _id: { $oid: '696488319c4c99c0043b4749' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Jaram'
  },
  {
    _id: { $oid: '696488311fb29f0f52b6e692' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Jharalawa'
  },
  {
    _id: { $oid: '696488319ad33faf48cc0301' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Jhirka'
  },
  {
    _id: { $oid: '69648831112c67867d99d448' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Kamaloor'
  },
  {
    _id: { $oid: '696488318cca73c02e3e7bbe' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Karnjener'
  },
  {
    _id: { $oid: '6964883111a323c598bf7da9' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Kawadgaon'
  },
  {
    _id: { $oid: '6964883156caadbf16be53b1' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Kawalnar'
  },
  {
    _id: { $oid: '69648831a5200bcad771d6c9' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Keshapur'
  },
  {
    _id: { $oid: '696488318d129bfd18da9285' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Kuhchepal'
  },
  {
    _id: { $oid: '69648831ed207af0b39afa8c' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Kumharras'
  },
  {
    _id: { $oid: '696488314f3d2222dbe65c4d' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Kundeli'
  },
  {
    _id: { $oid: '6964883151d785893c71d56c' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Kuper'
  },
  {
    _id: { $oid: '696488317ccdea22562a242c' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Mangnar'
  },
  {
    _id: { $oid: '69648831726232b0b7c13926' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Masenar'
  },
  {
    _id: { $oid: '6964883184cac0822e44ac3a' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Matenar'
  },
  {
    _id: { $oid: '69648831e2cd348f8bd2ec8e' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Mendoli'
  },
  {
    _id: { $oid: '69648831006402d2982bf626' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Metapal'
  },
  {
    _id: { $oid: '69648831e3b488f746c0767a' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Midkulnar'
  },
  {
    _id: { $oid: '69648831ab212e1b68dc530a' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Molasnar'
  },
  {
    _id: { $oid: '696488310166558539c2d8a0' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Murki'
  },
  {
    _id: { $oid: '69648831f36c37960c36178d' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Muskel'
  },
  {
    _id: { $oid: '69648831525d8b594153363e' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Nerli'
  },
  {
    _id: { $oid: '69648831f4153fcd496fe1f8' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Netapur'
  },
  {
    _id: { $oid: '696488311407e352bc8c07c3' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Padhapur'
  },
  {
    _id: { $oid: '69648831d997c6e16b5d701c' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Pandewar'
  },
  {
    _id: { $oid: '696488319eae14589ed602d5' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Pinabacheli'
  },
  {
    _id: { $oid: '696488310ad9d4151e7c4914' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Pondum'
  },
  {
    _id: { $oid: '6964883118f51c18751378e6' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Porokameli'
  },
  {
    _id: { $oid: '6964883126a05c966f884e78' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Purantarai'
  },
  {
    _id: { $oid: '696488311113eab0a01259bc' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Rewnar'
  },
  {
    _id: { $oid: '696488313c42971af4ed0cd0' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Teknar'
  },
  {
    _id: { $oid: '69648831855c069b9e406bdf' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Toylanka'
  },
  {
    _id: { $oid: '696488314fa236a968fc1971' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Tudparas'
  },
  {
    _id: { $oid: '696488311a315e7ac2400160' },
    state: 'Chhattisgarh',
    district: 'Dantewada',
    block: 'Geedam',
    village: 'Udela'
  },

  {
    _id: { $oid: '69a70241240acb2b9a31cd85' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Vijravan'
  },
  {
    _id: { $oid: '69a7024195517456e98e07cc' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Dargany'
  },
  {
    _id: { $oid: '69a702411aa76acc32e24383' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Kanti'
  },
  {
    _id: { $oid: '6961e01124e966c3ed59e12d' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Aparwal'
  },
  {
    _id: { $oid: '6961e011939caab35bea464a' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Bachhoda Bhata'
  },
  {
    _id: { $oid: '6961e01124498fd830fca09e' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Bachhoda Khas'
  },
  {
    _id: { $oid: '6961e0117710e4c61368c0a8' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Bagoura'
  },
  {
    _id: { $oid: '6961e011f1cd3d2aefc51c19' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Baharo Tal'
  },
  {
    _id: { $oid: '6961e011d4d33594e72fd5b7' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Baidora Khas'
  },
  {
    _id: { $oid: '6961e011da7483d2ab2ebf2c' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Baiwarjangal'
  },
  {
    _id: { $oid: '6961e0114b3500744f178d5d' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Baiwarkhas'
  },
  {
    _id: { $oid: '6961e011478bb287ee0153cc' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Bajetpura'
  },
  {
    _id: { $oid: '6961e0112b08670421a7b1c9' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Baldeopura'
  },
  {
    _id: { $oid: '6961e0113b81f462e0925bf4' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Bamhori Abda'
  },
  {
    _id: { $oid: '6961e011f014f455a4442b68' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Bamhori Khas'
  },
  {
    _id: { $oid: '6961e011c301c52d2cecec97' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Bandarguda'
  },
  {
    _id: { $oid: '6961e0112125939d4c118e83' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Barmadang Bhata'
  },
  {
    _id: { $oid: '6961e011f69545360d24956f' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Barmadang Khas'
  },
  {
    _id: { $oid: '6961e0119d3bf2cc5d52ef9a' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Barmamanjh'
  },
  {
    _id: { $oid: '6961e011a01a62c02854d5aa' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Barmatal'
  },
  {
    _id: { $oid: '6961e011633441d641875815' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Bijrotha'
  },
  {
    _id: { $oid: '6961e011150c9a6f3d9dced1' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Bilgay Bhata'
  },
  {
    _id: { $oid: '6961e011ecb0b387261c2bee' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Bilgay Khas'
  },
  {
    _id: { $oid: '6961e01166193b591de904bb' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Chandaua Khera'
  },
  {
    _id: { $oid: '6961e011bc02978f37088b2d' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Chandera Khas'
  },
  {
    _id: { $oid: '6961e0115d8a9fac8fc989ca' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Chandera Ugad'
  },
  {
    _id: { $oid: '6961e0110a9179b1a9464657' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Chandrapura'
  },
  {
    _id: { $oid: '6961e011f1415ea4881fab9f' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Chaturkari'
  },
  {
    _id: { $oid: '6961e011ff70310b8af4c9fa' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Chhipri'
  },
  {
    _id: { $oid: '6961e0113ab58e9eb98c1812' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Dalupura'
  },
  {
    _id: { $oid: '6961e0119b25102f9e46af79' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Devkha'
  },
  {
    _id: { $oid: '6961e0117ba62efd62d9090e' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Deopur'
  },
  {
    _id: { $oid: '6961e0111bd87605e8234921' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Deoraha'
  },
  {
    _id: { $oid: '6961e011faf38011df53259a' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Dhamna Bhata'
  },
  {
    _id: { $oid: '6961e0119fe46b7335d4feea' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Dhamna Khas'
  },
  {
    _id: { $oid: '6961e011d32152329701b0d5' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Dharampura'
  },
  {
    _id: { $oid: '6961e0115f1e383670549970' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Digoda'
  },
  {
    _id: { $oid: '6961e0118418d756a4d932a0' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Dor'
  },
  {
    _id: { $oid: '6961e011893b1b530f133c45' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Eshon'
  },
  {
    _id: { $oid: '6961e011ba49ee785dec93d1' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Firojpura Bhata'
  },
  {
    _id: { $oid: '6961e011eda0d613b6c6320c' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Firojpura Khas'
  },
  {
    _id: { $oid: '6961e01197a0199891eec760' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Garroli'
  },
  {
    _id: { $oid: '6961e011c2249788337592c1' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Gotet Khas'
  },
  {
    _id: { $oid: '6961e01155919549191dbeff' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Gotet Ugad'
  },
  {
    _id: { $oid: '6961e011c41da510a5e574f1' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Guda Nadi'
  },
  {
    _id: { $oid: '6961e011ac9d6b9a4b310284' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Harpura'
  },
  {
    _id: { $oid: '6961e0111a615ffb5fa1b61d' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Hirdenager'
  },
  {
    _id: { $oid: '6961e011e4dc3f41ec7e12ad' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Hunarganj'
  },
  {
    _id: { $oid: '6961e011351a787be8384461' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Janakpur Bhata'
  },
  {
    _id: { $oid: '6961e0116574657046dbb596' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Janakpur Khas'
  },
  {
    _id: { $oid: '6961e0112c8a5a1e496f7246' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Jatara (NP)'
  },
  {
    _id: { $oid: '6961e011e84a291adb7668f3' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Jauwa'
  },
  {
    _id: { $oid: '6961e0112f87943989d5b4f9' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Kamal Nagar'
  },
  {
    _id: { $oid: '6961e0111ec349718d091633' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Kandwa'
  },
  {
    _id: { $oid: '6961e0119ed20e19d36cd180' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Kari Uttari'
  },
  {
    _id: { $oid: '6961e0118ccfe782b2e087d9' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Karibhata'
  },
  {
    _id: { $oid: '6961e011f2b3b798a937a5d2' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Karmaura'
  },
  {
    _id: { $oid: '6961e0111c259e8f96123245' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Kharoi'
  },
  {
    _id: { $oid: '6961e011ef1520c9b9269d7f' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Kitakhera'
  },
  {
    _id: { $oid: '6961e01144e92025c58db66f' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Kurrai'
  },
  {
    _id: { $oid: '6961e011f78c56ec099cee77' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Kuwarpura'
  },
  {
    _id: { $oid: '6961e0113aa369899c1b115d' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Lakhraun'
  },
  {
    _id: { $oid: '6961e0117695839f04fc59dc' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Larkhurd'
  },
  {
    _id: { $oid: '6961e0115f2fec5a1a760a83' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Lidhora Khas (NP)'
  },
  {
    _id: { $oid: '6961e01157cd8424a68fd1d5' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Lidhouratal'
  },
  {
    _id: { $oid: '6961e011d82770519ce36dc3' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Luharguwa Khas'
  },
  {
    _id: { $oid: '6961e0111bdbc8be5ee7e3b3' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Luharguwan Bhata'
  },
  {
    _id: { $oid: '6961e011a282a0f5ec3d83d6' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Machora'
  },
  {
    _id: { $oid: '6961e01138e388ec546a1901' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Mahuabag'
  },
  {
    _id: { $oid: '6961e011d8c97f67f332ecfe' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Manchi'
  },
  {
    _id: { $oid: '6961e01108109a47c42e827d' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Marguwa'
  },
  {
    _id: { $oid: '6961e011bd197ee14d6cec68' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Mathupura'
  },
  {
    _id: { $oid: '6961e011576ab34def243de9' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Matol'
  },
  {
    _id: { $oid: '6961e0113a6bcd04fed64256' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Mau Bujurg Bhata'
  },
  {
    _id: { $oid: '6961e011e9fe2e59e01a51ed' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Mau Bujurg Khas'
  },
  {
    _id: { $oid: '6961e011e1e6dbcfbace3975' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Muhara Jangal'
  },
  {
    _id: { $oid: '6961e01144e2dc3f9c81f2c4' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Muhara Khas'
  },
  {
    _id: { $oid: '6961e011df91bc0fa0fd53c7' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Panyara Khera'
  },
  {
    _id: { $oid: '6961e0118db42de597278574' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Partappura'
  },
  {
    _id: { $oid: '6961e0112cd93a6cca8d4ce2' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Pathar'
  },
  {
    _id: { $oid: '6961e011f6e9b8208e9f3d65' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Pathara'
  },
  {
    _id: { $oid: '6961e01181e2a3f23a718269' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Petpura'
  },
  {
    _id: { $oid: '6961e01196e45a5a64b0ef8f' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Phateh Ka Khirak'
  },
  {
    _id: { $oid: '6961e011afe168bad7402037' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Piprat'
  },
  {
    _id: { $oid: '6961e011a523afba542dbc4c' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Punaul Khas'
  },
  {
    _id: { $oid: '6961e011f6fc940e78ef1bb4' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Punolhar'
  },
  {
    _id: { $oid: '6961e0110f801d03c4c14966' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Raghunathpura'
  },
  {
    _id: { $oid: '6961e011f82c4465052c0873' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Rajnagar'
  },
  {
    _id: { $oid: '6961e011e5a8383083b558c5' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Ramgarh'
  },
  {
    _id: { $oid: '6961e01105439cc65e7d3db0' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Ramnagar'
  },
  {
    _id: { $oid: '6961e011fbe5214045ff7dc0' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Raniganj'
  },
  {
    _id: { $oid: '6961e011324a9518c033e76e' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Ratangunwan Bhata'
  },
  {
    _id: { $oid: '6961e0112fc4cbbb139fbff8' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Ratangunwan Khas'
  },
  {
    _id: { $oid: '6961e011a7eae336b0b78008' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Roopganj'
  },
  {
    _id: { $oid: '6961e0110264382ae75aa2aa' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Satguwan Khas'
  },
  {
    _id: { $oid: '6961e0119ffde6f4c18e0371' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Satguwan Ugad'
  },
  {
    _id: { $oid: '6961e011215a9cfe8842ead0' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Serai'
  },
  {
    _id: { $oid: '6961e011ccd80cca9fab37b5' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Sevakhera'
  },
  {
    _id: { $oid: '6961e011e5e7916c2f64e8aa' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Shah'
  },
  {
    _id: { $oid: '6961e011466a895496f07b16' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Shahpur'
  },
  {
    _id: { $oid: '6961e0110db79dba22879373' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Shivpura'
  },
  {
    _id: { $oid: '6961e0116d2442830b7b1289' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Simariya'
  },
  {
    _id: { $oid: '6961e01174807625f35b3718' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Sitapur'
  },
  {
    _id: { $oid: '6961e0119df7e633e7034512' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Tanga'
  },
  {
    _id: { $oid: '6961e01143f4687149bfe5da' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Vaidau'
  },
  {
    _id: { $oid: '6961e0119c103f2c4ad39b3e' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Vaidora Jangal'
  },
  {
    _id: { $oid: '6961e011b3e8b8c921a145b1' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Vaidpur'
  },
  {
    _id: { $oid: '6961e011b76464497cb9c1d4' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Varana Khas'
  },
  {
    _id: { $oid: '6961e011b20ad8f2dbffc229' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Varanatal'
  },
  {
    _id: { $oid: '6961e011981db7e3397640f4' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Verau'
  },
  {
    _id: { $oid: '6961e0115888c9f3a1f2a17f' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Vijaypur'
  },
  {
    _id: { $oid: '6961e0115fb58f4d2c735da4' },
    state: 'Madhya Pradesh',
    district: 'Tikamgarh',
    block: 'Jatara',
    village: 'Vikrampura'
  },


  {
    _id: { $oid: '6943dcf685ebce8ffce096ac' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Anjoda'
  },
  {
    _id: { $oid: '6943dcf6bcf1778b95fc95ab' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Antriguda'
  },
  {
    _id: { $oid: '6943dcf6945d437a1d13d639' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Araku'
  },
  {
    _id: { $oid: '6943dcf69475e639e4ce5ada' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Arama'
  },
  {
    _id: { $oid: '6943dcf6eee4b73bc2989190' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Badiyapadu'
  },
  {
    _id: { $oid: '6943dcf678d300a8651ee5be' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Bairaguda'
  },
  {
    _id: { $oid: '6943dcf66177d4f9cb06c59e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Billaputtu'
  },
  {
    _id: { $oid: '6943dcf68e01ce48b7ac71e4' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Bitragonda'
  },
  {
    _id: { $oid: '6943dcf60636ea7fb1ca59ff' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Boddaputtu'
  },
  {
    _id: { $oid: '6943dcf64ce9dbf5f77e3013' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Bodimela'
  },
  {
    _id: { $oid: '6943dcf6bf9e4a071bf274a6' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Borrapalem'
  },
  {
    _id: { $oid: '6943dcf6023e534cb3c2b753' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Chamadapadu'
  },
  {
    _id: { $oid: '6943dcf626687b2f578d3b83' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Champaputtu'
  },
  {
    _id: { $oid: '6943dcf60bc0b6f4d05fd317' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Chelimarivalasa'
  },
  {
    _id: { $oid: '6943dcf6644a897f08657d78' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Chinakaguvalasa'
  },
  {
    _id: { $oid: '6943dcf6d6d8d575c474ee34' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Dathuru'
  },
  {
    _id: { $oid: '6943dcf61709d80b9868c695' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Demuduvalasa'
  },
  {
    _id: { $oid: '6943dcf686f4f012bb7a6d4b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Dondalavalasa'
  },
  {
    _id: { $oid: '6943dcf6c2511ffed1be6150' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Dumbriguda'
  },
  {
    _id: { $oid: '6943dcf69f22d31853a28c3a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Gadabagolugu'
  },
  {
    _id: { $oid: '6943dcf6e108885a2a83a730' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Gandha'
  },
  {
    _id: { $oid: '6943dcf6ea605c42ef5d325e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Gasaba'
  },
  {
    _id: { $oid: '6943dcf6857c5aff439f5253' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Gatharagilleda'
  },
  {
    _id: { $oid: '6943dcf66d08355777d6f2b2' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Godasortu'
  },
  {
    _id: { $oid: '6943dcf643692cb3634b56af' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Gondiguda'
  },
  {
    _id: { $oid: '6943dcf68e81315c367873b7' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Gondivalasa'
  },
  {
    _id: { $oid: '6943dcf64dd08feaf57c851c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Goppilivalasa'
  },
  {
    _id: { $oid: '6943dcf6cdbc74e94e982cec' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Gorapur'
  },
  {
    _id: { $oid: '6943dcf6f654dee9d81424c0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Guntagannela'
  },
  {
    _id: { $oid: '6943dcf6a0572b1bff486f0d' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Guntaseema'
  },
  {
    _id: { $oid: '6943dcf6488ad42e7a5c6d9a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Jamguda'
  },
  {
    _id: { $oid: '6943dcf6d3bdefc283e78e53' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Jurripadu'
  },
  {
    _id: { $oid: '6943dcf6bc4c1c492f68daac' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Kamalabanda'
  },
  {
    _id: { $oid: '6943dcf697d15409c4bf2ef7' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Kandram'
  },
  {
    _id: { $oid: '6943dcf65245cc02444557a5' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Karakavalasa'
  },
  {
    _id: { $oid: '6943dcf658fdf69d9f1a9506' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Kinchumanda'
  },
  {
    _id: { $oid: '6943dcf640f95d0d7351d158' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Kinjeru'
  },
  {
    _id: { $oid: '6943dcf6e99aa3b36ae607df' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Kiridivalasa'
  },
  {
    _id: { $oid: '6943dcf6272fd748d745d734' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Kithalangi'
  },
  {
    _id: { $oid: '6943dcf6f3bc0e06af0b0117' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Kollaputtu'
  },
  {
    _id: { $oid: '6943dcf6f177e55a48022a2c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Koranjiguda'
  },
  {
    _id: { $oid: '6943dcf6ae58842de4de7a04' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Korra'
  },
  {
    _id: { $oid: '6943dcf61b24b0a3996f78cc' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Korrai'
  },
  {
    _id: { $oid: '6943dcf637399b6ab8d6f82c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Kosangi'
  },
  {
    _id: { $oid: '6943dcf6dfd0829fad08bd93' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Kotragondi'
  },
  {
    _id: { $oid: '6943dcf6bfb91f9ac9423bb7' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Kuda'
  },
  {
    _id: { $oid: '6943dcf6b04c898c8271bdf6' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Kujabangi'
  },
  {
    _id: { $oid: '6943dcf638b46e14e715d0ba' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Kuridi'
  },
  {
    _id: { $oid: '6943dcf6363e27d31f90cf9d' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Kusumavalasa'
  },
  {
    _id: { $oid: '6943dcf639f2e4201912cc7e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Kutti'
  },
  {
    _id: { $oid: '6943dcf6d23307e4d1888a34' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Lakka'
  },
  {
    _id: { $oid: '6943dcf675b308eb1163676a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Livitiputtu'
  },
  {
    _id: { $oid: '6943dcf60ec2f8d45f42c681' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Logili'
  },
  {
    _id: { $oid: '6943dcf6d6ee1d0ec2805a95' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Lyganda'
  },
  {
    _id: { $oid: '6943dcf6a9cb6f7a7ed4922a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Malinguvalasa'
  },
  {
    _id: { $oid: '6943dcf6c206c42992c5465b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Mallivalasa'
  },
  {
    _id: { $oid: '6943dcf634fcd2c8863b0a3f' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Mamidivalasa'
  },
  {
    _id: { $oid: '6943dcf62a3327311426ab70' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Morriguda'
  },
  {
    _id: { $oid: '6943dcf69ad823490cf43304' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Musiri'
  },
  {
    _id: { $oid: '6943dcf62813877c443b36c1' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Nandiguda'
  },
  {
    _id: { $oid: '6943dcf6bf7543a522a3cfb3' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Nandivalasa'
  },
  {
    _id: { $oid: '6943dcf6699645e8a44211de' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Nimmagedda'
  },
  {
    _id: { $oid: '6943dcf68bef348bd56145f4' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Ombi'
  },
  {
    _id: { $oid: '6943dcf6e21485782fdc2431' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Padi'
  },
  {
    _id: { $oid: '6943dcf66f93894b70ac7c0c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Panasavalasa'
  },
  {
    _id: { $oid: '6943dcf6bf418d4031de4dfc' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Pantalachinta'
  },
  {
    _id: { $oid: '6943dcf63e7b9d61996ab52d' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Paridi'
  },
  {
    _id: { $oid: '6943dcf62b746d18a9443436' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Pariseela'
  },
  {
    _id: { $oid: '6943dcf6b5013a6dc9dfe5aa' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Pedapadu'
  },
  {
    _id: { $oid: '6943dcf62763fcb71d9abbe6' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Pothangi'
  },
  {
    _id: { $oid: '6943dcf68f054f6bd7c5ac89' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Rangilisingi'
  },
  {
    _id: { $oid: '6943dcf6c45cd3383065b247' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Ranginiguda'
  },
  {
    _id: { $oid: '6943dcf6efdcee36b4da3ad6' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Ranginivalasa'
  },
  {
    _id: { $oid: '6943dcf6b53151db564314ae' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Sagara'
  },
  {
    _id: { $oid: '6943dcf6c7e976485098f982' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Sagirivalasa'
  },
  {
    _id: { $oid: '6943dcf6454e53a4e331d9ec' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Sangamvalasa'
  },
  {
    _id: { $oid: '6943dcf634d5df25e056a46e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Sarai'
  },
  {
    _id: { $oid: '6943dcf6e7aa066551e50cab' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Seelamgondi'
  },
  {
    _id: { $oid: '6943dcf6aded743632bc0d9d' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Sornayakguda @ Surusyaguda'
  },
  {
    _id: { $oid: '6943dcf6f1495adb22625bc3' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Sovva'
  },
  {
    _id: { $oid: '6943dcf6a31182dfaf57c25b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Thotavalasa'
  },
  {
    _id: { $oid: '6943dcf62cb0224173dba3e0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Thutangi'
  },
  {
    _id: { $oid: '6943dcf60b917ea9b4c08798' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Ujjangi'
  },
  {
    _id: { $oid: '6943dcf61725ad50b1d9ec23' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Uyyalaputtu'
  },
  {
    _id: { $oid: '6943dcf6d58b3ae698fc8bf8' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Vadiyavalasa @ Vaddevalasa'
  },
  {
    _id: { $oid: '6943dcf688e1618a67a3c0ef' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Vantharla'
  },
  {
    _id: { $oid: '6943dcf649cd0d4cc6bb63d0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Vasabanda'
  },
  {
    _id: { $oid: '6943dcf69b34a227c5bb4f2f' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Dumbriguda',
    village: 'Vayya'
  },

  {
    _id: { $oid: '692a9cdbd72ebdbf4ec43fc1' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Dhone',
    village: 'Chanugondla'
  },
  {
    _id: { $oid: '692a9cdbf6926add7874e77f' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Dhone',
    village: 'Devarabanda'
  },
  {
    _id: { $oid: '692a9cdbcec1d07fb68a37ff' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Dhone',
    village: 'Dhone'
  },
  {
    _id: { $oid: '692a9cdbde023f4b3bba84a6' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Dhone',
    village: 'Eddupenta'
  },
  {
    _id: { $oid: '692a9cdb128d0bee37ea7a3d' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Dhone',
    village: 'Jagadurthi'
  },
  {
    _id: { $oid: '692a9cdb1d7ad470c71c37da' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Dhone',
    village: 'Kamaganikuntla'
  },
  {
    _id: { $oid: '692a9cdb255e99fe960bd4e7' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Dhone',
    village: 'Kocheruvu'
  },
  {
    _id: { $oid: '692a9cdbd571d4cb9323bba0' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Dhone',
    village: 'Kotha Buruju'
  },
  {
    _id: { $oid: '692a9cdbc29db90883ed23a4' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Dhone',
    village: 'Kothakota'
  },
  {
    _id: { $oid: '692a9cdb9759efab0014fa29' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Dhone',
    village: 'Malkapuram'
  },
  {
    _id: { $oid: '692a9cdbb0fce04e75c99389' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Dhone',
    village: 'Shotrium'
  },
  {
    _id: { $oid: '692a9cdbebeddc5c90d7181d' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Dhone',
    village: 'Udumulapadu'
  },
  {
    _id: { $oid: '692a9cdbdb7bb13f936145b1' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Dhone',
    village: 'Ungaranigundla'
  },
  {
    _id: { $oid: '692a9cdbb08dcff05801d2f7' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Dhone',
    village: 'Venkatapuram'
  },
  {
    _id: { $oid: '692a9cdb96dcd0fc0d569f87' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Dhone',
    village: 'Yapadinne'
  },

  {
    _id: { $oid: '6924150e8879844ef30b74bd' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Burugula'
  },
  {
    _id: { $oid: '6924150e084732e669e2a524' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Chandrapalle'
  },
  {
    _id: { $oid: '6924150e60521003cdc66388' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Gudipadu'
  },
  {
    _id: { $oid: '6924150ed327d0fccac7ada7' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Jakkasanikuntla'
  },
  {
    _id: { $oid: '6924150ef78305db9a65494d' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Jaladurgam'
  },
  {
    _id: { $oid: '6924150ec9b54947efea3b77' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Kalachetla'
  },
  {
    _id: { $oid: '6924150e45284ec65a8227e0' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Kommemarri'
  },
  {
    _id: { $oid: '6924150ecaf2f3a9a24b0063' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Madhavaram'
  },
  {
    _id: { $oid: '6924150e50b8c06f8ec7e4f7' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Mettupalle'
  },
  {
    _id: { $oid: '6924150ef1bb485ef594ad14' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Munimadugu'
  },
  {
    _id: { $oid: '6924150e8139170933b1768e' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Nereducherla'
  },
  {
    _id: { $oid: '6924150e664be3a921a7dee8' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Peapally'
  },
  {
    _id: { $oid: '6924150e3ae4f0f9cd1d9dab' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Peddapodilla'
  },
  {
    _id: { $oid: '6924150e67a993205052a1f5' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Pothidoddi'
  },
  {
    _id: { $oid: '6924150eeaa34db918540545' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Racherla'
  },
  {
    _id: { $oid: '6924150e4e598179a67a91e0' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Shrotrium Nallaballe'
  },
  {
    _id: { $oid: '6924150e8c5610c8d30a1bf1' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Shrotrium Rangapuram'
  },
  {
    _id: { $oid: '6924150e7d96f445c0e100dc' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Peapully',
    village: 'Vengalampalle'
  },


  {
    _id: { $oid: '692414d49983de56b4df7afa' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Mahanandhi',
    village: 'Basavapuram'
  },
  {
    _id: { $oid: '692414d4bd50ef1f610e2ad0' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Mahanandhi',
    village: 'Bollavaram'
  },
  {
    _id: { $oid: '692414d4252a79f2bf2a99f5' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Mahanandhi',
    village: 'Bukkapuram'
  },
  {
    _id: { $oid: '692414d480ed0e3533a76218' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Mahanandhi',
    village: 'Gajulapalle'
  },
  {
    _id: { $oid: '692414d44ea671fbed841120' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Mahanandhi',
    village: 'Gopavaram'
  },
  {
    _id: { $oid: '692414d40b001750052ee1c7' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Mahanandhi',
    village: 'Maseedupuram'
  },
  {
    _id: { $oid: '692414d49d8e7f26eac6e2e3' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Mahanandhi',
    village: 'Nandipalle'
  },
  {
    _id: { $oid: '692414d4b096138f62e14071' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Mahanandhi',
    village: 'Thammadapalle'
  },
  {
    _id: { $oid: '692414d4e2b48c6047f6778f' },
    state: 'Andhra Pradesh',
    district: 'Nandyal',
    block: 'Mahanandhi',
    village: 'Thimmapuram'
  },

  {
    _id: { $oid: '692414a567539120b88aa039' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Anjalam'
  },
  {
    _id: { $oid: '692414a5bd8a66c352f6c8af' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Annavaram'
  },
  {
    _id: { $oid: '692414a5c742844fe515c2e0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Antharla'
  },
  {
    _id: { $oid: '692414a515ea5e6f66ab9f2c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Asirada'
  },
  {
    _id: { $oid: '692414a5a61f87aa312ab1e3' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Baddimetta'
  },
  {
    _id: { $oid: '692414a5ab4caa7862b2fdf1' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Balabadram'
  },
  {
    _id: { $oid: '692414a516618bbf5a59e65c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Balajipeta'
  },
  {
    _id: { $oid: '692414a599a61faac10bee05' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Balapam'
  },
  {
    _id: { $oid: '692414a56724f07e47b595c2' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Bandabayalu'
  },
  {
    _id: { $oid: '692414a5a070cb01f5e19023' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Bangarugummi'
  },
  {
    _id: { $oid: '692414a552e2f40eb0c5fe2e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Barikadorapakalu @ Rajupakalu'
  },
  {
    _id: { $oid: '692414a574370f2ba98656da' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Basangi Kothuru'
  },
  {
    _id: { $oid: '692414a5738b8d5c27915ffb' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Bayalukinchangi'
  },
  {
    _id: { $oid: '692414a51f3a6896632490b6' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Bayapadu'
  },
  {
    _id: { $oid: '692414a56c4cb220694cb2cb' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Bemudichatru'
  },
  {
    _id: { $oid: '692414a53430aa62a2381bfd' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Bennavaram'
  },
  {
    _id: { $oid: '692414a58913103d4b3126bf' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Bheemanapalle'
  },
  {
    _id: { $oid: '692414a5f0e79e642df47b2c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Bheemanupalle'
  },
  {
    _id: { $oid: '692414a507c961b532b3b630' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Bheemasingi'
  },
  {
    _id: { $oid: '692414a5842da562bdca6215' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Boddajuvvi'
  },
  {
    _id: { $oid: '692414a5e184ffaf4883cc29' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Boddaputtu'
  },
  {
    _id: { $oid: '692414a53248c736247c6cbd' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Bokkellu'
  },
  {
    _id: { $oid: '692414a5fcf031d4b67db8dd' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Borramamidi'
  },
  {
    _id: { $oid: '692414a5d2241b30fc2c512f' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Bourthy'
  },
  {
    _id: { $oid: '692414a538d1ae2dcd3ac012' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Bowda'
  },
  {
    _id: { $oid: '692414a5a31c5cad4dc35447' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Boyalagudem'
  },
  {
    _id: { $oid: '692414a5770fc7330077b275' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Budidapadu'
  },
  {
    _id: { $oid: '692414a51f0342d091c2611c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Buradamamidi'
  },
  {
    _id: { $oid: '692414a5e72098d257cd1242' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Burisingi'
  },
  {
    _id: { $oid: '692414a5f226a0842553d501' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Burugubailu'
  },
  {
    _id: { $oid: '692414a5c738ae1f2a879391' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Busibanda'
  },
  {
    _id: { $oid: '692414a50e77925b44f0133a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Busulakota'
  },
  {
    _id: { $oid: '692414a598769ba5af1b34e6' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Chadalapadu'
  },
  {
    _id: { $oid: '692414a52bcc0839c353fe8e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Chadipeta'
  },
  {
    _id: { $oid: '692414a524617399ffd48030' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Chavatapadu'
  },
  {
    _id: { $oid: '692414a5acb152ed1633b28a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Cheemalabayalu'
  },
  {
    _id: { $oid: '692414a5bb2046027396d3bc' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Cherapalle'
  },
  {
    _id: { $oid: '692414a56da0df4968df7aed' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Cherukumpakalu'
  },
  {
    _id: { $oid: '692414a5bd401f6f871e92a4' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Cheruvuru'
  },
  {
    _id: { $oid: '692414a5d68951d8bf07bddc' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Chilakalamamidi'
  },
  {
    _id: { $oid: '692414a5e8d883017c508a56' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Chinna Gedda'
  },
  {
    _id: { $oid: '692414a53fafd556cc79711e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Chinna Rajupakalu'
  },
  {
    _id: { $oid: '692414a5d7abce48c9aeb5a4' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Chinnabarada'
  },
  {
    _id: { $oid: '692414a5cb6441a9ab471952' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Chinnayyapalem'
  },
  {
    _id: { $oid: '692414a57d87a23a6c178775' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Chintapalle (CT)'
  },
  {
    _id: { $oid: '692414a5db322794424cf3ea' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Chinthaluru'
  },
  {
    _id: { $oid: '692414a59581f019e2e57a69' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Chitrallagoppu'
  },
  {
    _id: { $oid: '692414a54d035a74c0d79add' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Chittamgaruvu'
  },
  {
    _id: { $oid: '692414a555866fb09894821a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Chowdupalle'
  },
  {
    _id: { $oid: '692414a5e32a4e5b0f0d28e9' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Dasuduveedhi'
  },
  {
    _id: { $oid: '692414a5933380fd92a5541c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Debbagaruvu'
  },
  {
    _id: { $oid: '692414a5e8d0dfd1fdb8a70e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Degalapalem'
  },
  {
    _id: { $oid: '692414a589d8293838bbb299' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Digavalasapalle'
  },
  {
    _id: { $oid: '692414a51d6fef57a14b5308' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Digijanaba'
  },
  {
    _id: { $oid: '692414a5e8f322a863383c54' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Diguvapakalu'
  },
  {
    _id: { $oid: '692414a51f703529eaaca12c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Domalagondhi'
  },
  {
    _id: { $oid: '692414a5ae26f6b74e8ed813' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Dongalega'
  },
  {
    _id: { $oid: '692414a55e6d897dcafdd1b3' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Donipolalu'
  },
  {
    _id: { $oid: '692414a52778db67f185a037' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Dovarapalle'
  },
  {
    _id: { $oid: '692414a586e6369fdc921357' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Egajanaba'
  },
  {
    _id: { $oid: '692414a53d93accf6680a50e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Egavalasapalle'
  },
  {
    _id: { $oid: '692414a52aa4eae3d3e52d3e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Gadapari'
  },
  {
    _id: { $oid: '692414a5ab9306a43dd9ac8b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Gaddibanda'
  },
  {
    _id: { $oid: '692414a5ff5231e6c871ab12' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Gangavaram'
  },
  {
    _id: { $oid: '692414a50a28127ab8e372f4' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Ganugulapadu'
  },
  {
    _id: { $oid: '692414a528bcdf3438dc8b50' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Gattumpakalu'
  },
  {
    _id: { $oid: '692414a5d43fd3878dd012c1' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Genjigedda'
  },
  {
    _id: { $oid: '692414a5b795fbdcb01c2514' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Gerrilagadda'
  },
  {
    _id: { $oid: '692414a5709f96edf237d264' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Gochapalle'
  },
  {
    _id: { $oid: '692414a52a348d51c2626434' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Goddibanda'
  },
  {
    _id: { $oid: '692414a50d0591caf6a36872' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Godugulametta'
  },
  {
    _id: { $oid: '692414a5eb284a2075a5bacf' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Godugumamidi'
  },
  {
    _id: { $oid: '692414a5bd94fa45c72f801d' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Gondipakalu'
  },
  {
    _id: { $oid: '692414a5c42cdb7cd0f8cda7' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Goppugudiselu'
  },
  {
    _id: { $oid: '692414a58f566f36f1257d5c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Gorrelametta'
  },
  {
    _id: { $oid: '692414a520941abd18888792' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Gosaigondhi'
  },
  {
    _id: { $oid: '692414a59128a75101055311' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Goyyalametta'
  },
  {
    _id: { $oid: '692414a5940352073029174a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Gummidipalem'
  },
  {
    _id: { $oid: '692414a5491951da1bde0cc5' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Gunnamamidi'
  },
  {
    _id: { $oid: '692414a5d2675b00ae690ace' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Itikabedda'
  },
  {
    _id: { $oid: '692414a52424e0b074b091fd' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Jaduguru'
  },
  {
    _id: { $oid: '692414a56801fc7013acf41e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Jangambanda'
  },
  {
    _id: { $oid: '692414a5152136dde27c13c9' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Jangambuddi'
  },
  {
    _id: { $oid: '692414a54752ad5f5a8193ff' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Jangampakalu'
  },
  {
    _id: { $oid: '692414a50459d63381e9a1bd' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Jeelugumetta'
  },
  {
    _id: { $oid: '692414a5203ff14ae0a27482' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Jerrigedda'
  },
  {
    _id: { $oid: '692414a5e7c8b44d4b5e2098' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Joharu'
  },
  {
    _id: { $oid: '692414a5188017681b75ec91' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Joheru'
  },
  {
    _id: { $oid: '692414a5d4b921ada42d9cd7' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Junnulu'
  },
  {
    _id: { $oid: '692414a5bafddd942e97da60' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kadasilpa'
  },
  {
    _id: { $oid: '692414a5f93f08d94e799d33' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kagulabanda'
  },
  {
    _id: { $oid: '692414a5cf454aef3be68575' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kandulagodi'
  },
  {
    _id: { $oid: '692414a5458245617e815801' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kapasupadu'
  },
  {
    _id: { $oid: '692414a5b6230319c06ae210' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kappagondhi'
  },
  {
    _id: { $oid: '692414a5f4b01f04d705adc6' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kappalu'
  },
  {
    _id: { $oid: '692414a5c021cb7966a19d2f' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Karakapalle'
  },
  {
    _id: { $oid: '692414a5e84b089ce39f2eda' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kattubanda'
  },
  {
    _id: { $oid: '692414a54681d29aa1256e07' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kikkisalabanda'
  },
  {
    _id: { $oid: '692414a541fb094ce727fe0f' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kilimisingi Durgam'
  },
  {
    _id: { $oid: '692414a55ebcf1f0fa9bb885' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kinnerla'
  },
  {
    _id: { $oid: '692414a5df6444f524cbfc02' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kitumula'
  },
  {
    _id: { $oid: '692414a5629efd3182bed789' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kolanubanda'
  },
  {
    _id: { $oid: '692414a572102f23ade07cb9' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kolapari'
  },
  {
    _id: { $oid: '692414a5782da94fd6efa005' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kommangi'
  },
  {
    _id: { $oid: '692414a509a6a74e3a85a1cb' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kondavanchula'
  },
  {
    _id: { $oid: '692414a5d6409dc92c978780' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Korrabanda'
  },
  {
    _id: { $oid: '692414a5ca01d260d173c26e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Korukonda'
  },
  {
    _id: { $oid: '692414a5448254bf1b85751c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kotagunnalu'
  },
  {
    _id: { $oid: '692414a5dce3c9067408ef66' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kothapalem'
  },
  {
    _id: { $oid: '692414a5838d1a562e0401b2' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kothaveedhi'
  },
  {
    _id: { $oid: '692414a5e1ece097221781db' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kothavuru'
  },
  {
    _id: { $oid: '692414a50457f78f56d2f6e0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Krishnapuram'
  },
  {
    _id: { $oid: '692414a55d521c1fb28e4171' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kudumulu'
  },
  {
    _id: { $oid: '692414a57162d33d6e44575a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kudumusari'
  },
  {
    _id: { $oid: '692414a5f4d0e7d60779173b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kudupusingi'
  },
  {
    _id: { $oid: '692414a545a4636baae1d3cf' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kummarivanchala'
  },
  {
    _id: { $oid: '692414a599de5cecb1722103' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kuramanapakalu'
  },
  {
    _id: { $oid: '692414a5a537251a476ed4a6' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Kurusingi'
  },
  {
    _id: { $oid: '692414a5fa3bac2f2f99a525' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Labbangi'
  },
  {
    _id: { $oid: '692414a55ab04b1d5c09d851' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Labbangikothaveedhi'
  },
  {
    _id: { $oid: '692414a56887cedccb9753fd' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Lakkavaram'
  },
  {
    _id: { $oid: '692414a5325bc12273d7c913' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Lakshmipuram'
  },
  {
    _id: { $oid: '692414a562c1c04612044606' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Lambadampalle'
  },
  {
    _id: { $oid: '692414a5690d10332cdd4aaf' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Lammadampalle'
  },
  {
    _id: { $oid: '692414a5be3001f7e7991aea' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Lammasingi'
  },
  {
    _id: { $oid: '692414a5b43d09da134ace81' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Lingalagudi'
  },
  {
    _id: { $oid: '692414a5b20f3e2abeb0d03f' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Lothugedda'
  },
  {
    _id: { $oid: '692414a51ea3d2434a8cb3b5' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Lubbagunta'
  },
  {
    _id: { $oid: '692414a550304a07c1314db6' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Lumburu'
  },
  {
    _id: { $oid: '692414a569ea1df1969aa07b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Madigunta'
  },
  {
    _id: { $oid: '692414a5bb6f64870e657447' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Madimabanda'
  },
  {
    _id: { $oid: '692414a59e6736563e5bfb5c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Mallavaram'
  },
  {
    _id: { $oid: '692414a5545429e83b10cea2' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Mamidipalle'
  },
  {
    _id: { $oid: '692414a5c5c4ed54aa60fea8' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Mandipalle'
  },
  {
    _id: { $oid: '692414a5c006e55e4d18ac4e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Marrichettu Pakalu'
  },
  {
    _id: { $oid: '692414a5c010fa99df5260a3' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Matchalamamidi'
  },
  {
    _id: { $oid: '692414a52e24f662fb8cfe14' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Meduru'
  },
  {
    _id: { $oid: '692414a51394698c223fd194' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Merakalu'
  },
  {
    _id: { $oid: '692414a56d0512b8698c2c4d' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Mulusubanda'
  },
  {
    _id: { $oid: '692414a581b0e9094220af53' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Munthamamidi'
  },
  {
    _id: { $oid: '692414a5e9621854c2c426d2' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Nadimipalem'
  },
  {
    _id: { $oid: '692414a590ffcd766a7cfe70' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Nagraharam'
  },
  {
    _id: { $oid: '692414a5ec35dc2ce022a4cb' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Nagulagondi'
  },
  {
    _id: { $oid: '692414a597018935206986ae' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Nimmalapadu'
  },
  {
    _id: { $oid: '692414a5dcd08ad61c22e9c1' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Nimmalapalem'
  },
  {
    _id: { $oid: '692414a57165c1622054789a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Nuthibanda'
  },
  {
    _id: { $oid: '692414a510a1e083407232e0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Ona Chakarayabanda'
  },
  {
    _id: { $oid: '692414a5bcee79d765311d32' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Pakabu'
  },
  {
    _id: { $oid: '692414a56d60c769f79afbfe' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Palada'
  },
  {
    _id: { $oid: '692414a579a1f1c69190983e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Palamamidi'
  },
  {
    _id: { $oid: '692414a5a290ea94615194a4' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Pamulachintabanda'
  },
  {
    _id: { $oid: '692414a5315317e4dddeed1a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Panasalapadu'
  },
  {
    _id: { $oid: '692414a5a29c7c9b5ec3d442' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Pandlimamidi'
  },
  {
    _id: { $oid: '692414a50bb35fef4eacbc37' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Parikalu'
  },
  {
    _id: { $oid: '692414a5b59b93e0388ff787' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Pasuvulabanda'
  },
  {
    _id: { $oid: '692414a56c3cd3c1fddbc151' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Pathapadu'
  },
  {
    _id: { $oid: '692414a51b220b156eb6a910' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Pedabarada'
  },
  {
    _id: { $oid: '692414a5a24fb9afe8d44a47' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Pedagaruvu'
  },
  {
    _id: { $oid: '692414a54c47a60d3139c12b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Pedagondhi'
  },
  {
    _id: { $oid: '692414a54f3fe50a9133514a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Pedakonda'
  },
  {
    _id: { $oid: '692414a50d78dfa60aeae32d' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Pedapakalu'
  },
  {
    _id: { $oid: '692414a5053654059e9f8321' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Pina Kothuru'
  },
  {
    _id: { $oid: '692414a5073bc7398707ac3c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Pinapadu'
  },
  {
    _id: { $oid: '692414a52494e949b98bc233' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Polamabanda'
  },
  {
    _id: { $oid: '692414a5bf35be43fc5805f4' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Polugonta'
  },
  {
    _id: { $oid: '692414a5be8475fbd31dd922' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Porlubanda'
  },
  {
    _id: { $oid: '692414a5331bcebc959ae6ea' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Pothurajugummalu'
  },
  {
    _id: { $oid: '692414a5de9a3eefb45f95fe' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Pothurajugunnalu'
  },
  {
    _id: { $oid: '692414a5f749513a1dc0f4bd' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Puligondhi'
  },
  {
    _id: { $oid: '692414a53c08e1ace05dc782' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Puligondi'
  },
  {
    _id: { $oid: '692414a5a12eccfa25f00ec8' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Pullalamamidi'
  },
  {
    _id: { $oid: '692414a508b1b51897085773' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Pusalapalem'
  },
  {
    _id: { $oid: '692414a52c250d6714a01f5f' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Rachapanasa'
  },
  {
    _id: { $oid: '692414a51296aa544c269a93' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Rachapanukulu'
  },
  {
    _id: { $oid: '692414a507f8a6b21013eab7' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Rajubanda'
  },
  {
    _id: { $oid: '692414a5f0528dcea262e683' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Rakota'
  },
  {
    _id: { $oid: '692414a59bfbfb92cfb009eb' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Rallagedda'
  },
  {
    _id: { $oid: '692414a53a35f2dce821a23a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Rallagedda Kothuru'
  },
  {
    _id: { $oid: '692414a5572bb10a490739eb' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Ravimanupakalu'
  },
  {
    _id: { $oid: '692414a5f52925d55af8b5cd' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Rayipalem'
  },
  {
    _id: { $oid: '692414a54a45fdca464fa0ad' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Regallu'
  },
  {
    _id: { $oid: '692414a595506932b3a1f2c0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Regubailu'
  },
  {
    _id: { $oid: '692414a5ffbebfb1911b89b9' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Relangi'
  },
  {
    _id: { $oid: '692414a576767a31917a1eeb' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Rolugunta'
  },
  {
    _id: { $oid: '692414a58c2baed52cf70063' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Routhupayalu'
  },
  {
    _id: { $oid: '692414a57b692db6eb0ccf78' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Rowrimthada'
  },
  {
    _id: { $oid: '692414a5c22fd8a3055b5c58' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Sadika'
  },
  {
    _id: { $oid: '692414a5ea3d30594fc05740' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Sallai'
  },
  {
    _id: { $oid: '692414a517b7d964933dff96' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Samagiri'
  },
  {
    _id: { $oid: '692414a5c43f0e80d0b6250e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Sampangiputtu'
  },
  {
    _id: { $oid: '692414a5b1dacf498ee5e5de' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Sanivaram'
  },
  {
    _id: { $oid: '692414a5d51a1187d03fe4eb' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Sathyavaram'
  },
  {
    _id: { $oid: '692414a538e6627bfb832025' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Seetharamapuram'
  },
  {
    _id: { $oid: '692414a5b4a1b4eee4079d55' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Sheekayabanda'
  },
  {
    _id: { $oid: '692414a59a8aff932770bab3' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Singavaram'
  },
  {
    _id: { $oid: '692414a53a3d210fe72ea9f3' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Singavaram Kothuru'
  },
  {
    _id: { $oid: '692414a517f2679547afc56e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Siripuram'
  },
  {
    _id: { $oid: '692414a5b8a371d1bba9a888' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Somavaram'
  },
  {
    _id: { $oid: '692414a5d1d789a4765b5e37' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Suddagaruvu'
  },
  {
    _id: { $oid: '692414a507256541b0e77582' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Tadlapalle'
  },
  {
    _id: { $oid: '692414a5262b7123bec5de4f' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Tajangi'
  },
  {
    _id: { $oid: '692414a551a1799246e46d52' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Tamarapalle'
  },
  {
    _id: { $oid: '692414a5e93529fbf6d362b1' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Tammingala'
  },
  {
    _id: { $oid: '692414a5da090f8b4ba378ce' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Tappulamamidi'
  },
  {
    _id: { $oid: '692414a5d4c4b88affd6ecc0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Teegalametta'
  },
  {
    _id: { $oid: '692414a5b13e47332811cacd' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Terapalle'
  },
  {
    _id: { $oid: '692414a55ae66187daa0b14f' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Thallakota'
  },
  {
    _id: { $oid: '692414a565bab5cbb9c6880c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Thatibanda'
  },
  {
    _id: { $oid: '692414a5715b4159360505fc' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Thatipalem'
  },
  {
    _id: { $oid: '692414a519d5fcbcd7d449ef' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Tokapadu'
  },
  {
    _id: { $oid: '692414a51e3179a0eba1de43' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Totamamidi'
  },
  {
    _id: { $oid: '692414a5cbeac27c359bca2b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Turamamidi'
  },
  {
    _id: { $oid: '692414a50b8c4febcc4adfe3' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Turebongalu'
  },
  {
    _id: { $oid: '692414a5e132224d6dd33080' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Turubongulu'
  },
  {
    _id: { $oid: '692414a5242ad1514602881f' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Ubalagaruvu'
  },
  {
    _id: { $oid: '692414a5da8ba370b1c69059' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Umrasigondi'
  },
  {
    _id: { $oid: '692414a52576829cb82b1c58' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Usuruputtu'
  },
  {
    _id: { $oid: '692414a5b78aa25489bee70b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Vamigedda'
  },
  {
    _id: { $oid: '692414a5328e7219a9581024' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Vamigedda Kothuru'
  },
  {
    _id: { $oid: '692414a59597621bd2c3cbdb' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Vanajajulu'
  },
  {
    _id: { $oid: '692414a53b1c8ef8de5e726e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Vanchuladurgam'
  },
  {
    _id: { $oid: '692414a56d44c70fce69c4fa' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Vandanapalle'
  },
  {
    _id: { $oid: '692414a5b11d98237b51a007' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Vandlamamidi'
  },
  {
    _id: { $oid: '692414a5c344a56dfdae58cf' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Vangasari'
  },
  {
    _id: { $oid: '692414a5b4ac471343932414' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Vanthalapadu'
  },
  {
    _id: { $oid: '692414a56769652098434978' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Vanthamamidi'
  },
  {
    _id: { $oid: '692414a50201a7fa764ed1d7' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Varathanapalle'
  },
  {
    _id: { $oid: '692414a55f8b5657bc18cf2a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Vedurupalle'
  },
  {
    _id: { $oid: '692414a50b2f91d1e7da4aa0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Veeravaram'
  },
  {
    _id: { $oid: '692414a5eb911e0dc0d92198' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Velamjuvvi'
  },
  {
    _id: { $oid: '692414a540fc8ed7a55a7a4a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Vookabanda'
  },
  {
    _id: { $oid: '692414a56bdfa11c224c79d9' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Votti Busulu'
  },
  {
    _id: { $oid: '692414a501f4d0906e256e9a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Vurisingi'
  },
  {
    _id: { $oid: '692414a52076a09fd2294b38' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Yernabili'
  },
  {
    _id: { $oid: '692414a53de05f9fa705d490' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Yerrabanda'
  },
  {
    _id: { $oid: '692414a53ea593489899da01' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Yerrabommalu'
  },
  {
    _id: { $oid: '692414a568beb99c0d80dbfb' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Yerranabilli'
  },
  {
    _id: { $oid: '692414a526f9568719a4c665' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Yerravaram'
  },

  {
    _id: { $oid: '69241466273f792d27240edc' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: '14 Mile Stone'
  },
  {
    _id: { $oid: '692414666f10d6ddfef6696c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Allivara'
  },
  {
    _id: { $oid: '6924146670f7d1c1cede5a80' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Aluguru'
  },
  {
    _id: { $oid: '692414667b90058a3f9e9d15' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Ampuru'
  },
  {
    _id: { $oid: '69241466b7f345e7642729d8' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Antilova'
  },
  {
    _id: { $oid: '6924146604efd9ae2d21169b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Arjapuram'
  },
  {
    _id: { $oid: '69241466e9b8c580f3f2ba6d' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Arlada'
  },
  {
    _id: { $oid: '6924146695be4d1fbd77a5b5' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Ayinada'
  },
  {
    _id: { $oid: '69241466533deef7d82fee6b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Baddigummi'
  },
  {
    _id: { $oid: '692414667a2e31e186d3ca49' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Badimela'
  },
  {
    _id: { $oid: '6924146638eb7187e58e0eb6' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Balamalu'
  },
  {
    _id: { $oid: '69241466753f23507064f1c1' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Bandalu'
  },
  {
    _id: { $oid: '69241466573220a4498dd4dd' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Bandapolam'
  },
  {
    _id: { $oid: '6924146617522a133751bad2' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Bangarumetta'
  },
  {
    _id: { $oid: '692414665902bef1722fb638' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Bantrothuputtu'
  },
  {
    _id: { $oid: '692414667b6d00a08cfb030a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Baridiputtu'
  },
  {
    _id: { $oid: '69241466fe95a411b6e9c388' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Barisingi'
  },
  {
    _id: { $oid: '6924146642401814bd949291' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Barluputtu'
  },
  {
    _id: { $oid: '692414667f041f0159de4736' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Bidarigaruvu'
  },
  {
    _id: { $oid: '69241466a674d100b0fcb09d' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Birimisala'
  },
  {
    _id: { $oid: '6924146617be0202c0ad5ecf' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Boddaputtu'
  },
  {
    _id: { $oid: '69241466808c96ae1271b0a4' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Boddimamidi'
  },
  {
    _id: { $oid: '69241466813c7c27b7538047' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Bodichettu'
  },
  {
    _id: { $oid: '6924146636dcdc0170ff99e2' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Bokkellu'
  },
  {
    _id: { $oid: '6924146664cb9045a73eeb65' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Bonjangi'
  },
  {
    _id: { $oid: '6924146629eee5d4c751f692' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Buradapadu'
  },
  {
    _id: { $oid: '692414668a9c90c737a2fef4' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Burugu Chetru'
  },
  {
    _id: { $oid: '692414668d0c8e5fe3ed04b1' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Chakirevu'
  },
  {
    _id: { $oid: '692414667e4cac20929e5c1d' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Chantada'
  },
  {
    _id: { $oid: '69241466b0c57ab7e1727785' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Cheedikudda'
  },
  {
    _id: { $oid: '6924146604c9a0aab5a3e89f' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Cheedimetta'
  },
  {
    _id: { $oid: '692414663403010ab80ec872' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Cheedipalem'
  },
  {
    _id: { $oid: '692414667a3f9db1f162952b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Cheemalapalle'
  },
  {
    _id: { $oid: '69241466685561c50cae492b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Chilakalagondi'
  },
  {
    _id: { $oid: '692414660a12aadd38419e7d' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Chintada'
  },
  {
    _id: { $oid: '69241466af6071395d1bb794' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Chintagondi'
  },
  {
    _id: { $oid: '69241466329ae78179e1462c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Chintagunne'
  },
  {
    _id: { $oid: '6924146601ea16957dc5320b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Chintala Veedhi'
  },
  {
    _id: { $oid: '69241466c9d0956bf6fc2884' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Chinthagunnalu'
  },
  {
    _id: { $oid: '692414663d806c056252bb51' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Chodepalle'
  },
  {
    _id: { $oid: '692414667595d2540683d622' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Dabbagaruvu'
  },
  {
    _id: { $oid: '692414666c32e63dc314a152' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Dabbapadu'
  },
  {
    _id: { $oid: '69241466e3f9c898d05e5de0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Dabbaputtu'
  },
  {
    _id: { $oid: '692414665a61dcd33c75456c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Dalimputtu'
  },
  {
    _id: { $oid: '69241466aa007d9717a39303' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Dallapalle'
  },
  {
    _id: { $oid: '69241466be7ee606dfbf3aeb' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Darapalle'
  },
  {
    _id: { $oid: '69241466ed3e49193a697e11' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Degalaveedhi'
  },
  {
    _id: { $oid: '692414661eee69935d2698f2' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Devapuram'
  },
  {
    _id: { $oid: '69241466e2bbcf42eb9962a7' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Devarapalle'
  },
  {
    _id: { $oid: '6924146637b6a07cb6e828d4' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Digasampalu'
  },
  {
    _id: { $oid: '69241466c56a0a87e7a53727' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Digumodaputtu'
  },
  {
    _id: { $oid: '69241466f78ddba97cee2ed9' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Doddipalle'
  },
  {
    _id: { $oid: '6924146626787f5a16730699' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Dokuluru'
  },
  {
    _id: { $oid: '692414662dd0443b00f21676' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Donela'
  },
  {
    _id: { $oid: '69241466de3a5de51af90f88' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Dummaputtu'
  },
  {
    _id: { $oid: '692414662ed061d32a88923d' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Edulapalem'
  },
  {
    _id: { $oid: '69241466e60b67c37f69ef67' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Eegasampalu'
  },
  {
    _id: { $oid: '69241466a63e907e34ca8fdb' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Gabbangi'
  },
  {
    _id: { $oid: '692414664cd0bbbb4060b070' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Gadabavalasa @ Y.Kusarlapalem'
  },
  {
    _id: { $oid: '69241466ee14efc4abaae20b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Gaddibanda'
  },
  {
    _id: { $oid: '69241466e69235458b1a3d8b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Gaddibandalu'
  },
  {
    _id: { $oid: '69241466373e64b5c64ed4f4' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Gadivalasa'
  },
  {
    _id: { $oid: '69241466760ea90e3e37331c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Galipadu'
  },
  {
    _id: { $oid: '69241466dfa12f2e6e523d1f' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Ganjigedda'
  },
  {
    _id: { $oid: '6924146666dd9451f4b3dd22' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Gathapanuku'
  },
  {
    _id: { $oid: '69241466124f5b00940682e5' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Goddalipadu'
  },
  {
    _id: { $oid: '6924146636e8df61f6795aa8' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Godugula'
  },
  {
    _id: { $oid: '69241466fd98f279fb9bb5df' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Gondeli'
  },
  {
    _id: { $oid: '69241466233c144a596e3b03' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Gonduru'
  },
  {
    _id: { $oid: '69241466283daea49bd353d4' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Goonagummi'
  },
  {
    _id: { $oid: '69241466d078a4c65e01842a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Gudivada (CT)'
  },
  {
    _id: { $oid: '6924146699e1702efea44c71' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Gulimiddhachatru'
  },
  {
    _id: { $oid: '692414667699ba236b2affc5' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Gulli'
  },
  {
    _id: { $oid: '692414669611e51661bee138' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Gullipalle'
  },
  {
    _id: { $oid: '6924146697c6b0c0b56f8e85' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Gunjigedda'
  },
  {
    _id: { $oid: '6924146610e9ba643b2f693d' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Gurragaruvu'
  },
  {
    _id: { $oid: '692414664cfadcce55538244' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Gurrampanuku'
  },
  {
    _id: { $oid: '69241466536e66959f1ca531' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Gurupalle'
  },
  {
    _id: { $oid: '69241466732ea97e6959730a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Guttulaputtu'
  },
  {
    _id: { $oid: '69241466f85169c34afc15b7' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Hanumanthapuram'
  },
  {
    _id: { $oid: '692414662a721331aee1779c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Iradapalle'
  },
  {
    _id: { $oid: '69241466db1d4cbeb89d799a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Isakagaruvu'
  },
  {
    _id: { $oid: '69241466e07a4b0789dd15a1' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Iskali'
  },
  {
    _id: { $oid: '69241466cd9399475e6e5a33' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Jallipalle'
  },
  {
    _id: { $oid: '692414663ffae3573dcfe2b8' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Jangadapalle'
  },
  {
    _id: { $oid: '692414669476832bff3556ac' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Jarragaruvu'
  },
  {
    _id: { $oid: '69241466f6a12d3a31bd2c70' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Jeedipagada'
  },
  {
    _id: { $oid: '6924146647602b0050b7604c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Jeelugupadu'
  },
  {
    _id: { $oid: '69241466fbfb15d7e8c20886' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Jodimamidi'
  },
  {
    _id: { $oid: '6924146628349675eb462656' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Joduru'
  },
  {
    _id: { $oid: '6924146603606780985aa6e0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kadeli'
  },
  {
    _id: { $oid: '692414666a2e4be11196c1c7' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kakki'
  },
  {
    _id: { $oid: '692414664d78426d6e653664' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kallalabayalu'
  },
  {
    _id: { $oid: '6924146621bd4a05b6ea67f1' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kandrangipadu'
  },
  {
    _id: { $oid: '692414660211652a9a55225c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kandulapalem'
  },
  {
    _id: { $oid: '69241466bdaf0a4b1ea69072' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kangedda'
  },
  {
    _id: { $oid: '69241466b71f7f6430ee83d0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kappalagondi'
  },
  {
    _id: { $oid: '69241466cac046993069c594' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kapparamajji'
  },
  {
    _id: { $oid: '6924146659e7d746061108df' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Karakaputtu'
  },
  {
    _id: { $oid: '692414666e0c8e63868619dc' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Karibanda'
  },
  {
    _id: { $oid: '69241466602ec310cc5eda55' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Karya Bandu'
  },
  {
    _id: { $oid: '69241466d33994fd76d710d2' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kavirai'
  },
  {
    _id: { $oid: '6924146609c34f58d447c155' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kinchuru'
  },
  {
    _id: { $oid: '69241466e2ca9e7dd679ddc1' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kindangi'
  },
  {
    _id: { $oid: '69241466e185f1a9b3089309' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kodulolangipadu'
  },
  {
    _id: { $oid: '69241466d407e70c3747dea0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kollambo'
  },
  {
    _id: { $oid: '69241466ee5ec6198808b8a1' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kondajeelugu'
  },
  {
    _id: { $oid: '692414664950745d405e4701' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kondamamidi'
  },
  {
    _id: { $oid: '69241466aa991f46fcd54e2b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kotha Valasapadu'
  },
  {
    _id: { $oid: '692414661bdac49b1142f1ec' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kothabu'
  },
  {
    _id: { $oid: '69241466ed8c97cdf16dba1a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kothapalle'
  },
  {
    _id: { $oid: '692414668f34f7270b3c96ea' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kothapolam'
  },
  {
    _id: { $oid: '692414664b01f39d94ab11a8' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kothavalasa'
  },
  {
    _id: { $oid: '692414668ee99aa1449e34bd' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kothavooru'
  },
  {
    _id: { $oid: '692414664c66a50b28dbaa40' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kothuru'
  },
  {
    _id: { $oid: '6924146686ef1fc4498db3cf' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kujjali'
  },
  {
    _id: { $oid: '69241466ebef644852ff77e0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kummaripalem'
  },
  {
    _id: { $oid: '692414668cd0326a7d3a0f45' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kummariputtu'
  },
  {
    _id: { $oid: '692414664d35ad79318e8802' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kummarithumu'
  },
  {
    _id: { $oid: '69241466486dda690efe04ee' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Kusarlapalem'
  },
  {
    _id: { $oid: '69241466c6bee4ffc36d1415' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Ladaputtu'
  },
  {
    _id: { $oid: '69241466d57ceba07e8c02d0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Lagisapalle'
  },
  {
    _id: { $oid: '6924146624ceb71e56024a18' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Lampeli'
  },
  {
    _id: { $oid: '69241466f106890682f3364b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Lingaputtu'
  },
  {
    _id: { $oid: '6924146650ff6e455f4b951a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Lolangipadu'
  },
  {
    _id: { $oid: '692414665ae026aaa10d1748' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Madigabanda'
  },
  {
    _id: { $oid: '6924146631075d9551eeab83' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Malakapolam'
  },
  {
    _id: { $oid: '692414664c493658039e2a3c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Malapadu'
  },
  {
    _id: { $oid: '6924146627fcd11b86ad9d03' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Mandiputtu'
  },
  {
    _id: { $oid: '6924146619918b71b38cc858' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Matikabande'
  },
  {
    _id: { $oid: '69241466527d0bf067ac4f0c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Mettavoolu'
  },
  {
    _id: { $oid: '69241466bdf5f50f4271b930' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Minumuluru'
  },
  {
    _id: { $oid: '692414665f6dbd41f8a967ca' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Modapalle'
  },
  {
    _id: { $oid: '6924146662c31389726a37cf' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Mulagalapalem'
  },
  {
    _id: { $oid: '6924146614d5ba089643f1e1' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Munchingi Puttu'
  },
  {
    _id: { $oid: '69241466914a8c27c247ff89' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Nandigaruvu'
  },
  {
    _id: { $oid: '692414666339646021a7cb01' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Nereduvalasa'
  },
  {
    _id: { $oid: '6924146624a240cc3d14de6f' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Obarthi'
  },
  {
    _id: { $oid: '692414662e3d0a6ee7d393e9' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Ontipaka'
  },
  {
    _id: { $oid: '6924146669088b411f980122' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Ontiveedhulu'
  },
  {
    _id: { $oid: '69241466162152c168784ec3' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Onuru'
  },
  {
    _id: { $oid: '692414668ff05de22e987d91' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Palamanichilaka'
  },
  {
    _id: { $oid: '6924146603abef4540fca8db' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Pamurelli'
  },
  {
    _id: { $oid: '69241466e1b2c9446b036b94' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Panasapalle'
  },
  {
    _id: { $oid: '692414666ce4dbcc1c78e237' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Panasaputtu'
  },
  {
    _id: { $oid: '6924146637fe9c8ee312a990' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Pandigun'
  },
  {
    _id: { $oid: '6924146628a101f861729f55' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Pathapaderu'
  },
  {
    _id: { $oid: '6924146622c472d67b0d8c70' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Pedapolam'
  },
  {
    _id: { $oid: '692414664bd1fc23faad3393' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Pidugumamidi'
  },
  {
    _id: { $oid: '69241466f47fc889f023d3fc' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Piduguputtu'
  },
  {
    _id: { $oid: '6924146633cf0a6e028a7f82' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Pilliputtu'
  },
  {
    _id: { $oid: '69241466e154259f744bdd2e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Poolabanda'
  },
  {
    _id: { $oid: '69241466ebf070fc28fbd56e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Pothampalem'
  },
  {
    _id: { $oid: '69241466d6724c2a33b2dd9a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Pothurajumetta'
  },
  {
    _id: { $oid: '69241466dde91c6f001aaddc' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Pulusumamidi'
  },
  {
    _id: { $oid: '692414660d983ba0cb33078c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Putikagaruvu'
  },
  {
    _id: { $oid: '69241466a29d1ec75760f67d' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Puttarajupadu'
  },
  {
    _id: { $oid: '69241466439cc16c33b0324e' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Raigedda'
  },
  {
    _id: { $oid: '69241466d347df46fa83ec33' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Raipalem'
  },
  {
    _id: { $oid: '692414666aaed4866f7a47fe' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Rakota'
  },
  {
    _id: { $oid: '69241466d0c7174412386405' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Ranambadi'
  },
  {
    _id: { $oid: '692414660a320d9129ed1c63' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Rangasingipadu'
  },
  {
    _id: { $oid: '6924146636e1002a5a323a8a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Rellabanda'
  },
  {
    _id: { $oid: '69241466f071953822a99311' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Sakiputtu'
  },
  {
    _id: { $oid: '69241466e8e6fe7350327134' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Saldigedda'
  },
  {
    _id: { $oid: '69241466d2ffbad37f1c01fb' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Salugu'
  },
  {
    _id: { $oid: '692414663bdfbf2c24519cc0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Sangodi'
  },
  {
    _id: { $oid: '69241466e3d405f75bd2a338' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Santhaganduva'
  },
  {
    _id: { $oid: '69241466434febf68a6d5525' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Sappiputtu'
  },
  {
    _id: { $oid: '69241466f0e46872e300a532' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Sariapalle'
  },
  {
    _id: { $oid: '69241466c524a5ac0547ac46' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Seekaipadu'
  },
  {
    _id: { $oid: '69241466f3dd746638b0fb9c' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Seekupanasa'
  },
  {
    _id: { $oid: '69241466952920bb715049b9' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Seribayalu'
  },
  {
    _id: { $oid: '6924146612af55ed56b0a66a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Sindugula'
  },
  {
    _id: { $oid: '69241466c41926ffa774126b' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Solamulu'
  },
  {
    _id: { $oid: '69241466de5e177948dcde63' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Sukuruputtu'
  },
  {
    _id: { $oid: '692414662567ff6713df46fc' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Sundruputtu'
  },
  {
    _id: { $oid: '692414664cbe16f302f232bb' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Tagavulamamidi Garuvu'
  },
  {
    _id: { $oid: '692414667001267c83d949e1' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Talarisingi'
  },
  {
    _id: { $oid: '69241466a822aab7d93adbe4' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Tamarapalle'
  },
  {
    _id: { $oid: '69241466f9e9b9105b5bf0f6' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Taragam'
  },
  {
    _id: { $oid: '692414668af83e50d5549009' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Thotagunnalu'
  },
  {
    _id: { $oid: '692414669da3ad836b01c247' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Thotalagondi'
  },
  {
    _id: { $oid: '6924146645bf79654e87aec0' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Thumpada'
  },
  {
    _id: { $oid: '69241466633402cf6c74dc83' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Tiyyagedda'
  },
  {
    _id: { $oid: '692414667a68cee9c5316fa5' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Tummalapalem'
  },
  {
    _id: { $oid: '69241466f40c8695bcaccb1a' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Turumamidi'
  },
  {
    _id: { $oid: '69241466352d4efa82543e17' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Ubbediputtu'
  },
  {
    _id: { $oid: '69241466e1a168ac3ec128ba' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Valasamamidi'
  },
  {
    _id: { $oid: '6924146680dd6cbeefb3b0a2' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Vallai'
  },
  {
    _id: { $oid: '69241466f5229133add3176d' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Vallapuram'
  },
  {
    _id: { $oid: '6924146689338ba2237c020f' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Vanagarai'
  },
  {
    _id: { $oid: '692414662de3ecefbfaa1206' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Vanchadagondi'
  },
  {
    _id: { $oid: '6924146617d0cd0b13b26b77' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Vanjangi'
  },
  {
    _id: { $oid: '69241466e1d861cae3feb622' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Vanjaparthi'
  },
  {
    _id: { $oid: '69241466709cb0e5993f2014' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Vanji Bathi'
  },
  {
    _id: { $oid: '69241466890708c041c578a3' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Vankachinta'
  },
  {
    _id: { $oid: '6924146675af4b7ac029fbe7' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Vanthadapalle'
  },
  {
    _id: { $oid: '69241466a7b0002363293a08' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Vanthalagummi'
  },
  {
    _id: { $oid: '6924146647143906bd7b4531' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Vanthalamamidi'
  },
  {
    _id: { $oid: '692414663003179471c6f1f9' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Vanthalamamidi @ Gadilametta'
  },
  {
    _id: { $oid: '69241466da720f36b77b0e38' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Vantipaka'
  },
  {
    _id: { $oid: '69241466f47d5331475eba08' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Vanugupalle'
  },
  {
    _id: { $oid: '6924146610082b4604245aa6' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Varthanapalle'
  },
  {
    _id: { $oid: '6924146668ecb6f99128e9fb' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Varukaru'
  },
  {
    _id: { $oid: '692414666d4b712806da97f5' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Vurugonda'
  },
  {
    _id: { $oid: '69241466c836e7462964f3ce' },
    state: 'Andhra Pradesh',
    district: 'Alluri Sitharama Raju',
    block: 'Paderu',
    village: 'Yegumodaputtu'
  },

  {
    _id: { $oid: '692413ecac2c50c30ec6939f' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Agarlagokarla Palle'
  },
  {
    _id: { $oid: '692413ec248fb30c810ad756' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Akularaghunadha Puram'
  },
  {
    _id: { $oid: '692413ec7a8881bd69d6a324' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Anandapuram'
  },
  {
    _id: { $oid: '692413ecc6330baa588be5ee' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Annapuram'
  },
  {
    _id: { $oid: '692413ec9a842407c9000a15' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Badabanda'
  },
  {
    _id: { $oid: '692413ec2aa152f27845b337' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Badagam'
  },
  {
    _id: { $oid: '692413ec81505ba69a20d8c5' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Banjeerupeta'
  },
  {
    _id: { $oid: '692413ece80b35e637ed068b' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Bejjipalle'
  },
  {
    _id: { $oid: '692413ec4593b13490f7e3c4' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Bellukola'
  },
  {
    _id: { $oid: '692413ec58499d1a8c0d0488' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Beniavooru'
  },
  {
    _id: { $oid: '692413ecac570cef855bc749' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Bharanigam'
  },
  {
    _id: { $oid: '692413ec5b1840e3d9a1460e' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Bharthupuram'
  },
  {
    _id: { $oid: '692413ecb1dc7e6674b70a39' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Bhiriboddapadu'
  },
  {
    _id: { $oid: '692413ec30d535ebb83565f7' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Borubhadra'
  },
  {
    _id: { $oid: '692413eccec5f08beaaf4337' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Cherukupalle'
  },
  {
    _id: { $oid: '692413ec48946ed9d14a28e6' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Chinnaguruvuru'
  },
  {
    _id: { $oid: '692413ec59e92d805cc79fa8' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Chinnalavunipalle'
  },
  {
    _id: { $oid: '692413ec44d19083f9bf03c2' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Chinnalaxmipuram'
  },
  {
    _id: { $oid: '692413ec3d95ff0154bda520' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Chinnarigokarla Palle'
  },
  {
    _id: { $oid: '692413eccb267b43ae9c1661' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Chinnatamarapalle'
  },
  {
    _id: { $oid: '692413ecf65e7b26cfbbab2e' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Deenabandupuram'
  },
  {
    _id: { $oid: '692413ec89190561c0cfc10c' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Devada'
  },
  {
    _id: { $oid: '692413ec02b270961be8ebb3' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Devalabhadra'
  },
  {
    _id: { $oid: '692413ec34fe425b9cffc367' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Devupuram'
  },
  {
    _id: { $oid: '692413ec147b037829745943' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Dimilada'
  },
  {
    _id: { $oid: '692413ec933f695b076f377a' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Dimmidijola'
  },
  {
    _id: { $oid: '692413ecdc31068fa3dea8f0' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Dodlarama Chandrapuram'
  },
  {
    _id: { $oid: '692413ecfe5fcd02be60d9c7' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Haridasupuram'
  },
  {
    _id: { $oid: '692413ec09afdc93542d33c7' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Harshabada'
  },
  {
    _id: { $oid: '692413ec38d842cade4ebf64' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Hukumpeta'
  },
  {
    _id: { $oid: '692413ecb0d8d6abbcee4fa4' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Jadyada'
  },
  {
    _id: { $oid: '692413ec51a250bac61a5655' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Jammipeta'
  },
  {
    _id: { $oid: '692413ec2f41ccea08206c59' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Jayapuram'
  },
  {
    _id: { $oid: '692413ec94460965d7fdba96' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Kaijola'
  },
  {
    _id: { $oid: '692413ec232048c1d3db464d' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Kamadhenuvu'
  },
  {
    _id: { $oid: '692413ec6aef7b3364da73bb' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Kanchivooru'
  },
  {
    _id: { $oid: '692413eca2907d584ee77911' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Kandulagudem'
  },
  {
    _id: { $oid: '692413ec5ac6636da6540764' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Kanithivooru'
  },
  {
    _id: { $oid: '692413ec959f46d170686686' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Karajada'
  },
  {
    _id: { $oid: '692413ecac3f909235e7d3d3' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Karlapudi'
  },
  {
    _id: { $oid: '692413ecb6ca145d071d5908' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Kasirajukasipuram'
  },
  {
    _id: { $oid: '692413ec1eaad55eb96a2741' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Kaviti'
  },
  {
    _id: { $oid: '692413ec86f7b64194247356' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Khallada'
  },
  {
    _id: { $oid: '692413ec217d7e67c0b912ea' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Komatooru'
  },
  {
    _id: { $oid: '692413ec974cdeec8dbdcdb4' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Kondatemburu'
  },
  {
    _id: { $oid: '692413ece3da4ff144449454' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Kothagraharam'
  },
  {
    _id: { $oid: '692413eca28af409a3df5489' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Kotipalle'
  },
  {
    _id: { $oid: '692413ecf99031f00d71c0ae' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Krishnarayapuram'
  },
  {
    _id: { $oid: '692413ec7a12211d88723bfd' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Lakkidasupuram'
  },
  {
    _id: { $oid: '692413ec61e6d3262750d59d' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Lattigam'
  },
  {
    _id: { $oid: '692413ed4313fc0bbcbf9db1' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Madanapuram'
  },
  {
    _id: { $oid: '692413ed8d8862e31534ea47' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Madigapuram'
  },
  {
    _id: { $oid: '692413ed2ac65564ff358180' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Majjigopalapuram'
  },
  {
    _id: { $oid: '692413edd7f9f603d5ff81f9' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Malliveedu'
  },
  {
    _id: { $oid: '692413ed7ae65ef13d43ef24' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Mamidipalle'
  },
  {
    _id: { $oid: '692413ed6e78e253ddd0d31c' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Manigam'
  },
  {
    _id: { $oid: '692413edaa8f1e3120f2feaf' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Marlapadu'
  },
  {
    _id: { $oid: '692413ed875bae1934126527' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Mogilipadu'
  },
  {
    _id: { $oid: '692413eddee4d6dad5b0527d' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Mojjuvada'
  },
  {
    _id: { $oid: '692413edae4f95491adff0c2' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Mondrayavalasa'
  },
  {
    _id: { $oid: '692413eda9332e3a8c77707e' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Mukundapuram'
  },
  {
    _id: { $oid: '692413edba8f353e79ddf29d' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Nandigam'
  },
  {
    _id: { $oid: '692413ed85ac488d3df2cd82' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Narendrapuram'
  },
  {
    _id: { $oid: '692413eda378ec356d15f9e6' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Narsipuram'
  },
  {
    _id: { $oid: '692413ed4d78ffac368f359e' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Nowgam'
  },
  {
    _id: { $oid: '692413edc6ba3979f986fc12' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Padmapuram'
  },
  {
    _id: { $oid: '692413ed95b571543ccf28a1' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Palavalasa'
  },
  {
    _id: { $oid: '692413ed780641a2490b421b' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Pathrunivalasa'
  },
  {
    _id: { $oid: '692413edf3163d836dafe1ae' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Peddabanapuram'
  },
  {
    _id: { $oid: '692413ed7984d1ceb1d97b4b' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Peddaguruvooru'
  },
  {
    _id: { $oid: '692413ed1f4103ae843fa854' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Peddalavunipalle'
  },
  {
    _id: { $oid: '692413ede4d700fe40872040' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Peddatamarapalle'
  },
  {
    _id: { $oid: '692413ed0fe0a957c049711d' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Peddinaidupeta'
  },
  {
    _id: { $oid: '692413ed82183e9a0b315492' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Pentavooru'
  },
  {
    _id: { $oid: '692413ede45a18da385485ae' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Polavaram'
  },
  {
    _id: { $oid: '692413ed9144349af3227cb3' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Pothuluru'
  },
  {
    _id: { $oid: '692413ed7cd2203ce5cb04d3' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Prathapaviswana Dhapuram'
  },
  {
    _id: { $oid: '692413ed32291956d1de240b' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Radhajanabodda Padu'
  },
  {
    _id: { $oid: '692413edec574e1e447d36f3' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Rampuram'
  },
  {
    _id: { $oid: '692413eded88708aeb402c84' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Routhupuram'
  },
  {
    _id: { $oid: '692413ed533eacab371d851e' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Sagarampeta'
  },
  {
    _id: { $oid: '692413edbd2dabb108239104' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Santhosha Puram'
  },
  {
    _id: { $oid: '692413ed9eff1457e0a7a4ec' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Saradapuram'
  },
  {
    _id: { $oid: '692413ed416f4e7e35682129' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Savarabanapuram'
  },
  {
    _id: { $oid: '692413edbedbdd94643343de' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Savarakothuru'
  },
  {
    _id: { $oid: '692413eda1b0a0f68b224c9c' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Savaralingupuram'
  },
  {
    _id: { $oid: '692413ed2d912e0db813be3c' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Savararama Krishnapuram'
  },
  {
    _id: { $oid: '692413ede4fbc2e28e1599a5' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Savararampuram'
  },
  {
    _id: { $oid: '692413ed0ad40ac0a33c3e4f' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Singupuram'
  },
  {
    _id: { $oid: '692413edc75af8dc44f4b840' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Sivarampuram'
  },
  {
    _id: { $oid: '692413edca86d491bf875e63' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Sontinooru'
  },
  {
    _id: { $oid: '692413ed55aa6c4142766b50' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Subhadrapuram'
  },
  {
    _id: { $oid: '692413ed0d204a357f9f1661' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Tamalapuram'
  },
  {
    _id: { $oid: '692413ed224f54a191f16f97' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Temburu'
  },
  {
    _id: { $oid: '692413ed70030d877c31e13b' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Turakalakota'
  },
  {
    _id: { $oid: '692413ed505aa4b80a63124c' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Uddandabartupuram'
  },
  {
    _id: { $oid: '692413ed7064a52faef212ec' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Uyyalapeta'
  },
  {
    _id: { $oid: '692413edb050e2dcc51255b6' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Vallabharayapadu'
  },
  {
    _id: { $oid: '692413edcc36a9720a63ba06' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Venkatapuram'
  },
  {
    _id: { $oid: '692413edb5e7b6e6ed6922a4' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Venugopalapuram'
  },
  {
    _id: { $oid: '692413ed3289a4d35484d316' },
    state: 'Andhra Pradesh',
    district: 'Srikakulam',
    block: 'Nandigam',
    village: 'Vissampalle'
  },

  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab3f2',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Ailee',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab3f3',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Allopur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab3f4',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Amar Patti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab3f5',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Amauli',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab3f6',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Amba',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab3f7',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Araji Newada',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab3f8',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Ashapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab3f9',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Awadhipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab3fa',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Babhanpura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab3fb',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Bakaini',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab3fc',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Balkishunpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab3fd',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Bankat',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab3fe',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Barai',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab3ff',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Bariyasanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab400',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Bartharakala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab401',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Bhagavanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab402',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Bhasaudi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab403',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Byashpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab404',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Byaspur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab405',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Chadpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab406',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Chak Newada',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab407',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Chakvasdev',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab408',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Chandpur (mustafabad)',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab409',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Chhahi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab40a',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Chhitauna',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab40b',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Chhitauni',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab40c',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Chiraigaon',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab40d',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Chukaha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab40e',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Damodarpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab40f',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Daniyalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab410',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Dewariya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab411',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Dhananjaipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab412',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Dharadhar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab413',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Dhobahi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab414',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Dinapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab415',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Dubkiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab416',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Faridpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab417',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Gangapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab418',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Gaurakala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab419',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Gaura Khurd',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab41a',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Gaurdih',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab41b',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Giradharpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab41c',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Gobaraha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab41d',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Goithaha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab41e',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Gokoolpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab41f',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Goppur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab420',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Hasanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab421',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Hiramanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab422',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Hridaypur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab423',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Hulasipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab424',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Husepur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab425',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Imiliya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab426',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Jalhoopur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab427',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Jayrampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab428',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Jhanjhoopur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab429',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Jigana',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab42a',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Kadipur Khurd',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab42b',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Kamauli',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab42c',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Katesar Kala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab42d',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Ketesar Khurd',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab42e',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Khajuhee',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab42f',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Khalispur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab430',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Khanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab431',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Kharagipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab432',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Khetalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab433',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Khutahana',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab434',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Kochi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab435',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Kodopur Kala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab436',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Kodopur Khurd',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab437',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Kotava',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab438',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Kukudha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab439',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Ledhupur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab43a',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Luthakala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab43b',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Luthakurd',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab43c',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Madhani',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab43d',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Milkopur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab43e',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Misrapura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab43f',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Mokalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab440',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Mudali',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab441',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Mugdalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab442',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Muridpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab443',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Mustafabad',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab444',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Narayan Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab445',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Narpatpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab446',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Navapura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab447',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Nevada',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab448',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Pacharaw',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab449',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Pahadiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab44a',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Panditpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab44b',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Panihari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab44c',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Paranapoor',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab44d',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Parwatpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab44e',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Paterwa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab44f',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Phulpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab450',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Piyaree',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab451',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Prahladpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab452',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Puranpatti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab453',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Raghunathpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab454',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Raimala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab455',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Rai Pura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab456',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Rajapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab457',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Rajnahiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab458',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Ramana',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab459',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Ramchandipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab45a',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Ramgadhwa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab45b',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Rampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab45c',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Rasulgarh',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab45d',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Rustampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab45e',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Salarpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab45f',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Sandaha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab460',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Sarai Mohana',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab461',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Saraiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab462',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Saraiya No 1',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab463',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Saraiya No 2',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab464',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Sarasaul',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab465',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Sathawa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab466',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Shahpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab467',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Shankarpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab468',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Shivdasha Gangavar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab469',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Shivnathpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab46a',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Singhpoor',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab46b',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Singhvar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab46c',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Siristi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab46d',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Sivo',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab46e',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Sonbarsa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab46f',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Sultanpoor',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab470',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Taraya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab471',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Tatepur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab472',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Tilamapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab473',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Tophapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab474',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Ukathi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab475',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Umaraha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab476',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Viparjepur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab477',
    },
    district: 'Varanasi',
    block: 'Chiraigaon',
    village: 'Vishunpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab478',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Aapi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab479',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Arajiline',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab47a',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Asawari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab47b',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Ashad',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab47c',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Atarsuiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab47d',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Ayodhyapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab47e',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Babhaniyav',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab47f',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bachhed',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab480',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Badheini Kala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab481',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Badheini Khurd',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab482',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Badipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab483',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bahadurpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab484',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bahedava',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab485',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bahedawa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab486',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bahoranpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab487',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bairwan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab488',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bangalipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab489',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bansipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab48a',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Barikpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab48b',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Basant Patti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab48c',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Basantpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab48d',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Belaudi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab48e',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Benipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab48f',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Beruka',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab490',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bhadarasi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab491',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bhadav',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab492',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bhadehara',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab493',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bhaedpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab494',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bhanjanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab495',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bhatshar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab496',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bhawaneepur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab497',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bhedahan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab498',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bhikhampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab499',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bhikharipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab49a',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bhikhipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab49b',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bhimchandi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab49c',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bhojubeer',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab49d',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bhuvalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab49e',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Bibhauri',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab49f',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Birbalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4a0',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Birsinghpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4a1',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Brijwashichak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4a2',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Burapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4a3',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Chakadhiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4a4',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Chakdarshan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4a5',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Chakdiharam',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4a6',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Chakrapanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4a7',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Chandapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4a8',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Chaukhandi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4a9',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Chittapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4aa',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Dagahariya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4ab',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Darekhu',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4ac',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Dasarath Chak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4ad',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Dashrathpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4ae',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Dayapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4af',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Deuara',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4b0',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Deura Chak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4b1',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Dhadhorpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4b2',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Dhanapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4b3',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Dhanpalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4b4',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Dholapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4b5',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Dhoraee',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4b6',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Dindaspur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4b7',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Dipapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4b8',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Gaharpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4b9',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Ganeshpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4ba',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Gangpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4bb',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Ganjari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4bc',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Gaur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4bd',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Gaura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4be',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Gazapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4bf',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Ghamahanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4c0',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Ghamahapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4c1',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Gopal Chak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4c2',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Gopipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4c3',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Govindpoor',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4c4',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Govindpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4c5',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Gowindpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4c6',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Gurudaspur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4c7',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Harasos',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4c8',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Hardattpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4c9',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Haridaspur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4ca',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Harinampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4cb',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Harirampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4cc',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Harpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4cd',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Hridayeepur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4ce',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jaddupur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4cf',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jagardevpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4d0',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jagatpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4d1',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jakkhini',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4d2',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jalal Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4d3',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jameen Shivsagar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4d4',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jamin Bairvan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4d5',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jamindarshan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4d6',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jamin Hikmatshah',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4d7',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jamin Kaneri',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4d8',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jamin Kushichak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4d9',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jamin Sulachchhan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4da',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jamin Tekikahar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4db',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jamunipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4dc',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jansa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4dd',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jayapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4de',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jeetapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4df',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Jhabra',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4e0',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kachanar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4e1',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kachhariya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4e2',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kallipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4e3',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kalyanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4e4',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kamalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4e5',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kanakpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4e6',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kaneri',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4e7',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kanhaipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4e8',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kanthipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4e9',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kapar Phorwa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4ea',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Karmashipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4eb',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Karnadandi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4ec',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kashipoor',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4ed',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kashipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4ee',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kataiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4ef',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kazichak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4f0',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Khadaura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4f1',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Khajur Dih',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4f2',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Khajuri-2',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4f3',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kharagrajpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4f4',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Khemaipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4f5',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Khewali',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4f6',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Khewasipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4f7',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Khochwa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4f8',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Koraut',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4f9',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Korri',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4fa',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kosada',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4fb',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kotila',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4fc',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Krishnadattpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4fd',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kundriya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4fe',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kurauna',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab4ff',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kurauti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab500',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Kursato',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab501',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Lachhi Rampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab502',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Lakshapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab503',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Lal Chak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab504',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Lallapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab505',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Laskariya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab506',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Laximanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab507',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Laxirampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab508',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Loharapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab509',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Madhopoor',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab50a',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Madhukarshahpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab50b',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Madhukar Shahpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab50c',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Mahavan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab50d',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Mahgaon',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab50e',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Mahmadpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab50f',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Manikpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab510',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Maniyaripoor',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab511',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Marui',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab512',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Mataldei',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab513',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Meeravan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab514',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Mehadiganj',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab515',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Michekanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab516',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Milki Chack',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab517',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Milkipoor',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab518',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Milkpachai',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab519',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Mohan Sarai',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab51a',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Mongalabeer',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab51b',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Mubarakpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab51c',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Mungawar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab51d',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Musepur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab51e',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Nagaipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab51f',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Nagepur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab520',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Naipura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab521',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Naraicha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab522',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Narottmpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab523',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Narsara',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab524',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Navvechak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab525',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Nideura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab526',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Niyasipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab527',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Pachai-1',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab528',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Pachai-2',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab529',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Paidegaon',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab52a',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Paniyara',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab52b',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Parampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab52c',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Parjanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab52d',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Parmanandapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab52e',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Parsupur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab52f',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Pausee',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab530',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Pilauri',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab531',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Pratap Patti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab532',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Pratappur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab533',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Prithvipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab534',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Rajapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab535',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Rajjipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab536',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Raj Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab537',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Rakhauna',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab538',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Rakhee',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab539',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Ramaipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab53a',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Rampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab53b',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Ramraipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab53c',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Ramsinghpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab53d',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Ranibazar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab53e',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Rupapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab53f',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Sahawabad',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab540',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Sajoi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab541',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Saraiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab542',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Sarauni',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab543',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Sarvanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab544',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Shahabazpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab545',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Shahanshahpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab546',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Shaktiyarpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab547',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Shivrampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab548',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Sihorva',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab549',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Sihorwa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab54a',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Singahi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab54b',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Sirasa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab54c',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Suichak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab54d',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Tadiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab54e',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Tarsawn',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab54f',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Tatahavapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab550',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Tilanga',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab551',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Tinkedawa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab552',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Todarpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab553',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Tohafapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab554',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Tulachak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab555',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Upadhyaypur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab556',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Veerbhanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab557',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Veersinghpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab558',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Vitthalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab559',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Ghamhapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab55a',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Gobindpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab55b',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Lachhimanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab55c',
    },
    district: 'Varanasi',
    block: 'Arajiline',
    village: 'Serwanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab55d',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Adamapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab55e',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Akdama',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab55f',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Amaripur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab560',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Amini',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab561',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Araka',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab562',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Arjunpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab563',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Atarshuiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab564',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Babua Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab565',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Badaura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab566',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Bahara',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab567',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Baijal Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab568',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Bajardeeh',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab569',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Banauli',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab56a',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Bankat',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab56b',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Bansavariya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab56c',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Baradeeh',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab56d',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Baraki',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab56e',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Barani',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab56f',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Barema',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab570',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Barsata',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab571',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Basawan Chak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab572',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Basuhan Chak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab573',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Bazar Kalika',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab574',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Belawa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab575',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Besahoopur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab576',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Bhagautipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab577',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Bharhariya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab578',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Bhataulee',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab579',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Bhishampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab57a',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Bhitkuri',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab57b',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Bhorkala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab57c',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Bhor Khurd',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab57d',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Bhuilee',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab57e',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Bihada',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab57f',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Birampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab580',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Birapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab581',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Chak Amidahan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab582',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Chakchelhava',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab583',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Chak Lola',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab584',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Chak Sonabarasa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab585',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Chaktal Parewa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab586',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Chaura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab587',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Chhateri Manapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab588',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Chitrasenpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab589',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Dabethua',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab58a',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Dalpattipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab58b',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Danupur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab58c',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Daulatiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab58d',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Dayapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab58e',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Deipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab58f',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Devpalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab590',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Dewapur Kala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab591',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Dewapur Khurd',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab592',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Dhannipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab593',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Dilavalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab594',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Domaila',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab595',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Domanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab596',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Dubepur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab597',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Esarvar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab598',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Gaddopur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab599',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Gaharpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab59a',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Gairaha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab59b',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Gajapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab59c',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Gajepur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab59d',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Ghosila',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab59e',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Gogawa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab59f',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Gopal Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5a0',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Gorai',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5a1',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Gosaipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5a2',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Gudiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5a3',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Haribhanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5a4',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Harihar Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5a5',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Hathi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5a6',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Hirampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5a7',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Hirapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5a8',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Hittapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5a9',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Jaga Patti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5aa',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Jagashipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5ab',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Jagatipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5ac',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Jagdeeshpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5ad',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Jameen Balbhumihar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5ae',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Jameen Kardhana',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5af',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Jivarampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5b0',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Jogapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5b1',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Jogiyapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5b2',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Jummanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5b3',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Kamaldaha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5b4',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Kama Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5b5',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Kanshraipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5b6',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Kapsethi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5b7',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Kardhana',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5b8',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Katavaroopur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5b9',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Kevtan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5ba',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Khalispur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5bb',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Khamauna',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5bc',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Khandak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5bd',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Kharagrampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5be',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Khargoopur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5bf',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Khemapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5c0',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Khillupur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5c1',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Kinnupurchak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5c2',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Kuttupur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5c3',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Lachhipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5c4',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Lahiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5c5',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Lakchheepur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5c6',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Lakhansenpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5c7',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Lalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5c8',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Leduaai',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5c9',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Loharadeeh',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5ca',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Madaiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5cb',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Madhopur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5cc',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Mahagipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5cd',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Maharajpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5ce',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Maheshpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5cf',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Majhamatiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5d0',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Majhiyar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5d1',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Maniyari Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5d2',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Matuka',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5d3',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Milkipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5d4',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Mirchachak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5d5',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Mirchiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5d6',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Mokarama',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5d7',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Nahawanipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5d8',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Naktuwa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5d9',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Narayanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5da',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Nawalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5db',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Nayapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5dc',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Newada',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5dd',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Newadia',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5de',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Nimani',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5df',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Nonkhara',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5e0',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Odaraha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5e1',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Pachbanva',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5e2',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Pachwar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5e3',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Paraseepur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5e4',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Parsottampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5e5',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Paterchak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5e6',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Peduka',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5e7',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Puramajhila',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5e8',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Purandarpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5e9',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Purashiv',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5ea',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Pure',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5eb',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Purebariyar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5ec',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Purenanda',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5ed',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Raghunathpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5ee',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Raisipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5ef',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Rakhi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5f0',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Rakhi Nevada',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5f1',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Ram Datt Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5f2',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Ramdih',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5f3',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Rameshvar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5f4',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Ram Kishun Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5f5',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Ramnisf',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5f6',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Ram Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5f7',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Rampur Muttalake',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5f8',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Rampur Muttalake Sattanppur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5f9',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Ramrathauna',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5fa',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Rasulaha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5fb',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Ratanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5fc',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Sakalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5fd',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Sapehata',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5fe',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Sarang Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab5ff',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Satehada',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab600',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Sato',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab601',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Sattanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab602',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Shambhu Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab603',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Sheevdaspur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab604',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Sikhadi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab605',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Sirihira',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab606',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Sonbarasa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab607',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Suilara',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab608',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Sumerapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab609',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Tamachabad',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab60a',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Tara Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab60b',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Tatehara',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab60c',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Tekariya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab60d',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Telari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab60e',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Telhuaa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab60f',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Tendue',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab610',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Thathara',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab611',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Thekaha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab612',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Tiwari Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab613',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Todarpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab614',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Tribhuvanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab615',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Tulapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab616',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Uparwar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab617',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Chakatesua',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab618',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Ekdanga',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab619',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Khillupura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab61a',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Marhni',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab61b',
    },
    district: 'Varanasi',
    block: 'Sevapuri',
    village: 'Mariya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab61c',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Aharak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab61d',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Ajaipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab61e',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Amaut',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab61f',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Asawalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab620',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Asman Patti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab621',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Auraw',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab622',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Babatpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab623',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Badhauna',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab624',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Badhauta',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab625',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Baharipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab626',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Baikunthpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab627',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Balipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab628',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Bar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab629',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Baraipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab62a',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Barbaspur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab62b',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Barva',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab62c',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Basantpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab62d',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Basaw',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab62e',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Belari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab62f',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Bhadevali',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab630',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Bhagwatipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab631',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Bhai',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab632',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Bhanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab633',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Bharthipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab634',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Bhatbandha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab635',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Bhattpurava Khurd',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab636',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Bhopatpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab637',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Bhudkura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab638',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Buchi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab639',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Budava',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab63a',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Chakarama',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab63b',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Chak Dulla',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab63c',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Chamaru',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab63d',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Charo',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab63e',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Chehara',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab63f',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Chhataon',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab640',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Chintavan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab641',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Chitaura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab642',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Chiura Patti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab643',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Chiurapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab644',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Daharak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab645',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Dallipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab646',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Darunpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab647',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Dashrathpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab648',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Dayalipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab649',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Dayalpur Kala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab64a',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Dayalpur Khurd',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab64b',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Deoriya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab64c',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Devji',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab64d',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Devrae',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab64e',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Dharmanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab64f',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Dharsauna',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab650',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Dighiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab651',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Dindaspur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab652',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Dubeypur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab653',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Dudilpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab654',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Fattepur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab655',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Fattepur (hiramanpur)',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab656',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Gadakhada',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab657',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Gadar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab658',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Gajendra',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab659',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Gajokhar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab65a',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Gangapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab65b',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Ganzari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab65c',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Garthama',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab65d',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Ghamhapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab65e',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Ghoghali',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab65f',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Godiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab660',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Goghari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab661',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Gopal Patti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab662',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Gopalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab663',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Gori',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab664',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Harishankarpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab665',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Hathiwar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab666',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Hiramanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab667',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Indarkhapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab668',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Indarpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab669',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Jagdishpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab66a',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Jalalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab66b',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Jamalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab66c',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Jamapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab66d',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Jamkhor (vamokhar)',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab66e',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Jathi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab66f',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Jhanjhaur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab670',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Kachhiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab671',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Kaharaka',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab672',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Kamapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab673',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Kanakpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab674',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Karami',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab675',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Karemua',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab676',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Karkhiyaw',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab677',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Kashipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab678',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Katauna',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab679',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Katharawan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab67a',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Khajuhi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab67b',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Khalispur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab67c',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Khaliya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab67d',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Kharagpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab67e',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Khutaha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab67f',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Kiratpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab680',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Koireepur Kala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab681',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Kori',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab682',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Koyaripur Khurd',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab683',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Krishnapur Kala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab684',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Krisnapur Khurd',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab685',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Lallapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab686',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Lokapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab687',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Mahgaon',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab688',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Majhamatiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab689',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Majhawan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab68a',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Mangari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab68b',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Mani',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab68c',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Maniyakon',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab68d',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Marue',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab68e',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Mohanpoor',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab68f',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Moharpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab690',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Mulka',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab691',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Murdi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab692',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Nadoy',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab693',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Naikot',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab694',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Namapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab695',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Nama Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab696',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Nandapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab697',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Narayan Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab698',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Nathupur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab699',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Nawalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab69a',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Nayanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab69b',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Nehiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab69c',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Newada',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab69d',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Newari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab69e',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Nihalapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab69f',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Niwah',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6a0',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Odar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6a1',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Padari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6a2',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Parasaha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6a3',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Parsara',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6a4',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Paschimpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6a5',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Pashchim Patti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6a6',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Patirajpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6a7',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Patti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6a8',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Phulpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6a9',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Pindra',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6aa',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Pindrai',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6ab',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Prahaladpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6ac',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Prasadpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6ad',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Pratappur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6ae',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Purab Patti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6af',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Raghurampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6b0',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Rajpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6b1',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Ramai Patti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6b2',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Ramapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6b3',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Ramnagar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6b4',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Rampoor',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6b5',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Rampur (babatpur)',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6b6',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Rasulpoor',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6b7',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Ratanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6b8',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Ratwarbegpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6b9',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Roh',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6ba',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Sahamalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6bb',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Sahapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6bc',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Saira',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6bd',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Salivahanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6be',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Samogara',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6bf',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Sarahad',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6c0',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Sarai Bena',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6c1',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Sarai Takki',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6c2',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Saray',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6c3',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Saraybhogal',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6c4',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Saray Shekhlad',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6c5',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Shahpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6c6',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Shivpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6c7',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Sindhora',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6c8',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Sujaneepur (suganee)',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6c9',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Surahi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6ca',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Tarapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6cb',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Telaree',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6cc',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Thana',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6cd',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Thari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6ce',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Tikari Kala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6cf',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Tikari Khurd',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6d0',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Tiwaripur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6d1',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Udaypur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6d2',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Udhopur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6d3',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Vijai Patti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6d4',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Vikrampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6d5',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Vinda',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6d6',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Virdhawalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6d7',
    },
    district: 'Varanasi',
    block: 'Pindra',
    village: 'Visaipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6d8',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Abishan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6d9',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Adipah',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6da',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Araji Ghurma',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6db',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Arakhpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6dc',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Bahtura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6dd',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Baidauli',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6de',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Balua',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6df',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Barahi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6e0',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Barenda',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6e1',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Baswari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6e2',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Belsari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6e3',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Bhagmalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6e4',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Bhanapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6e5',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Bhatvana Ta. Tisauri',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6e6',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Bhauraha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6e7',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Bhikampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6e8',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Bhikharipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6e9',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Bihara',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6ea',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Bijaura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6eb',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Bijwanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6ec',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Birbalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6ed',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Boeri',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6ee',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Chak Dambar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6ef',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Chandpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6f0',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Chanwar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6f1',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Chaura Bogh',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6f2',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Churamanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6f3',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Dadi Kala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6f4',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Dadiwan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6f5',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Deevan Patti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6f6',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Dewapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6f7',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Dhobaha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6f8',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Dhotari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6f9',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Domanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6fa',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Dondsar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6fb',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Durkhushi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6fc',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Fatehpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6fd',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Fephra',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6fe',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Gain',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab6ff',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Gehundi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab700',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Ghariha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab701',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Govindpur Kirat',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab702',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Gulal Sarai',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab703',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Hameerpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab704',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Harhari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab705',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Hasanpura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab706',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Hridaypur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab707',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Indaura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab708',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Jagdishpur Autar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab709',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Jaitpura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab70a',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Jamira',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab70b',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Jargo Khas',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab70c',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Jasauli',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab70d',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Kabeerpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab70e',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Kalaura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab70f',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Kansahari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab710',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Kapurpah',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab711',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Karamdaspur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab712',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Kardah Kaithawali',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab713',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Karsarpurnankar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab714',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Kasba Goar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab715',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Kastuwa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab716',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Kelani',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab717',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Khajur Gaon',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab718',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Khatirpur Khas',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab719',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Khatirpur Takia',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab71a',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Khizirpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab71b',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Khozapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab71c',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Kisunpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab71d',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Kisunpur Gopal',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab71e',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Kodai',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab71f',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Kusehara',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab720',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Madanpura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab721',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Mahamudpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab722',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Mahegwan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab723',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Mahmoodpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab724',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Mahmudpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab725',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Malehun',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab726',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Maliknathpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab727',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Mangharia',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab728',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Mardah',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab729',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Marhi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab72a',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Mathiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab72b',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Mirpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab72c',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Mirzapur Mafi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab72d',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Narangpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab72e',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Narwar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab72f',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Nasaratpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab730',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Nasirpur Dadi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab731',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Nasirpur Kodari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab732',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Nasiruddinpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab733',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Nonara',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab734',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Paharpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab735',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Palahipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab736',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Palia',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab737',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Pandaypur Radhe',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab738',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Pandita',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab739',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Para',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab73a',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Pirthipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab73b',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Raipur Waghpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab73c',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Rajauli',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab73d',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Ramdoopur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab73e',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Ranipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab73f',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Rasulabad',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab740',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Rasulpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab741',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Ruhipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab742',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Rukkapur Ta. Sahabuddinpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab743',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Rumkapur Bihra',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab744',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Sahjadipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab745',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Sahodih',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab746',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Said Muhammad Chak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab747',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Samaurchak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab748',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Sarai Mubarak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab749',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Sarar Urf Haiderganj',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab74a',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Sarwandih',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab74b',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Sewtha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab74c',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Shadhopur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab74d',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Shahpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab74e',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Shakkapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab74f',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Shankarpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab750',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Sihora',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab751',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Singera',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab752',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Sonbarsa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab753',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Sudiya',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab754',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Sulemapur Deokali',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab755',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Sultanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab756',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Tahirpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab757',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Tarauti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab758',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Tawakkalpur Urf Dandapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab759',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Tejpura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab75a',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Tilari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab75b',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Tisauri',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab75c',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Uchoor',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab75d',
    },
    district: 'Ghazipur',
    block: 'Mardah',
    village: 'Harballabhpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab75e',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Eakdila',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab75f',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bhaisara T. Devali',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab760',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Naserpur Kusum',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab761',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Aalampur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab762',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Ahkapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab763',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Akasila',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab764',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Akawas Patti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab765',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Alipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab766',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Araji Kukudha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab767',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Araji Maphi Ramshala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab768',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Atarsua',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab769',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Babhanauli',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab76a',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Badahra',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab76b',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Baghipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab76c',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bahpura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab76d',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bahuta',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab76e',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Balahi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab76f',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Balasari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab770',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Balasi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab771',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Barahpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab772',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Baranpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab773',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Barathi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab774',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Barepur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab775',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Basipur Urf Piari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab776',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Basuchack',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab777',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Basu Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab778',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bhagawanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab779',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bharopur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab77a',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bharua',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab77b',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bharuka',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab77c',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bhataura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab77d',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bhawanipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab77e',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bhikhepur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab77f',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bhira',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab780',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bhitari Taraf Sadur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab781',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bhitari Taraphhatim',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab782',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Binwal',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab783',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bir Singhpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab784',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bishunpur Kala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab785',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bisun Pura',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab786',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bisunpur Padari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab787',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Bojh',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab788',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Budhanipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab789',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Budhanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab78a',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Budhauli',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab78b',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chakari Gangwarar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab78c',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chak Budasen',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab78d',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chakeri Upraw',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab78e',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chak Gaus',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab78f',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chakia Khatib',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab790',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chakia Muhammad',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab791',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chakjiram Wairagi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab792',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chak Jiwan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab793',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chak Kamal',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab794',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chak Latiph',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab795',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chak Pakari',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab796',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chakphatma Urf Balua',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab797',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chak Sajida',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab798',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chak Shah Muhajam',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab799',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chak Shah Muhammad',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab79a',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chakwaj Urph Bhatpurwa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab79b',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chak Yadgar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab79c',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Charipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab79d',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chaudi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab79e',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chhapara',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab79f',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chilar',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7a0',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Chitora',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7a1',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Dagipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7a2',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Dandapur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7a3',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Dawasiha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7a4',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Deochand Pur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7a5',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Deokali',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7a6',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Devpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7a7',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Dhanaipur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7a8',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Dharawa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7a9',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Dhari Kala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7aa',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Dhari Khurd',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7ab',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Dhruwarjun',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7ac',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Diyara Bad',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7ad',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Doria',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7ae',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Dubaitha',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7af',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Ebrahimpur Urf Talisa',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7b0',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Enayatpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7b1',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Fatehpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7b2',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Fatehpur Aual',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7b3',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Fatehpur Panjum',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7b4',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Fatehpur Soam',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7b5',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Fatehpur Susum',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7b6',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Fatehpur Taiyab',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7b7',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Gambhirpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7b8',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Garatholi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7b9',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Gobindpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7ba',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Goda Kala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7bb',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Gola',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7bc',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Gonda Khurd',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7bd',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Gopalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7be',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Habib Chack',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7bf',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Hajiabad',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7c0',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Hakimpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7c1',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Harakhpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7c2',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Harsinghpatti',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7c3',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Hasanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7c4',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Hathourhi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7c5',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Horilpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7c6',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Idilpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7c7',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Imilia',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7c8',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Isopur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7c9',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Jahanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7ca',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Jai Chand Chack',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7cb',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Jamin Mohiuddinpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7cc',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Jamin Mudarma',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7cd',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Janichak',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7ce',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Jeval',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7cf',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Jharagawan',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7d0',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Kakarawal',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7d1',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Kamalpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7d2',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Kanali',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7d3',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Kandhpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7d4',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Karhi',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7d5',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Kathghara Khadman',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7d6',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Khankah Kala',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7d7',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Khankah Khurd',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7d8',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Khanpur',
  },
  {
    _id: {
      $oid: '68b5f800183a8c2bd3aab7d9',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Khidori',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7da',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Khijir Pur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7db',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Khoda',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7dc',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Khojanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7dd',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Khutahan Namjad Bahiwalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7de',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Khutahan Namjad Karmaiya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7df',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Kishohari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7e0',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Koryadih',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7e1',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Kotawali',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7e2',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Koyalawar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7e3',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Kripal Chak',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7e4',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Kudhachawar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7e5',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Kundipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7e6',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Kunwarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7e7',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Kurah',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7e8',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Kurban Sarai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7e9',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Kusumi Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7ea',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Lonepur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7eb',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Luchimunpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7ec',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Madarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7ed',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Mahacha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7ee',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Mahadav Chack',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7ef',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Mahmoodpur Pali',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7f0',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Mahmud Hathini',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7f1',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Mahmudpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7f2',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Mahulia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7f3',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Malik Shah Pur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7f4',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Manjha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7f5',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Manjhari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7f6',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Manjharia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7f7',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Mansahipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7f8',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Marvan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7f9',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Maupara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7fa',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Mirpur Tirwah',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7fb',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Mohiudinpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7fc',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Mosempur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7fd',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Mosimpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7fe',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Mudarna',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab7ff',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Muhmadabad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab800',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Musapur Alam',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab801',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Muturjipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab802',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Nari Pachdewa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab803',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Nasara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab804',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Nasirabad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab805',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Nasirpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab806',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Nasirpur Hamida Chak',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab807',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Nasirpur Mutalika Durgapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab808',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Neecoat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab809',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Nidhuna',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab80a',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Nindopur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab80b',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Nohata',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab80c',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Pachara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab80d',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Pacharasi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab80e',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Padari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab80f',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Pahalatola',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab810',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Pahalwanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab811',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Paharpur Kala',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab812',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Pakawali',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab813',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Palia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab814',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Pathanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab815',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Patti Chittauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab816',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Pharid Chack',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab817',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Phulwari Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab818',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Piparahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab819',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Pohitpar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab81a',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Poota',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab81b',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Pura Ahiran',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab81c',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Raddipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab81d',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Rahimpur Urf Musalimpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab81e',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Raispur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab81f',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Rajadipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab820',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Rajapur Urf Alampur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab821',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Rajmalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab822',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Rajupur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab823',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Rampur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab824',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Rampur Bantara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab825',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Rampur Khatika',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab826',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Rasulpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab827',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Rasulpur Kolawar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab828',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Rasulpur Pachrasi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab829',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Rathauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab82a',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sadaku Chack',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab82b',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sagara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab82c',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sahabuddinpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab82d',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sahdullapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab82e',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Saichana',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab82f',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Saidan Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab830',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Salempur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab831',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Samanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab832',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sammanpur Newada',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab833',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sarai Sarif',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab834',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sarai Talbi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab835',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sarauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab836',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sarayamanulla',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab837',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sarwar Nagar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab838',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sehamal Pur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab839',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Seyanwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab83a',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Shahpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab83b',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Shakhpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab83c',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Shankarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab83d',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sharvarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab83e',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Shikarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab83f',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Shiwaadhan Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab840',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Shiwasingh Chak',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab841',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sihori',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab842',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sikandar Chack Hatim',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab843',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sikandarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab844',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sirgitha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab845',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sivdasi Chack',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab846',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sonhouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab847',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Srichack',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab848',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sripal Chack',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab849',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sultanpur Maphi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab84a',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Sumar Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab84b',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Tadirpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab84c',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Tajpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab84d',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Taraw',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab84e',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Tardih',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab84f',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Thehuna',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab850',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Todarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab851',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Turana',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab852',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Turkahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab853',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Vikhaepur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab854',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Wajid Chack',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab855',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Wikachak',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab856',
    },
    district: 'Ghazipur',
    block: 'Devkali',
    village: 'Wiskalan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab857',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Bara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab858',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Bhadaura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab858',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Sayar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab859',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Ahibaranpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab85a',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Akbarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab85b',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Amaura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab85c',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Arangi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab85d',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Ashanandpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab85e',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Bagesari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab85f',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Bahuwara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab860',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Bakainia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab861',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Baksara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab862',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Bareji',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab863',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Bhabhanaulia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab864',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Bhaksi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab865',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Bhataura Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab866',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Bhataura Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab867',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Chakbidaman',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab868',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Chak Ruknuddin',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab869',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Chand Barhi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab86a',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Chaurahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab86b',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Chitrakoni',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab86c',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Dalpatpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab86d',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Deo Dhanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab86e',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Deokali',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab86f',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Dewal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab870',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Dhanapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab871',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Dhanari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab872',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Dildar Nagar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab873',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Faridpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab874',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Gadaipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab875',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Gahmar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab876',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Ghoswal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab877',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Gorsara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab878',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Harishankarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab879',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Harkarnpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab87a',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Harnathpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab87b',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Hathauri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab87c',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Itwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab87d',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Jagwal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab87e',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Jalalpur T. Bhatura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab87f',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Jivnrain Pur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab880',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Kamesaradih',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab881',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Kapoor Pur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab882',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Karahia Khas',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab883',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Karma',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab884',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Keshopur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab885',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Khajuri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab886',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Khemapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab887',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Khudra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab888',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Kusiyra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab889',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Kutubpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab88a',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Lahana',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab88b',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Magarkhai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab88c',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Mahmoodpur T Karahia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab88d',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Malikfarid',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab88e',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Malikpur Lazi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab88f',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Malikpur T Gahmar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab890',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Mania',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab891',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Manihar Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab892',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Maniharkalan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab893',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Manihar Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab894',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Misraulia T. Bara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab895',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Misraulia T. Gahmar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab896',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Nirahukapura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab897',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Nizampur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab898',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Pachauri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab899',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Pah Gobardhan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab89a',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Pah Majhauwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab89b',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Palia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab89c',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Pathara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab89d',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Patkhaulia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab89e',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Piprauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab89f',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Raisenpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8a0',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Rajaipur Urf Rampur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8a1',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Rajmal Bandh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8a2',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Raksaha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8a3',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Rampur Kanwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8a4',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Rampur Katuia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8a5',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Rampur Urf Ramgarh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8a6',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Rasulpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8a7',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Roini',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8a8',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Sadhopur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8a9',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Sadhopur T Gahmar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8aa',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Sakarahat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8ab',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Saraila Chitrakoni',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8ac',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Sawrai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8ad',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Shair T Gahmar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8ae',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Sherpur T Karahia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8af',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Sihani',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8b0',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Sikandarpur T. Bara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8b1',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Sikandarpur T Gahmar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8b2',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Singha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8b3',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Sultanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8b4',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Suraha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8b5',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Suryabhanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8b6',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Tajpur Kurra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8b7',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Tarawa Urf Tilhatha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8b8',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Tikuria Kalan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8b9',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Tikuria Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8ba',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Uchitpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8bb',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Usia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8bc',
    },
    district: 'Ghazipur',
    block: 'Bhadaura',
    village: 'Wah Saroop',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8bd',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Hasanpura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8be',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Athahatha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8bf',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Awati',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8c0',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Baraura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8c1',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Basuka',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8c2',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Bawara Mustahakam',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8c3',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Begua',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8c4',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Abdullapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8c5',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Andhi Tilwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8c6',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Bahadurpur Jagjiwan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8c7',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Bahadurpur T Reotipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8c8',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Bharwalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8c9',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Bhikhi Chaura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8ca',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Bhupat Chak',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8cb',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Biraupur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8cc',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Budadeeh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8cd',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Chak Baksan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8ce',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Chakdharni',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8cf',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Chak Kalyan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8d0',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Chak Khan Mohammad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8d1',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Chak Mahibulla',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8d2',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Chak Muniam',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8d3',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Chak Paran',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8d4',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Chak Parsotam Dhodha Das',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8d5',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Chaksarai Baikunathpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8d6',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Dalpatpur T Reotipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8d7',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Daridih',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8d8',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Daswantpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8d9',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Derhgawan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8da',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Dohala',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8db',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Dullahpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8dc',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Gagran',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8dd',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Gangbarar Bawara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8de',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Gang Barar Dawami Patkani',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8df',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Gangbarar Juvrajpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8e0',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Gang Barar Madid Patkanian',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8e1',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Gang Barar Mednipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8e2',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Gangbarar Tari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8e3',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Gaura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8e4',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Gohda Bishun Pura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8e5',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Gopalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8e6',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Gopinath Pur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8e7',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Govindpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8e8',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Harchand Pur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8e9',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Harshankarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8ea',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Hasan Chak',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8eb',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Hetmapur T Reotipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8ec',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Jagbandhanpur Urf Mubarakpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8ed',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Jagopur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8ee',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Jamalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8ef',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Jarchha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8f0',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Juvraj Pur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8f1',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Kalupur Mustahakam',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8f2',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Kalyanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8f3',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Kauria Pah',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8f4',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Kawal Niranjan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8f5',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Kharagsenpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8f6',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Kulharia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8f7',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Lakhmipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8f8',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Madhu Chak',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8f9',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Mahnakalan Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8fa',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Mednipur Mustahakam',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8fb',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Mirzapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8fc',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Nagdilpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8fd',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Nagsar Mir Rai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8fe',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Nagsar Newajurai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab8ff',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Narainpur Urf Hariharpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab900',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Nasirpur T Reotipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab901',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Nawali',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab902',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Noor Pur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab903',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Pakari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab904',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Parmanandpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab905',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Patkania',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab906',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Patkholia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab907',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Piajua',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab908',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Prithvipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab909',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Rampur T Reotipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab90a',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Ramwal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab90b',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Reotipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab90c',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Sadhopur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab90d',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Sarahula',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab90e',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Sayelapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab90f',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Shital Chak',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab910',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Sihuli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab911',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Sonwal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab912',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Sugbalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab913',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Suhwal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab914',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Sujan Pur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab915',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Tajpur Kalu',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab916',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Tari Mustahakam',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab917',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Taunga',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab918',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Tilwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab919',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Tirlokpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab91a',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Udhranpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab91b',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Usaon',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab91c',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Utrauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab91d',
    },
    district: 'Ghazipur',
    block: 'Revatipur',
    village: 'Vegua',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab91e',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Abdalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab91f',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Akberpur Saraidina',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab920',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Akhaipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab921',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Alawalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab922',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Anedhi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab923',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Badgaon',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab924',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Banka Jalalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab925',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Baraepur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab926',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Baramau',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab927',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Basdaiya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab928',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Birbhanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab929',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Birsinghpur Urf Allipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab92a',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Bisani Urf Shikohabad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab92b',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Bishambherpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab92c',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Chack Baher',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab92d',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Chack Qazi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab92e',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Cheete Mau',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab92f',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Dadauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab930',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Daudpurnewada',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab931',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Deogalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab932',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Dewaria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab933',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Dharauta',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab934',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Dubahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab935',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Gadh Champa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab936',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Gadhina',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab937',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Gadiyani',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab938',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Gheenpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab939',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Harakhpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab93a',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Ismailpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab93b',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Ismailpur Ta.abdalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab93c',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Jagdishpur Dayal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab93d',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Jagdishpur Medi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab93e',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Jalalpur Katata',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab93f',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Jamkhuri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab940',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Jamui',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab941',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Jogipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab942',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Kasturipur Herkishun',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab943',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Kathwer Perwaizpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab944',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Katra Dayaram',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab945',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Khaninar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab946',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Khergapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab947',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Madari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab948',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Mahraunda',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab949',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Malakbela',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab94a',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Malak Payagi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab94b',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Malkhanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab94c',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Mani Umarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab94d',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Markhamau',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab94e',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Mau Aima',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab94f',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Mirzapur Abubakarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab950',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Misir Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab951',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Mohammadpur Maganpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab952',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Mohammadpur Sarai Ali',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab953',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Nazarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab954',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Persupur Gopal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab955',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Phulpurbam Urf Bhikhu',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab956',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Phulpurbikram Urf Gopalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab957',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Pil Khuwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab958',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Pipari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab959',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Puranpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab95a',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Purkhipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab95b',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Raghunathpur Herduwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab95c',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Ramaipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab95d',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Ramapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab95e',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Ramnagar Umrinizampur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab95f',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Ramnager Gansiari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab960',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Rampur Urf Kalyanshah',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab961',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Rasoolpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab962',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Ratansainpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab963',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Saidaha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab964',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Sakra Mau',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab965',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Sarai Alauddin Urf Jogapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab966',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Sarai Atan Urf Naugira',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab967',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Sarai Badshan Kuli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab968',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Saraidina',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab969',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Saraikesho Urf Bagi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab96a',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Sarai Lalu',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab96b',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Semra Birbhanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab96c',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Shahbazpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab96d',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Shaikhpur Sarai Bharat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab96e',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Sikandarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab96f',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Siswan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab970',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Sulempur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab971',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Sultanpur Khas',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab972',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Surajbhanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab973',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Tawakkalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab974',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Tejopur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab975',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Tikari Taluka Abdalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab976',
    },
    district: 'Prayagraj',
    block: 'Mauaima',
    village: 'Yasinpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab977',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Aadampur Upraura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab978',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Abhae Pur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab979',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Ahirai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab97a',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Arazi Dehigair Abad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab97b',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Atanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab97c',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Awraha Kachar Gair Abad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab97d',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Awrahauperhar Gair Abad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab97e',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Badalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab97f',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Baijpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab980',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Bajahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab981',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Bakrabad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab982',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Baksera',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab983',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Balipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab984',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Balkaranpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab985',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Bankat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab986',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Baraura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab987',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Barji',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab988',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Basrahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab989',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Beerapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab98a',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Bela Shailabi Gair Abad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab98b',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Berue',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab98c',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Bhaderpur Urf Deenapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab98d',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Bhane Mau',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab98e',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Bharatpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab98f',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Bharehta',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab990',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Bhawanapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab991',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Bhawanigarh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab992',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Bir Bhaderpur Urf Kalipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab993',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Bomapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab994',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Buapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab995',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaimalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab996',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chak Amanullah Urf Chaqmoodan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab997',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chakerbhanpur Urf Chakiya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab998',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chak Esa Urf Shiwgarh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab999',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chak Sulatan Urf Newada',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab99a',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chak Yarmohammad Urf Rampur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab99b',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chamarupur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab99c',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chamarupur Urf Beerganj',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab99d',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chanderpur Urf Busmahua',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab99e',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chandi Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab99f',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chandoopur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9a0',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chandrawat Urf Poore Matadin',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9a1',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Afzal Urf Poorelila',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9a2',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Bhikhauna',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9a3',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Faijulla Urf Bhauka',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9a4',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Fatima Urf Madhopur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9a5',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Hafiz Urf Pooresital',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9a6',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Jayanti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9a7',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Julekha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9a8',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Kafa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9a9',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Kasiram',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9aa',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Keshaw',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9ab',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Kewat Ali Gair Abad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9ac',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Masaud',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9ad',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Moahammad Urf Risal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9ae',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Mohamid',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9af',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Mohiuddin',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9b0',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Nooruddin Urf Nagdilpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9b1',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Payagi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9b2',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Piyaran',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9b3',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Piyaran Urf Paritapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9b4',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaqsaban',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9b5',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Saiuddin Urf Pooremati',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9b6',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Sekhahmed Urf Pooredudi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9b7',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Shahbeg Urframpur Dadi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9b8',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Shekhlal Urf Sadhopur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9b9',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaq Sheyam Urf Poore Hinchha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9ba',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chata',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9bb',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Chaturpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9bc',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Dalipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9bd',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Damoderpur Urf Tiwaripur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9be',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Deura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9bf',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Devkipur Urf Bijulipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9c0',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Dewapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9c1',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Dewarya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9c2',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Dhamaur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9c3',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Dhanpalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9c4',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Dharampur Urf Dhurwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9c5',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Dhosra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9c6',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Dhuripur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9c7',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Fajlabad Urf Kaloopur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9c8',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Gaharpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9c9',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Gamrahta',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9ca',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Garapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9cb',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Gauhani',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9cc',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Goberdhanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9cd',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Godwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9ce',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Gorapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9cf',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Hariram Patti Urf Katnae',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9d0',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Hasanpur Korari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9d1',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Hasanpur Mai Chak Mansoor',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9d2',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Hasimpur Urf Benipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9d3',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Hatiya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9d4',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Hetapatti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9d5',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Husenpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9d6',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Jagdeeshpur Urf Jalalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9d7',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Jalal Uddinpur Urf Mahpoora',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9d8',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Jamha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9d9',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Jamua',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9da',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Jiwnarayanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9db',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Jugunideeh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9dc',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Kadipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9dd',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Kahli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9de',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Kalleyanpur Urf Lonari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9df',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Karmha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9e0',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Katiyahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9e1',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Kerkatepur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9e2',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Khalsa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9e3',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Khewrajpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9e4',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Khojapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9e5',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Kiranw',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9e6',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Kumbhauna',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9e7',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Kusungur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9e8',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Lakhrawan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9e9',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Lokapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9ea',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Madarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9eb',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Madhopur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9ec',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Madra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9ed',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Mahuli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9ee',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Mailha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9ef',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Malaka',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9f0',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Malaka Mai Bhai Sahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9f1',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Malipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9f2',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Mansoorpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9f3',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Mathura Urf Parandeeh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9f4',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Meerakpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9f5',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Mohammadbad Urf Gopalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9f6',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Mohammadpur Maichaq Shah Moham',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9f7',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Mulhapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9f8',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Muradpur Urf Khadirpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9f9',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Mustafabad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9fa',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Nadiyani',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9fb',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Nagaepur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9fc',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Narayanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9fd',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Nari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9fe',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Nasratpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aab9ff',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Nawab Urf Khanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba00',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Newada',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba01',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Nimi Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba02',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Noorpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba03',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Oharpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba04',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Padumpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba05',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Paigamberpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba06',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Partappur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba07',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Permanandpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba08',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Poore Bagi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba09',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Poore Bhaiya Ram',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba0a',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Poore Durgi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba0b',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Poore Gopi Urf Lahti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba0c',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Poore Pandey',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba0d',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Poore Rudrashah',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba0e',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Pure Fauzshah',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba0f',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Purusottampur Urf Garapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba10',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Raghunathpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba11',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Raide Pur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba12',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Rajepursani Urf Rajjupur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba13',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Ramgarh Kothari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba14',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Rampur Urf Doulatpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba15',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Ruhera',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba16',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sadalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba17',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sadhopur Urf Sulemanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba18',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sakra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba19',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Abdul Ganigair Abad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba1a',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Aziz Ta.harkishun',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba1b',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Chandi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba1c',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Danshah',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba1d',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Darashikoh Urf Mijhura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba1e',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Saraidatte',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba1f',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Gambhirdas Urf Bibipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba20',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Gani',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba21',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Herkishun',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba22',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Saraijeetrai Urf Pure Bhawa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba23',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Jhanjha Urf Jhaliya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba24',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Jodhrai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba25',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Khandev',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba26',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Saraikhowaja',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba27',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Khwaza Urf Baghola',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba28',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Lahuri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba29',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Lili Urf Berchanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba2a',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Madan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba2b',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Mohiuddin',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba2c',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Pargair Abad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba2d',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Raijot',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba2e',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Sultan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba2f',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Sultan Urf Poore Makhdoo',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba30',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Todermal Urf Dandupur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba31',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarai Youdhisthir',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba32',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarangpur Taluka Belwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba33',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sarangpur Taluka Kahli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba34',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sari Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba35',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Satanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba36',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Shefkhanpur Urf Chilharai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba37',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Shivpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba38',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Shukulpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba39',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sihori Kachar Gair Abad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba3a',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sihori Uperhar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba3b',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sikandra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba3c',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Singaldeep',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba3d',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sirkindiya Gair Abad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba3e',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sisae Sipah',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba3f',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Sultanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba40',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Suprawari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba41',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Tejpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba42',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Teliyabeer',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba43',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Tikari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba44',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Trilokpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba45',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Tulapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba46',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Udhopurkhagiya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba47',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Wazirpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba48',
    },
    district: 'Prayagraj',
    block: 'Bahria',
    village: 'Yasinpur Urf Karnayeepur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba49',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Aalemau',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba4a',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Agahua',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba4b',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Agra Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba4c',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Akdala',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba4d',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Amiliya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba4e',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Arwansimai Bahadurgarh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba4f',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Atamadpur Urf Mishrapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba50',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Atraura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba51',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Badnama',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba52',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Bagae Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba53',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Balkranpur Mai Kasrawe',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba54',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Baro',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba55',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Basaudha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba56',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Batwansi Urf Poore Bihari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba57',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Baudai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba58',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Beerbhanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba59',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Beer Kaji',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba5a',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Belwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba5b',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Benipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba5c',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Bhamae Husamganj',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba5d',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Bhanewara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba5e',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Bharahri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba5f',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Bigahiya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba60',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chak Abusaed Urf Pooremiya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba61',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chak Alabksh Gair Awad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba62',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chak Bikhari Urf Parsadih',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba63',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chak Kajiolia Urf Khojapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba64',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chak Kashim Urf Phulpur Bahar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba65',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chak Miya Urf Chakesha(gairaba',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba66',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chak Mohamd Urf Pooresood',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba67',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chakralipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba68',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chamrupur Urf Nandout',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba69',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chandauhan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba6a',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chaq Abdul Krim Urf Pure Mulai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba6b',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chaq Abdul Shakoor Urf Hatia G',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba6c',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chaq Afrad Urf Mubarakpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba6d',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chaq Ali Urf Poore Gopali',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba6e',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chaq Dostmohammad Urfmohammadp',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba6f',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chaq Hafiz Badruddin Urf Konar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba70',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chaq Husaina Urf Chor Kariya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba71',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chaq Kutubujjama Urf Jalalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba72',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chaq Mali',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba73',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chaqpeer Mohammd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba74',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chaq Sekh Ahmed Urf Kusehta',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba75',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chaq Shahabuddin Urf Chitha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba76',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chaq Sultan Mohammad Urf Nusar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba77',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chikhari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba78',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chilaura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba79',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chilauri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba7a',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chintamanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba7b',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chitraha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba7c',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Chorhae',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba7d',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Dariyapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba7e',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Dariyapur Nandaut',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba7f',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Dayalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba80',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Devnahri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba81',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Dhelha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba82',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Dhokari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba83',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Fazilapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba84',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Firojpur Urf Shekhpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba85',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Firozpur Ta.bharahri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba86',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Gagaur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba87',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Gagawr',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba88',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Girdherpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba89',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Hansrajpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba8a',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Hemapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba8b',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Herbhanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba8c',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Jaferpur Urf Babuganj',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba8d',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Jagdev Urf Barethi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba8e',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Jalaluddinpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba8f',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Junedpatti Gairabad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba90',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Kanauja Kala',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba91',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Kanauja Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba92',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Kanehti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba93',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Kapsa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba94',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Kasarawe May Chakoliya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba95',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Khansar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba96',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Khanupur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba97',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Khudaypur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba98',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Khudaypur Kasganw',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba99',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Khwajgipatti Urf Belahabandh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba9a',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Korapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba9b',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Kutubpatti Urf Ahiapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba9c',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Kutubpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba9d',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Latifpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba9e',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Lilhat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aaba9f',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Mailhan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaa0',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Makhdoompur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaa1',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Malkapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaa2',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Manapur Urf Bagae Kla',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaa3',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Manethu',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaa4',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Mansi Bujurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaa5',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Mansi Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaa6',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Mehdipur Urf Poore Indra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaa7',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Mohamadabad Urf Mialwan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaa8',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Mubrakpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaa9',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Mugara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaaa',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Narae',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaab',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Narayanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaac',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Pahsi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaad',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Pali',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaae',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Parasinpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaaf',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Patulki',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabab0',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Perwezabad',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabab1',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Pooranpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabab2',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Raini',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabab3',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Rajapur May Kajioliya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabab4',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Rajepur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabab5',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Rajepur Mai Sarai Aerjani',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabab6',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Ram Nath Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabab7',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Rampur Maya Keshawrampur Urf M',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabab8',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Rasoolpur Dehmafi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabab9',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Rasulpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aababa',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Roodapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aababb',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Saoraha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aababc',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Sarai Abdulmalik (ct)',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aababd',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Sarai Abhaichand Urf Chandauki',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aababe',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Sarai Aerjani',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aababf',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Sarai Aziz Urf Azizpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabac0',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Sarai Daud Urf Dhaqpura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabac1',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Sarai Gopi Urf Jhanjhari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabac2',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Sarai Husena',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabac3',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Sarai Jaina',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabac4',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Saraikhowaja Klan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabac5',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Sarai Khundmir',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabac6',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Sarai Lili Urf Khojapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabac7',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Sarai Saiydbare Urf Yaseenpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabac8',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Saraisultan Urf Alipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabac9',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Sarai Wirindawan Urfchaq Jani',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaca',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Saray Ghurdas Urf Mahajudwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabacb',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Saray Kutubddin Urf Shekhpur J',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabacc',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Saray Manohar Urf Barjibara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabacd',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Saray Smael Urf Madhpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabace',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Sawdih',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabacf',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Sehunadeeh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabad0',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Semari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabad1',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Serwadeeh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabad2',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Shahapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabad3',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Shefkhanpur Mai Chaqsalik',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabad4',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Shivgarh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabad5',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Shrai Shekhpeer Urf Salmapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabad6',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Silokhra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabad7',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Sonkhari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabad8',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Tardeeh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabad9',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Thanapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabada',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Tisaura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabadb',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Tulsipatti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabadc',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Udaepur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabadd',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Umari Maitatehra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabade',
    },
    district: 'Prayagraj',
    block: 'Phulpur',
    village: 'Umer Pur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabadf',
    },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Aladadpur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabadf' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Ulda (Maheshganj)',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabaf0' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Malak Balaoo',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabaf1' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Sarai Dadan',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabaf2' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Mansoorabad',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabaf3' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Jamua Urf Bhawanipur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabaf4' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Ganipur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabaf5' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Kudha',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabaf6' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Mendara',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabaf7' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Bajha',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabaf8' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Samhai',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabaf9' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Serawa',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabafa' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Ibrahimpur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabafb' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Singraur Uparhar',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabafc' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Berawa',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabafd' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Munawarpur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabafe' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Belha',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabaff' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Sarai Chandrabhan Urf Nanansai',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb00' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Raghuvanshpur Urf Rerua',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb01' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Sahavpur (Sa.Ta. Sahavpur)',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb02' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Lai',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb03' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Khargapur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb04' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Mohiuddinpur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb05' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Arjunpur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb06' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Pardhpur Bhagdewra',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb07' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Bareepur Harkh',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb08' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Naseerpur Dargahi',
  },

  {
    _id: { $oid: '68b5f801183a8c2bd3aabb09' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Bhagwatipur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb0a' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Aanapur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb0b' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Pipraundh',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb0c' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Kamalapur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb0d' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Andhiyari',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb0e' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Aladadpur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb0f' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Khandrauli',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb10' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Pannupur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb11' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Sarai Rah Korari',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb12' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Piyari Urf Vijlipur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb13' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Korari',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb14' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Bareepur Ramnagar',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb15' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Maroofpur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb16' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Fatehpur Kayasthan',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb17' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Phoolpur Urf Jagapur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb18' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Gariyanwa',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb19' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Kasturipur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb1a' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Daharpur Urf Bandhpur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb1b' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Ramdaspur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb1c' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Patna Uparhar',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb1d' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Kashipur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb1e' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Moharab',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb1f' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Paschimanara',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb20' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Madupur Ramnagar',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabb21' },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Judapur Beehar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabae0',
    },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Arjunpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabae1',
    },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Bajha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabae2',
    },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Barai Harakh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabae3',
    },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Berawan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabae4',
    },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Jurapur Biher',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabae5',
    },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Kashipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabae6',
    },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Khargapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabae7',
    },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Madupur Ramnagar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabae8',
    },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Pachim Nara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabae9',
    },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Ramdaspur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaea',
    },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Sarai Chndrabhan Urf Nansnsai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaeb',
    },
    district: 'Prayagraj',
    block: 'Sringverpur Dham',
    village: 'Serawan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaec',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Adrauna',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaed',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Ahirauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaee',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Ahirauli Kusumhi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaef',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Amadaria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaf0',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Amawa Bazar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaf1',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Badahara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaf2',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Ba;gaha Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaf3',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Bairia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaf4',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Barwa Asthan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaf5',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Barwa Mahadewa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaf6',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Basdila',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaf7',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Bhathahi Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaf8',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Bhathahi Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaf9',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Bihuli Nisfi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabafa',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Bihuli Shumali Urf Hanuman Gan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabafb',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Bishunpura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabafc',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Chak Abdul Islam',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabafd',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Chandarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabafe',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Deoria Babu',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabaff',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Deulia Maniya Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb00',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Dhanauji Khas',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb01',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Dhanauji Mafi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb02',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Dharmauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb03',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Dharm Samda',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb04',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Dhodharahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb05',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Dhuan Tikar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb06',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Farna',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb07',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Inder Senwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb08',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Jamun Barwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb09',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Khairatawa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb0a',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Khotahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb0b',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Kusumahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb0c',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Kusumha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb0d',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Lala Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb0e',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Mandey Rai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb0f',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Mathia Barghat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb10',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Morwan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb11',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Moti Pakar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb12',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Padari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb13',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Pagar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb14',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Pakari Bangar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb15',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Pakari Bantir Saunha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb16',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Pakari Bantir Urf Mehndiganj',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb17',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Papaur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb18',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Paroraha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb19',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Pathar Dewa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb1a',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Phulwaria Magarib',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb1b',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Phulwaria Masriq',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb1c',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Pindari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb1d',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Ramkola',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb1e',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Rampur Bagaha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb1f',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Saneramal Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb20',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Sapaha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb21',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Shivpor Mathiya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb22',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Sidhawat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb23',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Sihulia Mathia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb24',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Sohrauna',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb25',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Tarkulwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb26',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Urdaha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb27',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Arazi Sidhawe',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb28',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Chaurahi Urf Anjahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb29',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Kathgharhi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb2a',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Parsauna',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb2b',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Parsauna Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb2c',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Parwarpar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb2d',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Rambar Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb2e',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Sidhawe',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb2f',
    },
    district: 'Kushinagar',
    block: 'Ramkola',
    village: 'Tekuatar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb30',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Bahorapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb31',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Baij Nathpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb32',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Basdeopur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb33',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Batar Dera',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb34',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Bhatwalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb35',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Dharni Chhapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb36',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Durgwalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb37',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jigana',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb38',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jigani',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb39',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Khardewa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb3a',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Kohra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb3b',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Mathia Naraipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb3c',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Mathia Tapsi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb3d',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Narsar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb3e',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Phagupur Bishunpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb3f',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Pipra Tiwari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb40',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Ramhwalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb41',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sakhopar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb42',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sampur Hatwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb43',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sekhwania Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb44',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Shekhwania Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb45',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Shivpur Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb46',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Shivpur Dih',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb47',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sondia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb48',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Adhar Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb49',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Ahirauli Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb4a',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Ahirauli Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb4b',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Andhari Bari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb4c',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Badal Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb4d',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Badrauna',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb4e',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Bahadurganj',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb4f',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Baldiha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb50',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Balochaha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb51',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Bandhu Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb52',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Bandi Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb53',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Barahaj',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb54',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Bargaon',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb55',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Barhwalia Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb56',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Barhwalia Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb57',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Barwa Kalan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb58',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Barwa Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb59',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Basdila',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb5a',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Bashia Banbirpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb5b',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Batrauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb5c',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Belahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb5d',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Belwa Misir',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb5e',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Bharwalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb5f',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Bhiswa Lala',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb60',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Bhiswa Sarkari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb61',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Bishunpura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb62',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Chain Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb63',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Chakia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb64',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Chandarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb65',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Chauparia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb66',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Chaura Khas',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb67',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Chauria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb68',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Chhitan Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb69',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Dal Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb6a',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Dambatia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb6b',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Deoria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb6c',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Deoria Pandey',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb6d',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Dharampur Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb6e',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Dharampur Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb6f',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Dheer Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb70',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Dumar Bhar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb71',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Ganeshi Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb72',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Gangauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb73',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Gangrani',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb74',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Ghorghatia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb75',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Gopalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb76',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Gulelha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb77',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Haraiya Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb78',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Haraiya Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb79',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Harka Baijnath Mal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb7a',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Harka Ghurmal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb7b',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Harka Hanmantgir',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb7c',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Harka Malik Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb7d',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Hirnaha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb7e',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Horilapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb7f',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Indra Senwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb80',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungal Piprasi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb81',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Amwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb82',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Bakulha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb83',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Banbirpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb84',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Bangali Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb85',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Belwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb86',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Bishunpura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb87',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Chauria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb88',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Dharampur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb89',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Gai Ghat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb8a',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Hanumanganj',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb8b',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Jagdishpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb8c',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Khirkia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb8d',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Kurmaul',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb8e',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Nahar Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb8f',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Nonia Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb90',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Pachrukhia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb91',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jungle Sukhpura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb92',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Jura Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb93',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Kalyan Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb94',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Karhia Hazari Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb95',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Kasia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb96',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Kathkuia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb97',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Kati',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb98',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Katya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb99',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Kewal Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb9a',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Khadda Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb9b',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Khadda Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb9c',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Khanwar Baklolahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb9d',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Khudra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb9e',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Koharwalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabb9f',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Lamkan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabba0',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Lamuha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabba1',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Laxmipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabba2',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Madariha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabba3',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Maghi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabba4',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Maharani',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabba5',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Maila',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabba6',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Majra Kewal Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabba7',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Mathia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabba8',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Mathia Basant Pande',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabba9',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Mathia Jai Kishun',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbaa',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Mathia Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbab',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Mathia Raghunath',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbac',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Mathia Ram Govind',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbad',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Mathiya Devi Sahay',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbae',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Matihania Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbaf',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Matihania Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbb0',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Milki',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbb1',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Misir Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbb2',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Misrauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbb3',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Moti Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbb4',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Nadah',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbb5',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Naugaon Inrahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbb6',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Nautan Hardo',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbb7',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Oharwalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbb8',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Pachphera',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbb9',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Padari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbba',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Pagara Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbbb',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Pakri Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbbc',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Pakri Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbbd',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Palia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbbe',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Parsadpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbbf',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Parsauni',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbc0',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Parsauni Kalan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbc1',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Patkhauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbc2',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Pipar Sujan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbc3',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Pipra Jatanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbc4',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Pipra Majra Dharampur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbc5',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Piprasi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbc6',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Pipra Sobhmal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbc7',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Pradhan Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbc8',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Rahasu',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbc9',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Rampur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbca',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Rasulpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbcb',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Ratanwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbcc',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sadi Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbcd',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sadi Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbce',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sahajwalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbcf',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sahuadih',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbd0',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sarpathi Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbd1',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sarya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbd2',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Semara Hardo',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbd3',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Semria Kalan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbd4',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Semria Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbd5',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sewak Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbd6',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Shukul Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbd7',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sidhua',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbd8',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sidhua Bagar Bhath',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbd9',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Siganjori',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbda',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sikta',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbdb',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Siswa Mathia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbdc',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sohanaria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbdd',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sohrauna',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbde',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Sugahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbdf',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Suswalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbe0',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Tadawa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbe1',
    },
    district: 'Kushinagar',
    block: 'Padrauna',
    village: 'Thagda',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbe2',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Atardiha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbe3',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Babhnauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbe4',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Badal Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbe5',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Badhara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbe6',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Baglaha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbe7',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Bali',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbe8',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Baluahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbe9',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Bandhu Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbea',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Bandhwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbeb',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Bargaha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbec',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Barwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbed',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Barwa Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbee',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Basantpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbef',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Belwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbf0',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Bhimal Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbf1',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Bishunpura Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbf2',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Chak Chintaman',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbf3',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Chakhani Bhoj Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbf4',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Chakhni Bhmi Hari Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbf5',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Chakhni Mafi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbf6',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Chakhnipuran Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbf7',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Darbahaganga Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbf8',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Deo Gaon',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbf9',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Deotaha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbfa',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Dhinuhua',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbfb',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Dhir Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbfc',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Dholha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbfd',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Ekdanga Bhajan Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbfe',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Feru Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabbff',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Gulriha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc00',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Harju Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc01',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Har Keshwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc02',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Harpur Maphi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc03',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Harpur Tappa Batesara 46',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc04',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Harpur Tappa Naugaon 55',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc05',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Jai Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc06',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Judavan Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc07',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Judawn Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc08',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Kalwari Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc09',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Kathinahia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc0a',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Kauwasar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc0b',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Khairatia Shitalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc0c',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Khajuri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc0d',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Khanu Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc0e',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Kheman Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc0f',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Kohar Gaddi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc10',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Kohra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc11',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Kotwa Kalan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc12',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Kuia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc13',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Laukaria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc14',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Luxmipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc15',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Luxmipur Urf Kurmi Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc16',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Madar Bindwalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc17',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Mahuawa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc18',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Mansha Chhapra 48',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc19',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Mansha Chhapra 52',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc1a',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Mathia Alam',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc1b',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Mathia Dheer',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc1c',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Mathiya Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc1d',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Moti Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc1e',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Mundera',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc1f',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Narainpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc20',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Naurangia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc21',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Nebua Rai Ganj',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc22',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Newaz Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc23',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Pach Phera',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc24',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Padri Mehdia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc25',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Paharpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc26',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Pakaripar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc27',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Palat Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc28',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Pande Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc29',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Parsia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc2a',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Parsu Rampur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc2b',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Piparpati',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc2c',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Pipra Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc2d',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Pipra Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc2e',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Piprawar Siwan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc2f',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Pipria Narhar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc30',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Raipur Banjari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc31',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Raipur Bhaisahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc32',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Raipur Khopa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc33',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Raipur Phulwari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc34',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Rajman Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc35',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Rampur Bhat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc36',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Rampur Khas',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc37',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Rampur Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc38',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sadi Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc39',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sagar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc3a',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sagar Gosai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc3b',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sarang Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc3c',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sargatia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc3d',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Saurha Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc3e',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Saurha Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc3f',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sehui Khas',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc40',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sekhui',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc41',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sekhui Kaf',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc42',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Semra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc43',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Shesha Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc44',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Shobha Chhapra 51',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc45',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Shobha Chhapra 67',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc46',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sigha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc47',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sirsia Bir Bhan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc48',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sirsia Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc49',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sirsia Kalan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc4a',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sirsia Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc4b',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sirsia Sagar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc4c',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Siswa Prithvi Shahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc4d',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Siswa Urf Siswania',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc4e',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sita Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc4f',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sukhari Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc50',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Sukh Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc51',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Terhi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc52',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Vijaipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc53',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Vishunpur Vijaipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc54',
    },
    district: 'Kushinagar',
    block: 'Nebua Naurangia',
    village: 'Parsauni Janubi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc55',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Ahiraule',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc56',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Amahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc57',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Amwadiger',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc58',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Amwa Khas',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc59',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Arazi Bundel Giri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc5a',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Asokawa Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc5b',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Asokawa Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc5c',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Babhanauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc5d',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Badahara Brit',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc5e',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Badahara Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc5f',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Badahara Dubey',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc60',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Badahara Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc61',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Baikunthpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc62',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Bangara Ram Bux Rai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc63',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Bans Gaon',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc64',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Barampur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc65',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Barawa Mishrauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc66',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Baria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc67',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Batarauli Dhur Khandwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc68',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Beni Bhar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc69',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Bhual Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc6a',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Bichpatwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc6b',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Bijaipur Dakhin Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc6c',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Bijaipur Uttar Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc6d',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Bishunpur Baria Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc6e',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Chaf',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc6f',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Chaubia Patkhauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc70',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Chir Kutaha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc71',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Dasahwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc72',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Dharampur Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc73',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Dhokaraha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc74',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Doihara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc75',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Dudhi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc76',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Dumahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc77',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Ganesh Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc78',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Gangalwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc79',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Gauri Jagdish',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc7a',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Gauri Shri Ram',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc7b',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Gauri Sukul',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc7c',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Godaria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc7d',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Govind Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc7e',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Gurwalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc7f',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Jangle Bishunpura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc80',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Jangle Lala Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc81',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Jungle Ghorath',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc82',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Jungle Luathaha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc83',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Jungle Naugawan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc84',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Jungle Siswa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc85',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Kataura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc86',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Khiriya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc87',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Kirat Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc88',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Kokil Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc89',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Korya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc8a',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Kuber Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc8b',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Lohar Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc8c',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Machhariha Basant Bharati',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc8d',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Machhariha Daljit Kunwar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc8e',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Maheshpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc8f',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Manjharia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc90',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Mathia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc91',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Mathia Bhakariya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc92',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Mathia Kartar Giri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc93',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Mathiamafi Urf Dukhi Ganeshpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc94',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Mishrauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc95',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Narhawa Dih',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc96',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Narhawa Urf Maila',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc97',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Narhwa Achraj Dubey',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc98',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Padaraha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc99',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Padraun Madurahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc9a',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Pandey Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc9b',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Parvat Chhapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc9c',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Pirathipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc9d',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Rakaba Dulama Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc9e',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Ramnagar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabc9f',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Rampur Barahan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabca0',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Rampur Jamunia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabca1',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Rampur Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabca2',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Saragatia Karan Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabca3',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Sariswa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabca4',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Shahpur Mafi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabca5',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Shahpur Uchaki Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabca6',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Shankarpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabca7',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Shapur Khalwa Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabca8',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Sikatia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabca9',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Sorahwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcaa',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Sukulahe',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcab',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Thari Bhar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcac',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Tilak Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcad',
    },
    district: 'Kushinagar',
    block: 'Dudhahi',
    village: 'Tiwari Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcae',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Alawalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcaf',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Alawatpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcb0',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Amwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcb1',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Balwa Afgan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcb2',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Bankata Tiwari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcb3',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Bans Ghati',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcb4',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Bhairopur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcb5',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Chakur Fakir',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcb6',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Chawaria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcb7',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Chhitrouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcb8',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Chuhia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcb9',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Demura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcba',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Dharam Khor Babu',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcbb',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Dharmkhor Dube',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcbc',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Dulha Chhapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcbd',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Ghati Khas',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcbe',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Gopalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcbf',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Imilia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcc0',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Jigni',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcc1',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Khairat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcc2',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Khiria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcc3',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Khudhan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcc4',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Kurmouta Dhuri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcc5',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Lal Chak',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcc6',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Laxmipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcc7',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Math Danur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcc8',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Mayapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcc9',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Meharour',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcca',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Motipur Bhual',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabccb',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Motipur Tikait',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabccc',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Padouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabccd',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Pipra Bithal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcce',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Raibari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabccf',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Ranighat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcd0',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Singhpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcd1',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Achaula',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcd2',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Ahirouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcd3',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Akliha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcd4',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Amawa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcd5',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Babhani',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcd6',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Banjaria Pandey',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcd7',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Banjarias Shukla',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcd8',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Bankata Diksit',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcd9',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Bankata Shiv',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcda',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Bardiha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcdb',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Barthi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcdc',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Basdev Chak',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcdd',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Behra Daber',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcde',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Belwa Babu',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcdf',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Bhagawan Chhapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabce0',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Bharhe Choura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabce1',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Bhatni Khas',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabce2',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Birsinghpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabce3',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Bishunpura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabce4',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Chakara Tiwari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabce5',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Chandouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabce6',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Chhapia Jaidev',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabce7',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Danur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabce8',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Deoria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabce9',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Devghat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcea',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Dhanouti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabceb',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Doomri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcec',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Ekdanga',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabced',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Fatehpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcee',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Gaonria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcef',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Hatwa Nakahni',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcf0',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Jigna Mishra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcf1',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Jigni Diksit',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcf2',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Jiraso',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcf3',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Kaithouli Urf Bhatouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcf4',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Khajuri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcf5',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Khajuri Karouta',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcf6',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Khori Bari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcf7',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Kurmouta',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcf8',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Maghhagawan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcf9',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Magraich',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcfa',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Mahurao',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcfb',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Mamatouli Kalan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcfc',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Mamatouli Khurd',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcfd',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Matha Kesavram',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcfe',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Mishrouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabcff',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Mishrouli Diksit',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd00',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Nonapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd01',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Noonkhar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd02',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Parasia Karakathi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd03',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Parsouni',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd04',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Pawanar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd05',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Pipara Devraj',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd06',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Pipra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd07',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Pipra Diksit',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd08',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Pipra Shukla',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd09',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Poutwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd0a',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Purnac Chhapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd0b',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Rampur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd0c',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Rupai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd0d',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Sahopar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd0e',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Sakrapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd0f',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Salhapur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd10',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Sathiyaon',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd11',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Savreji',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd12',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Shiv Datt Chhapia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd13',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Shivrajpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd14',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Singhi Dih',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd15',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Singhi Jamin',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd16',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Sisai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd17',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Siswan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd18',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Surjipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd19',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Teghara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd1a',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Tenua',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd1b',
    },
    district: 'Deoria',
    block: 'Bhatni',
    village: 'Uska',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd1c',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Amari Chak',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd1d',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Babhanouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd1e',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Bankata Amethia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd1f',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Chanuki',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd20',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Damodra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd21',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Distouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd22',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Holaipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd23',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Karmua',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd24',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Katoura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd25',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Kharidih',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd26',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Kharwania',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd27',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Mahaichpar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd28',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Mahuja',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd29',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Manjharia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd2a',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Matha Damodar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd2b',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Tal Dona',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd2c',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Uska',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd2d',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Ajana',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd2e',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Amouna',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd2f',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Baba Hardo',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd30',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Babhanuli Pandey',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd31',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Babhnouli Babu',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd32',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Bagapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd33',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Baldev Chhapara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd34',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Balwa Gouri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd35',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Barari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd36',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Bardiha Prasuram',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd37',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Barouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd38',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Bawanpali Basdev',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd39',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Bawan Pali Gosai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd3a',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Bhaisahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd3b',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Bhaskari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd3c',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Bhewali',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd3d',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Bhikham Chhapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd3e',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Bhrigusari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd3f',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Birni',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd40',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Bourdih',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd41',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Buha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd42',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Chamukha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd43',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Chatia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd44',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Chordiha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd45',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Chourha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd46',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Churia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd47',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Daini',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd48',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Dhadhwar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd49',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Dhamouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd4a',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Dhan Gara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd4b',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Dhangari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd4c',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Dogari Misra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd4d',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Douari Rajamal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd4e',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Dubouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd4f',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Dumari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd50',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Gahodilla',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd51',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Garhwa Khas',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd52',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Ghorahat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd53',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Goura Pandey',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd54',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Harkhouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd55',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Hata',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd56',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Hingahupur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd57',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Itahua Misra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd58',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Itahu Hajam',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd59',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Jamasara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd5a',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Jamuna',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd5b',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Jogia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd5c',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Kakarouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd5d',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Karcho',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd5e',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Karjaha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd5f',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Kausar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd60',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Kharadaha Nilkanth',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd61',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Kharaka Narsingh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd62',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Khardha Ghansyam',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd63',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Kharkatula',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd64',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Khemadei',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd65',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Kishunpura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd66',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Kohara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd67',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Kuichwar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd68',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Kundouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd69',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Loharapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd6a',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Madhopur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd6b',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Maghara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd6c',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Mahal Garhwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd6d',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Mahal Manjharia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd6e',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Mahal Parasi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd6f',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Maheshpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd70',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Majhawalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd71',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Majha Walia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd72',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Majirio',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd73',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Mal Dharhara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd74',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Manakpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd75',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Math Amouna',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd76',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Mathia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd77',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Mathila Hil',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd78',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Mathila Majhawalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd79',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Mathila Upadhyay',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd7a',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Matiara Jagadish',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd7b',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Meharouna',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd7c',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Mugarouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd7d',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Mundera',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd7e',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Murar Bari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd7f',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Nadouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd80',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Nagawa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd81',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Naini',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd82',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Nema',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd83',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Nema Narayan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd84',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Pachdeura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd85',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Padri Gajarat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd86',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Pahelia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd87',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Paikouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd88',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Pakhaoli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd89',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Palia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd8a',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Parasia Chak Lal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd8b',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Patna',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd8c',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Patneji',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd8d',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Phariyav Dih',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd8e',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Pindi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd8f',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Raksa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd90',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Ram Nagar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd91',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Ratanpura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd92',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Rautpar Amethia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd93',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Rautpar Ghat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd94',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Rautpar Pandey',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd95',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Rautpar Raghen',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd96',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Ropan Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd97',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Ruchapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd98',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Sahia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd99',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Sahjour',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd9a',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Sajaw',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd9b',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Sakarapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd9c',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Sakhouli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd9d',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Samaha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd9e',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Sarakara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabd9f',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Satotar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabda0',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Sutawar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabda1',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Takia Dharhi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabda2',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Tandawa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabda3',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Tenua',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabda4',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Thakur Gouri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabda5',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Thara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabda6',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Thuri',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabda7',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Ukina Hardo',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabda8',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Ukina Kalawat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabda9',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Ukina Khas',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdaa',
    },
    district: 'Deoria',
    block: 'Lar',
    village: 'Usaraha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdab',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Ahirauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdac',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Alkhi Chhapra Urf Laxamipur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdad',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Amawan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdae',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Assitola Urf Mainpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdaf',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Balpur Shrinagar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdb0',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Banraha Narhar Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdb1',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Bansh Bharia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdb2',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Barthahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdb3',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Barwa Semra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdb4',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Basantpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdb5',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Belhi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdb6',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Bhainsaha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdb7',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Bharauta',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdb8',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Bishunpur Bhupati',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdb9',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Bishunpur Dalpat',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdba',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Chhabauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdbb',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Deurwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdbc',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Dwarika',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdbd',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Gopalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdbe',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Haraia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdbf',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Harpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdc0',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Harpur Nijam',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdc1',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Jaluwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdc2',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Jamuni',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdc3',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Kaithawalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdc4',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Kamdhenwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdc5',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Kanakpura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdc6',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Kanchanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdc7',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Khagi Tola',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdc8',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Konhawalia Baburai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdc9',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Konhawalia Bharthrai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdca',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Konhwalia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdcb',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Kotwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdcc',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Mahuaari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdcd',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Mahuapatan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdce',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Mahuawa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdcf',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Mahuawan Bajaratar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdd0',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Mandaria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdd1',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Markandey',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdd2',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Mathia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdd3',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Mathia Mahabal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdd4',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Mathia Rati',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdd5',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Mathura Chhapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdd6',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Mogalpura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdd7',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Mundera',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdd8',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Mushari',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdd9',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Narayanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdda',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Pachrokhia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabddb',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Padauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabddc',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Paharpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabddd',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Pakari Chhapar Patkhauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdde',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Paras Khand',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabddf',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Parsauni',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabde0',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Patakhauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabde1',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Piprahia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabde2',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Rampur Jagdishpur Urf Brindaba',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabde3',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Rampur Khas',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabde4',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Ratanpura',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabde5',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Saraini Khas',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabde6',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Sirsia Gotha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabde7',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Sirsia Patti Husen Urf Basantp',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabde8',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Sirwania',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabde9',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Siswan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdea',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Sohanria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdeb',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Sonhula Ramnagar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdec',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Subans Chhapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabded',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Tarkulwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdee',
    },
    district: 'Deoria',
    block: 'Tarkalua',
    village: 'Tawkalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdef',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Aktahia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdf0',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Amari Jhanga',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdf1',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Awarhi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdf2',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Baijanathpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdf3',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Balkuon',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdf4',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Balua',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdf5',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Barwa Mansingh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdf6',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Barwamir Chhapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdf7',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Basantpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdf8',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Belwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdf9',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Bharth Patti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdfa',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Bhatani Dadan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdfb',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Bhatni Buzurg',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdfc',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Bhikham Chhapra',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdfd',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Bhujauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdfe',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Chakia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabdff',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Deoria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe00',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Deoria (nakchhed)',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe01',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Deshi Deoria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe02',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Dhamur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe03',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Dhanauti Rajdiha',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe04',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Dighwapautwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe05',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Dubauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe06',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Dumari Ekhlakh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe07',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Gaunaria',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe08',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Gopalpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe09',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Gotha Rasulpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe0a',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Haraia Basantpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe0b',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Haraiya',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe0c',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Hariapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe0d',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Harkhauli Mafi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe0e',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Hetimpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe0f',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Imiliha Urf Bhagwanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe10',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Jaisauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe11',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Jigani',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe12',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Jigani Musahib Khan',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe13',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Jiganiraja',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe14',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Junglebelwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe15',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Kaula Chhapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe16',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Kotwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe17',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Madapa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe18',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Madrapali Bharthrai',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe19',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Mahui',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe1a',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Mahwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe1b',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Math Bhagwam',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe1c',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Mundera',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe1d',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Mundera Chand',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe1e',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Mundera Urf Baluahi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe1f',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Munedra Urf Devrawa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe20',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Nautan Hathiagarh',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe21',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Nibi Barwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe22',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Ojhauli',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe23',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Padiapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe24',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Pakri Birbhard',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe25',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Papaur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe26',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Pauhari Chhapar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe27',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Phoolehara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe28',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Piparahia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe29',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Pipra Daulakadam',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe2a',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Pipra Madangopal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe2b',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Piprua',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe2c',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Puraini',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe2d',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Rampur Dullah',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe2e',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Rampur Hiraman',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe2f',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Rampur Shripal',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe30',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Sahodarpatti',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe31',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Sahwa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe32',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Samogar',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe33',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Semara',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe34',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Shahjahanpur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe35',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Shampur',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe36',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Sirsia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe37',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Sonadi',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe38',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Sonbarsa',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe39',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Sonia',
  },
  {
    _id: {
      $oid: '68b5f801183a8c2bd3aabe3a',
    },
    district: 'Deoria',
    block: 'Desai Deoria',
    village: 'Tilatari',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe40' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Balliputtuga',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe41' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Bejjiputtuga',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe42' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Belagam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe43' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Bhyripuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe44' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Borivanka',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe45' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Chandiputtuga',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe46' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Deppili Gonapaputtuga',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe47' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Jagathi',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe48' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Kapasakuddi',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe49' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Karapadu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe4a' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Kaviti',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe4b' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Kojjiria',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe4c' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Kusumpuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe4d' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Manikyapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe4e' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Nelavanka',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe4f' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Putiyadala',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe50' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Raghunadhapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe51' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Rajapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe52' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Silagam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe53' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Varakha',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe54' },
    district: 'Srikakulam',
    block: 'Kaviti',
    village: 'Vinjagiri',
  },

  {
    _id: { $oid: '68b5f801183a8c2bd3aabe60' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Akkupalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe61' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Amalapadu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe62' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Ananthagiri',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe63' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Bathupuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe64' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Battupadu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe65' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Bendi',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe66' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Bypalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe67' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Cheepurupalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe68' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Cheepurupalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe69' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Chinavanka',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6a' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Dabbalapadu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6b' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Devunaltada',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6c' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Dokulapadu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6d' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Gadivuru',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6e' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Garudabhadra',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6f' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Gollalapadu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe70' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Gollasaradhi',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe71' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Gopaladoravuru',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe72' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Govindapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe73' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Gunalapadu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe74' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Kidisingi',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe75' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Kollipadu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe76' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Komarlatada',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe77' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Kondavooru',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe78' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Laxmidevipeta @ Nuvvalarevu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe79' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Lingalapadu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe7a' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Mahadevipuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe7b' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Metturu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe7c' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Miliaputti',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe7d' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Nagarampalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe7e' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Narayanapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe7f' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Pallisaradhi',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe80' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Pallivuru @ Sangaruvanipeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe81' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Pathatekkali',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe82' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Pedavanka',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe83' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Peddabadam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe84' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Peddaboddapadu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe85' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Peddamuraharipuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe86' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Pedijagannadhapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe87' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Pollada',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe88' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Rajam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe89' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Reyyipadu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe8a' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Rittapadu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe8b' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Saradapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe8c' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Seethapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe8d' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Sunkara Jaganadhapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe8e' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Suryamanipuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe8f' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Synooru',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe90' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Terapalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe91' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Thadivada',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe92' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Thotapalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe93' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Uddanam Gopinadhapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe94' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Uddanamkurmanadhapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe95' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Uddanam Narsingapalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe96' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Uddanamraipadu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe97' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Uddanam Ramakrishnapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe98' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Undrukudia',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe99' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Vajrapukothuru',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe9a' },
    district: 'Srikakulam',
    block: 'Vajrapukotturu',
    village: 'Venkatapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe3b' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Annavaram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe3c' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Bapiraju Kothapalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe3d' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Bodapalem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe3e' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Chinaboddepalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe3f' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Chowduvada',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe40' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Gottivada',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe41' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'G.Sanyasirajupalem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe42' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Jalluru',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe43' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Kailasapatnam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe44' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Kodavatipudi',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe45' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Kotauratla',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe46' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Krishnambhotla Agraharam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe47' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Lingapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe48' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Pamulavaka',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe49' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Panduru',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe4a' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Pippalla Kothapalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe4b' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Rajupeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe4c' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Ramannapalem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe4d' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Sunkapuru',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe4e' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Tadaparthi Jangampeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe4f' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Thangedu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe50' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Yendapalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe51' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Adivikamayya Agraharam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe52' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Anantha Padmanabhapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe53' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Buradapalle Agraharam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe54' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Chammachinta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe55' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Cherlopalem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe56' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'China Jaggampeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe57' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Chollangipalem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe58' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Dharmavaram Agraharam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe59' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Donkada Agraharam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe5a' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Gannavaram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe5b' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Golugondapeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe5c' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Gummidigonda',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe5d' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Gunupudi',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe5e' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Kalavavoddu Sarabhavaram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe5f' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Kesavaram Agraharam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe60' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Kodavatipudi Agraharam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe61' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Krishnapura Agraharam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe62' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Kuruvada',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe63' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Mallubhupala Patnam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe64' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Manyapuratla',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe65' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Mulagapudi Bennavaram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe66' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Nathavaram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe67' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Pedabhairavabhoopati Agraharam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe68' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Pedajaggampeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe69' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Pichchiganti Kothagudam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6a' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Pottinagannadora Palem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6b' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Rajupeta Agraharam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6c' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Ramachandraraju Agraharam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6d' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Sarabhoopala Patnam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6e' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Sarabhoopati Agraharam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6f' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Sarugudu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe70' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Srungavaram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe71' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Valasampeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe72' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Vedurupalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe73' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Veerabhupati Agraharam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe74' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Vootamalla',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe75' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Yellavaram Dondapeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe76' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Yerakabhoopati Agraharam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe77' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Yerakampeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe78' },
    district: 'Anakapalli',
    block: 'Nathavaram',
    village: 'Zilledipudi',
  },

  {
    _id: { $oid: '68b5f801183a8c2bd3aabe01' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Annavaram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe02' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Bapiraju Kothapalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe03' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Bodapalem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe04' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Chinaboddepalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe05' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Chowduvada',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe06' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Gottivada',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe07' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'G.Sanyasirajupalem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe08' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Jalluru',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe09' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Kailasapatnam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe0a' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Kodavatipudi',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe0b' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Kotauratla',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe0c' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Krishnambhotla Agraharam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe0d' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Lingapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe0e' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Pamulavaka',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe0f' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Panduru',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe10' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Pippalla Kothapalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe11' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Rajupeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe12' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Ramannapalem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe13' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Sunkapuru',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe14' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Tadaparthi Jangampeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe15' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Thangedu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe16' },
    district: 'Anakapalli',
    block: 'Kotauratla',
    village: 'Yendapalle',
  },

  {
    _id: { $oid: '68b5f801183a8c2bd3aabe5a' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Ambootia Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe5b' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Balasan Forest',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe5c' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Baman Dhura Forest',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe5d' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Bamonpokhari Forest',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe5e' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Bara Shibkhola Forest',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe5f' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Barasit Tong Khasmahal',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe60' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Cart Road (ct)',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe61' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Castleton Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe62' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Chaita Pani Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe63' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Champasari Forest',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe64' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Chattakpur Forest',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe65' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Chhota Adalpur',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe66' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Choklong Forest',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe67' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Dayal Thong(d.r.)tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe68' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Edenvale Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe69' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Garidhora (m.bari)tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6a' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Gayabari Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6b' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Gidda Pahar',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6c' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Gitingy Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6d' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Goethals',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6e' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Gola Forest',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe6f' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Jamadar Bhita Khasmahal',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe70' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Jungpana Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe71' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Kanyan',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe72' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Karbia Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe73' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Kharia Busty',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe74' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Lama Gumba Forest',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe75' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Latpanechar Forest',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe76' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Lizziepur Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe77' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Longview Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe78' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Lonku Khasmahal',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe79' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Lower Mamring Khasmahal',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe7a' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Mahal Diram Forest',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe7b' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Mahal Diram Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe7c' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Mahanadi Forest',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe7d' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Mahanadi Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe7e' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Maharani Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe7f' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Majua Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe80' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Makai Bari Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe81' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Malotar Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe82' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Montiviot Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe83' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'North Shibkhola Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe84' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Nurbang Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe85' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Paharu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe86' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Pairikumari',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe87' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Punkhabari',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe88' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Raki Forest',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe89' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Rohini Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe8a' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Rolak Khasmahal',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe8b' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Saptiguri Khelaghar Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe8c' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Selim Hill Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe8d' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Selpu Khasmahal',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe8e' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Sepoy Dhora(d.r.)tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe8f' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Sepoy Dhura Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe90' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Shalbari Chhat Dwitiya Khanda',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe91' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Shibkhola Forest (paglajhora)',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe92' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Simring Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe93' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Simulbari Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe94' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Singel Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe95' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Sittong Forest',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe96' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Sittong Khasmahal',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe97' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'South Shibkhola Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe98' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Spring Sidi Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe99' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'St.marys',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe9a' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Sukna',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe9b' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Sukna Forest',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe9c' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Sukna Pratham Khanda',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe9d' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Tindharia Tea Garden',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe9e' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Toryak Khasmahal',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabe9f' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Upper Mamring Khasmahal',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabea0' },
    district: 'Darjeeling',
    block: 'Kurseong',
    village: 'Mangpu Cinchona Plantation',
  },

  {
    _id: { $oid: '68b5f801183a8c2bd3aabea1' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Agency Laxmipuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabea2' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Ammapeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabea3' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Cheedigummala',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabea4' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Cheedikada',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabea5' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Chodyam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabea6' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Darapalem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabea7' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Gadampalem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabea8' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Golugonda',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabea9' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Gopalapatnam',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabeaa' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Gundupala',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabeab' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Jammadevipeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabeac' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Jammavaram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabead' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Karaka',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabeae' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Kasimi',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabeaf' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Komira',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabeb0' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Konkasingi',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabeb1' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Kothamallempeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabeb2' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Kothapalem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabeb3' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Kotha Yellavaram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabeb4' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Krishnadevipeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabeb5' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Kumarapuram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabeb6' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Lingamdora Palem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabeb7' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Mungerlapalem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabeb8' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Nagannadorapalem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabeb9' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Nallanki',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabeba' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Pakalapadu',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabebb' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Pallapu Nagannadora Palem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabebc' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Pappusettipalem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabebd' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Pathamallempeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabebe' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Pogachetlapalem',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabebf' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Polavaram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabec0' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Seethakandi',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabec1' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Thallacheedikada',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabec2' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Vadaparthi',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabec3' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Yarakampeta',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabec4' },
    district: 'Anakapalli',
    block: 'Golugonda',
    village: 'Yarravaram',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabec5' },
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Chintapalle',
  },
  {
    _id: { $oid: '68b5f801183a8c2bd3aabec6' },
    district: 'Alluri Sitharama Raju',
    block: 'Chintapalle',
    village: 'Paderu',
  },
];

export default villages;
export { villages };
